import React, { createContext, useEffect } from 'react';
import ReactDOM from 'react-dom';

import { useHistory } from 'react-router';
import { ReactComponent as CloseIcon } from 'assets/img/close.svg'
import { ReactComponent as LeftIcon } from 'components/PageBuilder/PageBuilderTopBar/icons/back.svg'
import styles from './workflow-creation2.module.scss'
import AppSelect from 'elements/appSelect';
import DeleteConfirmation from 'containers/channels/collections/deleteConfirmation';
import WorkflowEditSideBar from '../WorkflowEditSideBar/WorkflowEditSideBar';
import { AdminMessagingService } from 'api/services/admin-messaging/AdminMessagingService';
import { ReactComponent as AddIcon } from 'assets/img/plus-add.svg'
import { ReactComponent as ArrowDownIcon } from 'assets/img/arrow-down.svg'
import { ReactComponent as ArrowUpIcon } from 'assets/img/arrow-up.svg'

import { toast } from 'react-toastify';

import { CourseService } from 'api/services/course';
import PageBuilderService from 'api/services/page-builder';
import { SegmentService } from 'api/services/segment';
import { LibraryService } from 'api/services/library';
import { GroupService } from 'api/services/groups';
import EventsSelector from 'components/Events/EventsSelector';
import { ChannelService } from 'api/services/channels';
import { ReactComponent as DangerIcon } from 'assets/img/danger.svg';
import Dropdown from 'elements/dropdown';
import InputEntryDialog from 'components/InputEntryDialog';
import PostableDraft from 'components/post/PostableDraft';
import RenamePopup from './RenamePopup/RenamePopup';
import ChannelSelector from 'components/channel/channelSelector';
import WorkflowDataSelector from '../WorkflowDataSelector/WorkflowDataSelector';
import ContentDataSelector from '../ContentDataSelector/ContentDataSelector';
import miscUtils from 'utils/miscUtils';
import { TeamService } from 'api/services/teams';
import TeammateSelector from '../TeammateSelector/TeammateSelector';
import CustomUserComponent from 'components/CustomUserComponent/CustomUserComponent';
import { TagsFields } from './TagsFields';
import { choiceBottomPopupAtom, choiceTopPopupAtom, communityBillingPlansPopupAtom, renameTemplatePopupAtom } from 'showMessageMenuAtom';
import { useAtom } from 'jotai';
import { ReactComponent as MaximizeIcon } from 'components/post/PostableEditor/icons/maximize.svg';
import { ReactComponent as MinimizeIcon } from 'components/post/PostableEditor/icons/minimize.svg';
import { ReactComponent as TippyIcon } from 'containers/CoursesContainer/SectionsList/SectionItem/SectionItemContent/AdminCourseLesson/symbol-info.svg';
import SelectionDropDown from 'components/SelectionDropdown';
import TemplateNamePopup from 'components/TemplateNamePopup/TemplateNamePopup';
import ChoicePopup from './ChoicePopup/ChoicePopup';
import RuleEditor from './RuleEditor/RuleEditor';
import BottomChoicePopup from './BottomChoicePopup/BottomChoicePopup';
import ReactModal from 'react-modal';
import FlexyPopOnMe from 'elements/flexypoponme';
import { ReactComponent as MenuIcon } from 'assets/img/brackets.svg'
import KitInputTypes from './KitFieldsType/KitInputTypes';
import ResourceTagList from './ResourceTagList/ResourceTagList';

export const WorkflowCreationContext = createContext<any>({});


const WorkflowCreation2 = ({ group }: { group: any }) => {
    const history = useHistory()
    const hideDropdownRef = React.useRef<any>(null);
    const hideDropdownResourceRef = React.useRef<any>(null);

    const searchParams = new URLSearchParams(window.location.search);
    const pageNumber = Number(searchParams.get('page'));

    // get workflow id from url
    const pathSegments = window.location.pathname.split('/');
    const workflowId = pathSegments[pathSegments.indexOf('workflows') + 1];

    const generateRandomId = () => {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }

    const [workflowEvent, setWorkflowEvent] = React.useState<any>({ active: true });
    const eventOptions = (workflowEvent && workflowEvent.options) || (workflowEvent && workflowEvent.event_resource_details && workflowEvent.event_resource_details.options) || {};

    const fieldKey: any = Object.keys(eventOptions).find(
        key => key === 'mapping_fields' || key === 'community_fields'
    );

    const workflowEventResourceTitle = (workflowEvent && workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_title) || '';

    const [inputValuefieldKeys, setInputValuefieldKeys] = React.useState<any>(() => {
        return {
            key: `${workflowEvent && workflowEvent.resource_name}: ${workflowEventResourceTitle}`,
            data: fieldKey && eventOptions && eventOptions[fieldKey]
                ? eventOptions[fieldKey].map((item: any) => ({
                    label: item.label,
                    value: item.label,
                    ...item
                }))
                : []
        }
    });
    React.useEffect(() => {
        if (fieldKey && eventOptions && eventOptions[fieldKey]) {
            const newOptionsGroup = {
                key: `${workflowEvent && workflowEvent.resource_name}: ${workflowEventResourceTitle}`,
                data: fieldKey && eventOptions && eventOptions[fieldKey]
                    ? eventOptions[fieldKey].map((item: any) => ({
                        label: item.label,
                        value: item.label,
                        ...item
                    }))
                    : []
            };
            setInputValuefieldKeys(newOptionsGroup);
        }
        if (workflowEvent && !workflowEvent.event_resource_details) {
            setInputValuefieldKeys({
                key: null,
                data: []
            })
        }
    }, [workflowEvent && workflowEvent.event_resource_details])

    const [eventResourceString, setEventResourceString] = React.useState<string>('');
    const [eventString, setEventString] = React.useState<string>('');
    const [actionTypeString, setActionTypeString] = React.useState<string>('');

    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = React.useState<boolean>(false);
    const [workflowEventType, setWorkflowEventType] = React.useState<any>([{ data: [] }]);
    const [isEditingWorkflow, setIsEditingWorkflow] = React.useState<boolean>(false);
    const [workflowActionType, setWorkflowActionType] = React.useState<any>([]);
    const [workflowData, setWorkflowData] = React.useState<any>(null);
    const [closeSideBarOnMobile, setCloseSideBarOnMobile] = React.useState<boolean>(true);
    const [workflowTitle, setWorkflowTitle] = React.useState<any>(workflowData && workflowData.title);

    // temporary hold course content and landing page data
    const [landingPageEventData, setLandingPageEventData] = React.useState<any>(null);
    const [landingPageString, setLandingPageString] = React.useState<string>("");

    // temporary hold external data
    const [externalData, setExternalData] = React.useState<any>(null);

    // temporary hold lesson data 
    const [lessonData, setLessonData] = React.useState<any>(null);
    const [lessonString, setLessonString] = React.useState<string>(" ");

    // hold action data list
    const [actionList, setActionList] = React.useState<any>([])

    const [isRenameModalOpen, setIsRenameModalOpen] = React.useState<boolean>(false);
    // community billing plans pop up
    const [, setCommunityBillingPlansPopup] = useAtom(communityBillingPlansPopupAtom) as any;

    // rename pop up
    const [isRenameTemplateOpen, setIsRenameTemplateOpen] = useAtom(renameTemplatePopupAtom);

    // webhook pop up
    const [iSWebHookStatus, setiSWebHookStatus] = React.useState<boolean>(false);
    const [webhookTestResults, setWebhookTestResults] = React.useState<any>(undefined);

    // handle integrations
    const [integrations, setIntegrations] = React.useState<any>([]);

    function updateConfigOptionsData(configData: any) {
        const weventT = workflowEventType.flatMap((item: any) => item.data);

        // Check if there are any matching slugs at all
        const hasAnyMatch = configData.some((dateItem: any) =>
            weventT.some((eventItem: any) => eventItem.slug === dateItem.slug)
        );

        // If no matches found at all, return original data unchanged
        if (!hasAnyMatch) {
            return configData;
        }

        // Otherwise proceed with the mapping
        return configData.map((dateItem: any) => {
            const matchingEvent = weventT.find((eventItem: any) => eventItem.slug === dateItem.slug);

            if (!matchingEvent) {
                return dateItem;
            }

            const dateItemOptions = dateItem.event_resource_details && dateItem.event_resource_details.options || {};

            if (JSON.stringify(matchingEvent.options) !== JSON.stringify(dateItemOptions)) {
                return {
                    ...dateItem,
                    event_resource_details: {
                        ...dateItem.event_resource_details,
                        options: matchingEvent.options
                    }
                };
            }

            return dateItem;
        });
    }

    useEffect(() => {
        setWorkflowTitle(workflowData && workflowData.title)
        if (workflowData && workflowData.events_config) {
            const updatedData = updateConfigOptionsData(workflowData.events_config);
            setWorkflowEvent(updatedData[0])
        }
        if (workflowData && workflowData.actions_config) {
            setActionList(workflowData.actions_config)
        }
    }, [workflowData, workflowEventType])

    useEffect(() => {
        if (group && workflowId) {
            fetchWorkflow();
        }
    }, [group, window.location.pathname, workflowId])

    useEffect(() => {
        if (group) {
            fetchWorkflowEvents();
            fetchEventsActions();
        }
    }, [group])

    useEffect(() => {
        if (workflowEvent && workflowEvent.event_resource_details && workflowEvent.event_resource_details.external) {
            if (workflowEvent.event_resource_details.options && workflowEvent.event_resource_details.options.search) {
                const action = workflowEvent.event_resource_details.options.search
                const data = {
                    "action": action && action.action,
                    "search_query": eventResourceString
                }

                AdminMessagingService.getInstance()
                    .fetchEventsResource(group.id, workflowEvent.third_party_application_id, data)
                    .then((response: any) => {
                        const newList = response.map((item: any) => {
                            return {
                                label: item.title,
                                value: item.title,
                                ...item
                            }
                        });
                        setExternalData(newList)
                    }).catch((error: any) => {
                        console.error(error);
                    }).finally(() => {

                    })
            }
            return
        }

        if (workflowEvent.slug === 'page_form/new_submission') {
            let query: string = ``;
            if (eventResourceString.length > 0) {
                query = `?search=${eventResourceString}`;
            }
            PageBuilderService.getInstance()
                .getCommunityLandingPages(group.id, query)
                .then((response: any) => {

                    const newList = response.data.data.map((item: any) => {
                        return {
                            label: item.title,
                            value: item.title,
                            ...item
                        }
                    });
                    setExternalData(newList)
                }).catch((error: any) => {
                    console.error(error);
                }).finally(() => { }
                )
            return
        }

        if (workflowEvent.slug === 'course/enroll') {
            LibraryService.getInstance()
                .getSpecificContent(group.id, 'course', eventResourceString)
                .then((response: any) => {
                    const newList = response.data.data.map((item: any) => {
                        return {
                            label: item.contentable.title,
                            value: item.contentable.title,
                            ...item.contentable
                        }
                    });
                    setExternalData(newList)
                })
                .catch((error: any) => {
                    console.error(error)
                    new Error(error)
                })
                .finally(() => { })
            return
        }

        if (workflowEvent.slug === 'course/completed') {
            LibraryService.getInstance()
                .getSpecificContent(group.id, 'course', eventResourceString)
                .then((response: any) => {
                    const newList = response.data.data.map((item: any) => {
                        return {
                            label: item.contentable.title,
                            value: item.contentable.title,
                            ...item.contentable
                        }
                    });
                    setExternalData(newList)
                })
                .catch((error: any) => {
                    console.error(error)
                    new Error(error)
                })
                .finally(() => { })
            return
        }

        if (workflowEvent.slug === 'library-content/accessed') {
            let query: string = ``;
            if (eventResourceString.length > 0) {
                query = `?search=${eventResourceString}`;
            }
            LibraryService.getInstance()
                .getLibraryContents(group.id, query)
                .then((response: any) => {
                    const newList = response.data.data.map((item: any) => {
                        return {
                            label: item.contentable.title,
                            value: item.contentable.title,
                            ...item
                        }
                    });
                    setExternalData(newList)
                })
                .catch((error: any) => {
                    console.error(error)
                    new Error(error)
                })
                .finally(() => { })
            return
        }

        if (workflowEvent.slug === 'segment/member_add') {
            let query: string = ``;
            if (eventResourceString.length > 0) {
                query = `?search=${eventResourceString}`;
            }
            SegmentService.getInstance()
                .getCommunitySegments(group.id, query)
                .then((response: any) => {
                    const newList = response.data.data.map((item: any) => {
                        return {
                            label: item.name,
                            value: item.name,
                            ...item
                        }
                    });
                    setExternalData(newList)
                })
                .catch((error: any) => {
                    console.error(error)
                    new Error(error)
                })
                .finally(() => { })
            return
        }

        if (workflowEvent.slug === 'segment/member_remove') {
            let query: string = ``;
            if (eventResourceString.length > 0) {
                query = `?search=${eventResourceString}`;
            }
            SegmentService.getInstance()
                .getCommunitySegments(group.id, query)
                .then((response: any) => {
                    const newList = response.data.data.map((item: any) => {
                        return {
                            label: item.name,
                            value: item.name,
                            ...item
                        }
                    });
                    setExternalData(newList)
                })
                .catch((error: any) => {
                    console.error(error)
                    new Error(error)
                })
                .finally(() => { })
            return
        }

        if (workflowEvent.slug === 'member/plan-subscription') {
            GroupService.getInstance()
                .getAdminCommunityPlans(group.id, eventResourceString)
                .then((response: any) => {
                    const newList = response.data.data.map((item: any) => {
                        return {
                            label: item.name,
                            value: item.name,
                            ...item
                        }
                    });
                    setExternalData(newList)
                })
                .catch((error: any) => {
                    console.error(error)
                    new Error(error)
                })
                .finally(() => { })
            return
        }

        if (workflowEvent.slug === 'member/cancelled-subscription') {
            GroupService.getInstance()
                .getAdminCommunityPlans(group.id, eventResourceString)
                .then((response: any) => {
                    const newList = response.data.data.map((item: any) => {
                        return {
                            label: item.name,
                            value: item.name,
                            ...item
                        }
                    });
                    setExternalData(newList)
                })
                .catch((error: any) => {
                    console.error(error)
                    new Error(error)
                })
                .finally(() => { })
            return
        }

        if (workflowEvent.slug === 'member/subscription-due') {
            GroupService.getInstance()
                .getAdminCommunityPlans(group.id, eventResourceString)
                .then((response: any) => {
                    const newList = response.data.data.map((item: any) => {
                        return {
                            label: item.name,
                            value: item.name,
                            ...item
                        }
                    });
                    setExternalData(newList)
                })
                .catch((error: any) => {
                    console.error(error)
                    new Error(error)
                })
                .finally(() => { })
            return
        }

        if (workflowEvent.slug === 'course-content/complete' || workflowEvent.slug === 'course-form/submitted') {
            LibraryService.getInstance()
                .getSpecificContent(group.id, 'course', eventResourceString)
                .then((response: any) => {
                    const newList = response.data.data.map((item: any) => {
                        return {
                            label: item.contentable.title,
                            value: item.contentable.title,
                            ...item.contentable
                        }
                    });
                    setExternalData(newList)
                })
                .catch((error: any) => {
                    console.error(error)
                    new Error(error)
                })
                .finally(() => { })
        }

    }, [workflowEvent && workflowEvent.slug, eventResourceString])

    useEffect(() => {
        if (
            workflowEvent.slug === 'page_form/new_submission' &&
            workflowEvent.event_resource_details &&
            workflowEvent.event_resource_details.parent_event_resource_id
        ) {

            PageBuilderService.getInstance()
                .getLeadables(group.id, workflowEvent.event_resource_details.parent_event_resource_id)
                .then((response: any) => {
                    const newList = response && response.data.map((item: any) => {
                        return {
                            label: item.leadable.title,
                            value: item.leadable.title,
                            ...item
                        }
                    });
                    setLandingPageEventData(newList)
                }).catch((error: any) => {
                    console.error(error);
                }).finally(() => {

                })

            return
        }

    }, [workflowEvent && workflowEvent.event_resource_details])

    useEffect(() => {
        if (workflowEvent.slug === 'course-content/complete' || workflowEvent.slug === 'course-form/submitted') {
            let query: string = ``;
            if (lessonString.length > 0) {
                query = `?search=${lessonString}`;
            }

            if (workflowEvent.event_resource_details.parent_event_resource_id) {
                CourseService.getInstance()
                    .getCourseOutlineWorkflow(group.id, workflowEvent.event_resource_details.parent_event_resource_id, query)
                    .then((response: any) => {
                        if (workflowEvent.slug === 'course-content/complete') {
                            const result = getFirstKeyValuefromLessons(response.data);
                            setLessonData(result)
                        } else {
                            const resData = response.data.reduce((acc: any[], item: any) => {
                                const filteredContents = item.contents.filter((content: any) => content.type === 'form');
                                if (filteredContents.length > 0) {
                                    acc.push({ ...item, contents: filteredContents });
                                }
                                return acc;
                            }, []);
                            const result = getFirstKeyValuefromLessons(resData);
                            setLessonData(result)
                        }
                    })
                    .catch((error: any) => {
                        console.error(error)
                        new Error(error)
                    })
                    .finally(() => { })
                return

            }

        }

    }, [workflowEvent && workflowEvent.event_resource_details, lessonString])

    useEffect(() => {
        if (workflowEvent && workflowEvent.slug === 'onboarding/field-submitted') {
            const fields = (workflowEvent.event_resource_details && workflowEvent.event_resource_details.options && workflowEvent.event_resource_details.options.community_fields) || [];

            const tempfilteredFields = fields.filter(
                (field: any) => !['full_name', 'first_name', 'last_name'].includes(field.key)
            );

            const filteredFields = !eventResourceString
                ? tempfilteredFields
                : tempfilteredFields.filter(function (item: any) {
                    return (
                        item.label &&
                        item.label.toLowerCase().includes(eventResourceString.toLowerCase())
                    );
                });

            const newList = filteredFields.map(function (item: any) {
                return {
                    value: item.label,
                    ...item
                };
            });

            setExternalData(newList);
        }
    }, [
        workflowEvent && workflowEvent.slug,
        eventResourceString,
        workflowEvent.event_resource_details
    ]);

    useEffect(() => {
        // if resource is 0 then the event_resource_title should be null to invalidate the ealier one
        if (externalData && externalData.length === 0) {
            setWorkflowEvent({
                ...workflowEvent,
                "event_resource_details": {
                    ...workflowEvent.event_resource_details,
                    'event_resource_title': null,
                    'event_resource_id': null,
                }
            });
        }

    }, [externalData && externalData.length === 0])

    function getTransformedKeyValue(data: any) {
        return data.map((item: any) => ({
            label: item.title || '',
            value: item.title || '',
            ...item
        }));
    }

    function getFirstKeyValuefromLessons(data: any) {
        return data.map((item: any) => ({
            key: item.title,
            data: getTransformedKeyValue(item.contents || [])
        }));
    }

    function getFirstKeyValue(data: any) {
        const keys = Object.keys(data);
        if (keys.length > 0) {
            return keys.map(key => ({
                key,
                data: transformData(data[key])
            }));
        }
        return [];
    }

    function transformData(data: any) {
        return data.map((item: any) => ({
            label: item.title || '',
            value: item.title || '',
            ...item
        }));
    }

    const closeAndSave = () => {
        setIsDeleteConfirmationOpen(true);
        history.push(`/settings/workflows?page=${pageNumber > 0 ? pageNumber : 1}`);
    }
    const [newPostion, setNewPostion] = React.useState<any>();
    const workflowEventID = workflowEvent && workflowEvent.workflow_event_id;
    const actionMergeTags: any[] = [];
    const [mergeTagAndresourcesUsed, setMergeTagsAndResourcesUsed] = React.useState<any>(null);

    useEffect(() => {
        if (workflowData && workflowData.extra_data && workflowData.extra_data.merge_tag_resources_used) {
            setMergeTagsAndResourcesUsed(workflowData.extra_data.merge_tag_resources_used)
        }
    }, [workflowData && workflowData.extra_data && workflowData.extra_data.merge_tag_resources_used])

    const requiredFieldsFormergeTagsUsed = ["randomID", "resource_id", "resource_name", "tag"];

    const requiredFieldsFormergeTagsUsedFn = () => {

        if (mergeTagAndresourcesUsed) {
            const filtered: any = {};

            for (const [key, items] of Object.entries(mergeTagAndresourcesUsed)) {
                if (Array.isArray(items)) {
                    const completeItems = items.filter(item =>
                        requiredFieldsFormergeTagsUsed.every((field: any) => item[field])
                    );
                    if (completeItems.length > 0) {
                        filtered[key] = completeItems;
                    }
                }
            }
            return filtered;
        } else {
            return mergeTagAndresourcesUsed;
        }
    }

    const contentpayload = {
        "title": String(workflowTitle),
        ...(workflowEvent.slug ? {
            "events_config": [
                {
                    "slug": workflowEvent.slug,
                    'active': workflowEvent.active,
                    "third_party_application_id": workflowEvent.third_party_application_id,
                    "plan_option": workflowEvent.plan_option,
                    "resource_id": (
                        workflowEvent.event_resource_details &&
                        workflowEvent.event_resource_details.event_resource_id
                    ) || null,
                    "resource_name": (
                        workflowEvent.event_resource_details &&
                        workflowEvent.event_resource_details.options &&
                        workflowEvent.event_resource_details.options.resource_name
                    ) || workflowEvent.event_resource_details && workflowEvent.event_resource_details.category,
                    'leadable_type': workflowEvent.event_resource_details &&
                        workflowEvent.event_resource_details.leadable_type,
                    "workflow_event_id": workflowEvent.workflow_event_id,
                    "integrations_data": workflowEvent.integrations_data,
                    'label': workflowEvent.label,
                    "event_resource_details": {
                        'external': (
                            workflowEvent.event_resource_details &&
                            workflowEvent.event_resource_details.external
                        ),
                        'options': (
                            workflowEvent.event_resource_details &&
                            workflowEvent.event_resource_details.options
                        ),
                        'event_resource_title': (
                            workflowEvent.event_resource_details &&
                            workflowEvent.event_resource_details.event_resource_title
                        ) || null,
                        'event_resource_id': (
                            workflowEvent.event_resource_details &&
                            workflowEvent.event_resource_details.event_resource_id
                        ) || null,
                        'third_party_application_id': (
                            workflowEvent.event_resource_details &&
                            workflowEvent.event_resource_details.third_party_application_id
                        ) || null,
                        'category': (
                            workflowEvent.event_resource_details &&
                            workflowEvent.event_resource_details.category
                        ),
                        'parent_event_resource_name': (
                            workflowEvent.event_resource_details &&
                            workflowEvent.event_resource_details.parent_event_resource_name
                        ) || null,
                        'parent_event_resource_id': (
                            workflowEvent.event_resource_details &&
                            workflowEvent.event_resource_details.parent_event_resource_id
                        ) || null,
                        'resource_deleted': (
                            workflowEvent.event_resource_details &&
                            workflowEvent.event_resource_details.resource_deleted
                        )
                    },
                }
            ]
        }
            : (
                workflowEvent.integrations_data ? {
                    "events_config": [
                        {
                            'active': workflowEvent.active,
                            "integrations_data": workflowEvent.integrations_data,
                        }
                    ],
                } : {
                    "events_config": [
                        { 'active': workflowEvent.active }
                    ]
                }
            )),
        "actions_config": actionList && actionList.length > 0 ? actionList : null,
        'extra_data': {
            'merge_tag_resources': combineMergeTagResourcesIDNames(),
            'merge_tag_resources_used': requiredFieldsFormergeTagsUsedFn(),
        }
    }

    const editWorkflow = (hideloading: boolean, payload: any) => {
        if (hideloading) {
            setIsEditingWorkflow(false);
        } else {
            setIsEditingWorkflow(true);
        }

        payload.valid = !activateBtnDisabled();

        AdminMessagingService.getInstance()
            .editWorkflow(group.id, Number(workflowId), payload)
            .then((response: any) => {
                if (hideloading) {
                    toast('Workflow title saved successfully', {
                        type: 'success',
                        autoClose: 3000,
                        position: "top-center",
                        hideProgressBar: true,
                        theme: "light"
                    });
                } else {
                    toast('Workflow saved successfully', {
                        type: 'success',
                        autoClose: 3000,
                        position: "top-center",
                        hideProgressBar: true,
                        theme: "light"
                    });

                }
                setWorkflowData(response.data);
            }).catch((error: any) => {
                setIsEditingWorkflow(false);
                console.error(error);
            }).finally(() => {
                setIsEditingWorkflow(false);
                setIsRenameModalOpen(false);
                setIsRenameTemplateOpen(false)
            })
    }

    const fetchWorkflowEvents = () => {
        AdminMessagingService.getInstance().fetchWorkflowEvents(group.id)
            .then((response: any) => {
                const result = getFirstKeyValue(response.data);
                setWorkflowEventType(result)
            }).catch((error: any) => {
                console.error(error);
            }).finally(() => {
            })
    }

    const fetchEventsActions = () => {
        AdminMessagingService.getInstance()
            .fetchEventsActions(group.id)
            .then((response: any) => {
                const result = getFirstKeyValue(response.data);
                setWorkflowActionType(result)
            }).catch((error: any) => {
                console.error(error);
            }).finally(() => {

            })
    }

    const fetchWorkflow = () => {
        AdminMessagingService.getInstance()
            .fetchAworflow(group.id, Number(workflowId))
            .then((response: any) => {
                // const result = getFirstKeyValue(response.data);
                setWorkflowData((prev: any) => ({
                    ...prev,
                    ...response.data
                }))
            }).catch((error: any) => {
                console.error(error);
            }).finally(() => {

            })
    }

    const shouldShowDangerIcon = () => {
        if (workflowEvent) {
            // Check if event_resource_details is undefined or null
            if (!workflowEvent.event_resource_details) {
                return true;
            }

            if (workflowEvent && workflowEvent.event_resource_details) {
                if (
                    [
                        "member/plan-subscription",
                        "member/cancelled-subscription",
                        "member/subscription-due",
                        "course-content/complete",
                        "course-form/submitted",
                        "page_form/new_submission",
                        "event_rsvp/create",
                        "library-content/accessed",
                        "segment/member_add",
                        "segment/member_remove",
                        "channel/new_member",
                        "channel/member_removed",
                        "course/enroll",
                        "course/completed",
                        "onboarding/field-submitted"
                    ].includes(workflowEvent.slug) || (workflowEvent.event_resource_details && workflowEvent.event_resource_details.external)
                ) {
                    // Specific logic for "member/cancelled-subscription" and "member/subscription-due"
                    if (
                        (
                            workflowEvent.slug === "member/cancelled-subscription" ||
                            workflowEvent.slug === "member/subscription-due"
                        )
                    ) {
                        if (!workflowEvent.plan_option || workflowEvent.plan_option === null) {
                            return true;
                        }
                        if (
                            workflowEvent.plan_option === 'specific subscription' &&
                            (
                                !workflowEvent.event_resource_details.event_resource_id ||
                                workflowEvent.event_resource_details.event_resource_id === null
                            )
                        ) {
                            return true;
                        }
                    }
                    // General logic for other slugs
                    else if (
                        !workflowEvent.event_resource_details.event_resource_id ||
                        workflowEvent.event_resource_details.event_resource_id === null
                    ) {
                        return true;
                    }
                }
            }
        }
        return false;

    };


    const resources: any = combineMergeTagResourcesIDNames();
    const changeDeletedStatus = (action: any) => {
        const updatedMergeTagData = { ...mergeTagAndresourcesUsed };
        const resourceName = action.executed_resource_name;
        const resourceId = action.resource_id;

        if (resourceName && resourceId) {
            const getResourceDataByKey = (key: string) => {
                const merged = mergeTagAndresourcesUsed && mergeTagAndresourcesUsed[key] || [];
                if (merged.length > 0) {
                    // Replace resource_name and resource_id in each item
                    const updatedMerged = merged.map((item: any) => ({
                        ...item,
                        resource_name: resourceName,
                        resource_id: resourceId
                    }));

                    updatedMergeTagData[action.resource_name] = updatedMerged;
                }
                return merged;
            };

            const updatedmerged = getResourceDataByKey(action.resource_name);
            if (updatedmerged && updatedmerged.length === 0) {
                return
            } else {
                setMergeTagsAndResourcesUsed(updatedMergeTagData);
            }
        }
    }

    // function findDifferenceInMergeTags() {
    //     if (!resources || !mergeTagAndresourcesUsed || Object.keys(resources).length === 0) return;

    //     const result: any = {};

    //     for (const key in mergeTagAndresourcesUsed) {
    //         if (!mergeTagAndresourcesUsed.hasOwnProperty(key)) continue;

    //         const originalItems = mergeTagAndresourcesUsed[key];

    //         // If the resource key is missing entirely
    //         if (!(key in resources)) {
    //             result[key] = originalItems
    //             .filter((item: any) => item.resource_id !== null)
    //             .map((item: any) => ({
    //                 ...item,
    //                 deleted: true
    //             }));
    //         } else {
    //             console.log('deletedMergeTags', mergeTagAndresourcesUsed)
    //             const resourceIDs = resources[key];
    //             result[key] = originalItems
    //                 .filter((item: any) => item.resource_id !== null)
    //                 .map((item: any) => {
    //                     if (!resourceIDs.includes(item.resource_id)) {
    //                         return { ...item, deleted: true };
    //                     }
    //                     return item;
    //                 });
    //         }
    //     }
    //     return result;
    // }

    // function findDifferenceInMergeTags() {
    //     if (!resources || !mergeTagAndresourcesUsed || Object.keys(resources).length === 0) return;

    //     const result: any = {};

    //     for (const key in mergeTagAndresourcesUsed) {
    //         if (!mergeTagAndresourcesUsed.hasOwnProperty(key)) continue;

    //         const originalItems = mergeTagAndresourcesUsed[key];

    //         if (!(key in resources)) {
    //             result[key] = originalItems
    //                 .filter((item: any) => item.resource_id !== null && item.randomID)
    //                 .map((item: any) => {
    //                     if (item.tag || item.randomID) {
    //                         return { ...item, deleted: true };
    //                     }
    //                     return item;
    //                 });
    //         } else {
    //             const resourceIDs = resources[key];
    //             result[key] = originalItems
    //                 .filter((item: any) => item.resource_id !== null && item.randomID)
    //                 .map((item: any) => {
    //                     if ((item.tag || item.randomID) && !resourceIDs.includes(item.resource_id)) {
    //                         return { ...item, deleted: true };
    //                     }
    //                     return item;
    //                 });
    //         }

    //     }
    //     return result;
    // }


    function findDifferenceInMergeTags() {
        if (!resources || !mergeTagAndresourcesUsed || Object.keys(resources).length === 0) return;

        const result: any = {};

        for (const key in mergeTagAndresourcesUsed) {
            if (!mergeTagAndresourcesUsed.hasOwnProperty(key)) continue;

            const originalItems = mergeTagAndresourcesUsed[key];
            let filteredItems: any[];

            if (!(key in resources)) {
                filteredItems = originalItems
                    .filter((item: any) => item.resource_id !== null && item.randomID)
                    .map((item: any) => ({ ...item, deleted: true }));
            } else {
                const resourceIDs = resources[key];
                filteredItems = originalItems
                    .filter((item: any) => item.resource_id !== null && item.randomID)
                    .map((item: any) => {
                        if (!resourceIDs.includes(item.resource_id)) {
                            return { ...item, deleted: true };
                        }
                        return item;
                    });
            }

            // ✅ Only add the key if there are items left after filtering
            if (filteredItems.length > 0) {
                result[key] = filteredItems;
            }
        }

        return result;
    }


    const deletedMergeTags = findDifferenceInMergeTags()

    function hasDeletedTags() {
        if (deletedMergeTags && Object.keys(deletedMergeTags).length > 0) {
            for (var key in deletedMergeTags) {
                if (Array.isArray(deletedMergeTags[key])) {
                    for (var i = 0; i < deletedMergeTags[key].length; i++) {
                        if (deletedMergeTags[key][i] && deletedMergeTags[key][i].deleted === true) {
                            return true;
                        }
                    }
                }
            }
            return false;
        } else {
            return false;
        }
    }

    const activateBtnDisabled = () => {
        return (
            isEditingWorkflow ||
            actionList.length === 0 ||
            shouldShowDangerIcon() ||
            (
                workflowEvent &&
                workflowEvent.event_resource_details &&
                workflowEvent.event_resource_details.resource_deleted !== undefined &&
                workflowEvent.event_resource_details.resource_deleted
            )
            ||
            (actionList.length > 0 && !actionList.some((item: any) => item.slug !== 'filter')) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.action_details && item.action_details.resource_deleted && (item.slug !== 'kit/remove_subscriber')))) ||
            (actionList.length > 0 && actionList.some((item: any) => (!item.slug))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug === null))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug === 'email') && (item.subject === null))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug === 'email') && (item.subject === undefined))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug === 'email') && (item.subject === ''))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug === 'email') && (item.message === null))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug === 'email') && (item.message === undefined))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug === 'email') && (item.message === ''))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug === 'delay') && (item.delay_in_minutes === 0))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug !== 'email') && (item.slug !== 'delay') && (item.slug !== 'member/cancel-subscription') && (item.slug !== 'filter') && (item.slug !== 'kit/remove_subscriber') && (!item.executed_resource_name))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug === 'member/cancel-subscription') && (!item.plan_option))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug === 'member/cancel-subscription') && (item.plan_option === null))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug === 'member/cancel-subscription') && (item.plan_option === 'specific subscription') && (!item.resource_id))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug === 'member/cancel-subscription') && (item.plan_option === 'specific subscription') && (!item.executed_resource_name))) ||
            (actionList.length > 0 && actionList.some((item: any) => (item.slug === 'filter') && (item.condition_groups.some((group: any) => group.rules.some((rule: any) => (rule.field === null) || (rule.condition === null))))))
            ||
            hasDeletedTags()
        )
    }

    const activateWorkflow = () => {
        if (
            group &&
            group.active_subscription &&
            group.active_subscription.plan &&
            group.active_subscription.plan.active_workflows === 0
        ) {
            setCommunityBillingPlansPopup({
                open: true,
                title: "Upgrade your plan to activate your workflow",
            });
            return
        }

        if (activateBtnDisabled()) {
            return;
        }

        AdminMessagingService.getInstance()
            .editWorkflow(group.id, Number(workflowId), contentpayload)
            .then((response: any) => {
                if (response.data) {
                    AdminMessagingService.getInstance()
                        .activateWorkflows(group.id, Number(workflowId))
                        .then((response: any) => {
                            toast('Workflow activated successfully', {
                                type: 'success',
                                autoClose: 3000,
                                position: "top-center",
                                hideProgressBar: true,
                                theme: "light"
                            });
                            setWorkflowData(response.data);

                        }).catch((error: any) => {
                            console.error(error);
                        }).finally(() => {
                        })
                }
            }).catch((error: any) => {
                console.error(error);
            }).finally(() => {
            })
    }

    const deactiveWorkflow = () => {
        AdminMessagingService.getInstance()
            .deactivateWorkflows(group.id, Number(workflowId))
            .then((response: any) => {
                toast('Workflow deactivated', {
                    type: 'success',
                    autoClose: 3000,
                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                });
                setWorkflowData(response.data);

            }).catch((error: any) => {
                console.error(error);
            }).finally(() => {
            })
    }

    // choice of workflow i.e either filter or action
    const [, setIsTopChoiceOpen] = useAtom(choiceTopPopupAtom)
    const [, setIsBottomChoiceOpen] = useAtom(choiceBottomPopupAtom)

    // Actions section
    const handleItemClick = (index: any, type?: any) => {
        setIsBottomChoiceOpen(true)
    };

    const creatNewTopAction = (type: any) => {
        let newAction: any = { randomID: generateRandomId(), active: true };

        if (type === 'filter') {
            newAction = {
                randomID: generateRandomId(),
                active: true,
                slug: type,
                // executed_resource_name: 'Filter',
                condition_groups: [
                    {
                        randomID: generateRandomId(),
                        ruleType: 'Only continue if',
                        rules: [
                            {
                                randomID: generateRandomId(),
                                "field": null,
                                "condition": null,
                                "value": ""
                            }
                        ]
                    }
                ]
            };
        }

        setActionList((prevList: any) => [newAction, ...prevList.map((action: any) => ({ ...action, active: false }))]);
        setWorkflowEvent((prev: any) => ({
            ...prev,
            active: false,
        }));
        setIsTopChoiceOpen(false)
    }

    const createNewBottomAction = (index: number, type: any) => {
        // Create a new action
        let newAction: any = { randomID: generateRandomId(), active: true };

        if (type === 'filter') {
            newAction = {
                randomID: generateRandomId(),
                active: true,
                slug: type,
                condition_groups: [
                    {
                        randomID: generateRandomId(),
                        ruleType: 'Only continue if',
                        rules: [
                            {
                                randomID: generateRandomId(),
                                "field": null,
                                "condition": null,
                                "value": ""
                            }
                        ]
                    }
                ]
            };
        }

        // Set all existing actions to inactive
        const updatedActionList = actionList.map((action: any) => ({ ...action, active: false }));

        // Determine where to insert the new action
        const position = index === actionList.length - 1 ? index + 1 : index + 1;

        // Add the new action at the determined position
        updatedActionList.splice(position, 0, newAction);
        setWorkflowEvent((prev: any) => ({
            ...prev,
            active: false,
        }));
        // Update the action list with the new action and the modified existing actions
        setActionList(updatedActionList);
        setIsBottomChoiceOpen(false)
    }

    const addAction = (addPosition: any, type?: any) => {
        if (
            group &&
            group.active_subscription &&
            group.active_subscription.plan
        ) {
            if (group.active_subscription.plan.workflow_actions === 0) {
                setCommunityBillingPlansPopup({
                    open: true,
                    title: "Upgrade your plan to create more actions",
                });
                return
            } else if (actionList.length >= group.active_subscription.plan.workflow_actions) {
                toast(`Only ${group.active_subscription.plan.workflow_actions} actions are allowed.`, {
                    type: 'error',
                    autoClose: 3000,
                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                });
                return
            }
        }

        if (workflowData.status === 'active') {
            return;
        }
        clearWorkflowEventQueries()
        if (addPosition === 'top') {
            // open choice popup
            setIsTopChoiceOpen(true)
        } else {
            handleItemClick(addPosition)
        }
    }

    const clearWorkflowEventQueries = () => {
        setEventString('')
        setEventResourceString('')
        setLessonString('')
        setLandingPageString('')
        setActionTypeString('')
    }

    const subscriptionOptions = () => {
        return [
            {
                label: `Specific subscription`,
                value: 'specific subscription',
            },
            {
                label: `All subscriptions`,
                value: 'all subscriptions',
            },
        ]
    }

    // close rename popup
    const closeRenamePopup = () => {
        history.push(`/settings/workflows`)
        setIsRenameTemplateOpen(false)
    }

    React.useEffect(() => {
        if (workflowData && workflowData.title.trim() !== "" && workflowData.title === 'untitled') {
            setIsRenameTemplateOpen(true)
        }
    }, [workflowData && workflowData.title]);

    actionList && actionList.forEach((action: any) => {
        const resourceId = action.resource_id;
        if (action.options && action.options.merge_tags && resourceId) {
            actionMergeTags.push({
                key: action.category,
                data: {
                    dataItemsName: action.action_details && action.action_details.action_resource_title,
                    dataItemsId: action.action_details && action.action_details.action_resource_id,
                    dataItems: action.options.merge_tags.map((item: any) => ({
                        ...item,
                    })),
                }
            });
        }
    });

    function getActionResourceIDName() {
        const mergeTagResources: any = {};

        actionList && actionList.forEach((action: any) => {
            if (action.options && action.options.merge_tags) {

                const resourceName = action.resource_name;
                const resourceId = action.resource_id;

                if (resourceName && resourceId) {
                    if (!mergeTagResources[resourceName]) {
                        mergeTagResources[resourceName] = [];
                    }
                    if (!mergeTagResources[resourceName].includes(resourceId)) {
                        mergeTagResources[resourceName].push(resourceId);
                    }
                }
            }
        });

        return mergeTagResources;
    }

    function getEventResourceIDName() {
        const mergeTagResources: any = {};

        if (
            workflowEvent &&
            workflowEvent.event_resource_details &&
            workflowEvent.event_resource_details.options &&
            workflowEvent.event_resource_details.options.merge_tags
        ) {
            const resourceName = workflowEvent && workflowEvent.event_resource_details && workflowEvent.event_resource_details.options &&
                workflowEvent.event_resource_details.options.resource_name;
            const resourceId = workflowEvent && workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_id;


            if (resourceName) {
                if (!mergeTagResources[resourceName]) {
                    mergeTagResources[resourceName] = [];
                }
                if (!mergeTagResources[resourceName].includes(resourceId)) {
                    mergeTagResources[resourceName].push(resourceId);
                }
            }
        }

        return mergeTagResources;
    }

    function combineMergeTagResourcesIDNames() {
        const combined: any = {};

        // Get all unique keys from both objects
        const allKeys: any = new Set([
            ...Object.keys(getEventResourceIDName()),
            ...Object.keys(getActionResourceIDName()),
        ]);

        allKeys.forEach((key: any) => {
            const values1 = getEventResourceIDName()[key] || [];
            const values2 = getActionResourceIDName()[key] || [];

            // Combine the arrays while maintaining the original order and ensuring uniqueness
            const uniqueValues: any = [...values1, ...values2].filter(
                (value, index, array) => array.indexOf(value) === index
            );

            combined[key] = uniqueValues.filter((item: any) => item !== null);
        });

        return combined;
    }

    function getActionsMergetags() {
        return actionMergeTags.length > 0 ? actionMergeTags : [];
    }


    const eventMergeTags: any = workflowEvent && workflowEvent.event_resource_details && workflowEvent.event_resource_details.options && workflowEvent.event_resource_details.options
    const dataItemsId = workflowEvent.event_resource_details && workflowEvent.event_resource_details.options && workflowEvent.event_resource_details.event_resource_id
    const dataItemsName = workflowEvent.event_resource_details && workflowEvent.event_resource_details.options && workflowEvent.event_resource_details.event_resource_title
    const planDataItemsName = workflowEvent && workflowEvent.event_resource_details && workflowEvent.event_resource_details.category

    function getEventMergeTagsData() {

        if ((dataItemsId === undefined || dataItemsId === null) && planDataItemsName !== 'community' &&
            planDataItemsName !== 'subscription') {
            return [];
        }
        if (eventMergeTags === undefined) {
            return [];
        }
        const keys: any = eventMergeTags && Object.keys(eventMergeTags);

        if (keys.length > 0) {
            return keys
                .filter((key: any) => key === 'merge_tags')
                .map(() => ({
                    key: eventMergeTags['resource_name'],
                    data:
                    {
                        dataItemsName: dataItemsName || 'Joined community',
                        dataItemsId: dataItemsId,
                        dataItems: eventMergeTags['merge_tags'],
                    }
                }));
        }

        return [];
    }

    function moveItemsToUser() {

        const data = [
            ...getEventMergeTagsData(),
            ...getActionsMergetags()
        ];
        if (data.length === 0) {
            return data;
        }
        // Construct the "User" object if it doesn't already exist
        let user = data.find((item: any) => item.key === "User");

        if (!user) {
            user = {
                "key": "User",
                "data": {
                    "dataItemsName": "User details",
                    "dataItems": []
                }
            };
            data.unshift(user);
        }

        // Iterate through the data to find any object with dynamic 'key' and move the relevant items
        data.forEach((item: any) => {
            if (item.key !== "User") {
                // Filter out the items to move from each dynamic object
                const itemsToMove = item.data.dataItems.filter((item: any) =>
                    item.tag === "{{full_name}}" || item.tag === "{{email}}" || item.tag === "{{first_name}}" || item.tag === "{{last_name}}" || item.tag === "{{phone_number}}"
                );

                // Remove those items from the current object's data
                item.data.dataItems = item.data.dataItems.filter((item: any) =>
                    item.tag !== "{{full_name}}" && item.tag !== "{{email}}" && item.tag !== "{{first_name}}" && item.tag !== "{{last_name}}" && item.tag !== "{{phone_number}}"
                );

                // Ensure no duplicates in the "User" object before adding
                itemsToMove.forEach((itemToMove: any) => {
                    const existingItem = user.data.dataItems.find(
                        (userItem: any) => userItem.tag === itemToMove.tag
                    );
                    if (!existingItem) {
                        user.data.dataItems.push(itemToMove);
                    }
                });
            }
        });

        return data;
    }

    const eventAndActionsMergeTags = moveItemsToUser()

    // save merge tags and resources when the merge tag icon is clicked
    const [mergeTagAndResource, setMergeTagAndResource] = React.useState<any>(null);

    React.useEffect(() => {
        if (mergeTagAndresourcesUsed && typeof mergeTagAndresourcesUsed === "object") {
            setMergeTagAndResource(mergeTagAndresourcesUsed);
        }
    }, [mergeTagAndresourcesUsed])
    const updateMergeTagsByResourceKey = function (mergeTagRes: any) {
        setMergeTagAndResource(function (prevTags: any) {
            const updatedKey = mergeTagRes && mergeTagRes.key;
            const incomingTags = (mergeTagRes && mergeTagRes.tags) || [];
            const randomID = mergeTagRes && mergeTagRes.randomID;

            if (updatedKey === 'User') {
                return prevTags;
            }

            const data = mergeTagRes && mergeTagRes.data;
            const newResourceId = data && data.dataItemsId ? data.dataItemsId : null;
            const resource_name = data && data.dataItemsName ? data.dataItemsName : null;

            const tagsData = prevTags ? prevTags : {};
            const existingData = Array.isArray(tagsData[updatedKey]) ? tagsData[updatedKey] : [];

            const newTagResourcePairs = incomingTags.map(function (tag: string) {
                return {
                    tag: tag,
                    resource_id: newResourceId,
                    randomID: randomID,
                    resource_name: resource_name
                };
            });

            // Merge and de-dupe only based on tag + resource_id + randomID
            const combinedPairs = existingData.concat(newTagResourcePairs).filter(function (pair: any, index: any, self: any) {
                return index === self.findIndex(function (p: any) {
                    return (
                        p.tag === pair.tag &&
                        p.resource_id === pair.resource_id &&
                        p.randomID === pair.randomID
                    );
                });
            });

            const finalData = {
                ...tagsData,
                [updatedKey]: combinedPairs
            };

            return finalData;
        });
    };

    const saveMergetagsUsed = () => {
        setMergeTagsAndResourcesUsed((prevTags: any) => {
            const updatedTags: any = { ...prevTags };

            if (mergeTagAndResource && typeof mergeTagAndResource === "object" && !Array.isArray(mergeTagAndResource)) {
                Object.keys(mergeTagAndResource).forEach((resourceKey) => {
                    const newResources = mergeTagAndResource[resourceKey]; // This is an array

                    if (Array.isArray(newResources)) {
                        const existingResource = updatedTags[resourceKey] || [];

                        // Merge existing and new data
                        const combinedPairs = [
                            ...existingResource,
                            ...newResources.map(({ tag, resource_id, randomID }) => ({ tag, resource_id, randomID })),
                        ];

                        // Remove duplicates based on both `tag` and `resource_id`
                        const uniquePairs = combinedPairs.filter((pair, index, self) =>
                            index === self.findIndex((p) =>
                                p.tag === pair.tag &&
                                p.resource_id === pair.resource_id &&
                                p.randomID === pair.randomID
                            )
                        );

                        updatedTags[resourceKey] = uniquePairs;
                    } else {
                        console.warn(`Invalid data for resourceKey: ${resourceKey}`, newResources);
                    }
                });
            }
            return updatedTags;
        });
    };


    function updateMergeTagsWhenDeleteOnString(dataString: string, eventRandomID: string) {
        if (
            typeof dataString !== "string" ||
            dataString.trim() === "" ||
            typeof mergeTagAndResource !== "object" ||
            !eventRandomID
        ) {
            return;
        }

        // Extract tags from the dataString
        const currentTags = new Set(dataString.match(/{{[^{}]+}}/g) || []);

        const updatedMergeTags = Object.entries(mergeTagAndResource).reduce((acc, [key, tags]: any) => {
            const updatedTags = tags.filter((item: { tag: string; randomID: string }) => {
                // 1. If the tag has a different randomID — keep it untouched
                if (item.randomID !== eventRandomID) return true;

                // 2. If tag has the matching randomID — keep only if it exists in dataString
                return currentTags.has(item.tag);
            });

            // Only add non-empty tag lists
            if (updatedTags.length > 0) {
                acc[key] = updatedTags;
            }

            return acc;
        }, {} as typeof mergeTagAndResource);

        setMergeTagsAndResourcesUsed(updatedMergeTags);
        findDifferenceInMergeTags();
    }


    function updateMergeTags(prevObj: any, updateObj: any) {
        const { resource_name, resource_id, resource_title } = updateObj;

        // Check if the resource_name exists in the object
        if (!prevObj.hasOwnProperty(resource_name)) return prevObj;

        const updatedCategoryArray = prevObj[resource_name].map((item: any) => {
            // Only update if the resource_id is different
            if (item.resource_id !== resource_id) {
                return {
                    ...item,
                    resource_id: resource_id,
                    resource_name: resource_title
                };
            }
            return item;
        });

        // Return a new object with the updated resource_name
        return {
            ...prevObj,
            [resource_name]: updatedCategoryArray
        };
    }

    const checkIfResourcesUsedHasChangedOnEvent = () => {
        const mergeTagResources: any = {};

        if (
            workflowEvent &&
            workflowEvent.event_resource_details &&
            workflowEvent.event_resource_details.options &&
            workflowEvent.event_resource_details.options.merge_tags
        ) {
            const resourceName = workflowEvent.event_resource_details.options.resource_name;
            const resourceId = workflowEvent.event_resource_details.event_resource_id;


            if (resourceName) {
                if (!mergeTagResources[resourceName]) {
                    mergeTagResources[resourceName] = [];
                }
                if (!mergeTagResources[resourceName].includes(resourceId)) {
                    if (deletedMergeTags && Object.keys(deletedMergeTags).length > 0) {
                        const deletedResource = deletedMergeTags[resourceName] || [];
                        if (deletedResource.length > 0 && deletedResource[0].deleted) {
                            const _updateObj = {
                                resource_name: workflowEvent.resource_name,
                                resource_id: resourceId,
                                resource_title: workflowEvent.event_resource_details.event_resource_title
                            };
                            const updatedData = updateMergeTags(mergeTagAndresourcesUsed, _updateObj);
                            setMergeTagsAndResourcesUsed(updatedData);
                        }
                    }
                    mergeTagResources[resourceName].push(resourceId);
                }
            }
        }
    }


    useEffect(() => {
        if (workflowEvent && workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_id) {
            saveMergetagsUsed();
            checkIfResourcesUsedHasChangedOnEvent();
        }
    }, [workflowEvent && workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_id]);

    const actionsResourceIds = React.useMemo(
        () => actionList && actionList.length > 0 && actionList.map((action: any) => action.resource_id),
        [actionList]
    );

    React.useEffect(() => {
        if (actionList && actionList.length > 0 && mergeTagAndresourcesUsed) {
            actionList.forEach((action: any) => {
                if (action.resource_id) {
                    const resourceName = action.resource_name;
                    const resourceId = action.resource_id;

                    if (resourceName && resourceId) {
                        if (!mergeTagAndresourcesUsed[resourceName]) {
                            mergeTagAndresourcesUsed[resourceName] = [];
                        }
                        if (!mergeTagAndresourcesUsed[resourceName].includes(resourceId)) {
                            if (deletedMergeTags && Object.keys(deletedMergeTags).length > 0) {
                                const deletedResource = deletedMergeTags[resourceName] || [];
                                if (deletedResource.length > 0) {
                                    deletedResource.forEach((deletedResource: any) => {
                                        if (deletedResource.deleted) {
                                            const _updateObj = {
                                                resource_name: action.resource_name,
                                                resource_id: action.action_details && action.action_details.action_resource_id,
                                                resource_title: action.action_details && action.action_details.action_resource_title
                                            };
                                            const updatedData = updateMergeTags(mergeTagAndresourcesUsed, _updateObj);
                                            setMergeTagsAndResourcesUsed(updatedData);
                                        }
                                    })
                                }
                            }
                            mergeTagAndresourcesUsed[resourceName].push(resourceId);
                        }
                    }
                }
            });
        }
    }, [actionsResourceIds]);

    return (
        ReactDOM.createPortal(
            <WorkflowCreationContext.Provider
                value={{
                    addAction,
                    getFirstKeyValue,
                    workflowActionType, setWorkflowActionType,
                    workflowData,
                    group,
                    closeSideBarOnMobile, setCloseSideBarOnMobile,
                    setWorkflowEvent,
                    clearWorkflowEventQueries,
                    subscriptionOptions,
                    generateRandomId,
                    createNewBottomAction,
                    newPostion, setNewPostion,
                    workflowEventID,
                    workflowEvent,
                    iSWebHookStatus, setiSWebHookStatus,
                    webhookTestResults, setWebhookTestResults,
                    actionList,
                    eventAndActionsMergeTags,
                    workflowEventType,
                    mergeTagAndresourcesUsed,
                    saveMergetagsUsed,
                    findDifferenceInMergeTags,
                    updateMergeTagsWhenDeleteOnString,
                    deletedMergeTags,
                    updateMergeTagsByResourceKey,
                    hasDeletedTags,
                    changeDeletedStatus,
                    inputValuefieldKeys,
                    setInputValuefieldKeys,
                    integrations, setIntegrations,
                    shouldShowDangerIcon,
                }}
            >
                {workflowData && workflowData.title &&
                    <div className={styles.workflowCreation}>
                        <ChoicePopup
                            choicefn={(newChoice: any) => creatNewTopAction(newChoice)}
                            workflowEvent={workflowEvent}
                        />
                        <BottomChoicePopup
                            choicefn={(newChoice: any) => createNewBottomAction(newPostion, newChoice)}
                            workflowEvent={workflowEvent}
                        />
                        <div className={styles.workflowCreation__wrapper}>
                            <div className={styles.workflowCreation__header}>
                                <div className={styles.workflowCreation__header__title}>
                                    <div className={styles.workflowCreation__header__title__top}>

                                        <span className={styles.close} onClick={() => setIsDeleteConfirmationOpen(true)}>
                                            <LeftIcon />
                                        </span>
                                        <span className={styles.closeMobile}>
                                            <CloseIcon onClick={() => history.push(`/settings/workflows?page=${pageNumber > 0 ? pageNumber : 1}`)} />
                                        </span>

                                    </div >

                                    <div className={styles.workflowCreation__header__title__bottom}>
                                        <div className={styles.tooltipWrapper}>
                                            <button
                                                disabled={workflowData.status === 'active'}
                                                onClick={() => setIsRenameModalOpen(true)}
                                            >
                                                {workflowTitle}
                                            </button>
                                            <span className={styles.tooltipText}>Rename workflow</span>
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.workflowCreation__header__actions}>
                                    <button
                                        className={workflowData.status === 'active' ? styles.workflowCreation__header__actions__disabled : ''}
                                        disabled={workflowData.status === 'active'}
                                        onClick={() => {

                                            editWorkflow(false, contentpayload)
                                        }}
                                    >
                                        {
                                            isEditingWorkflow ? 'Saving...' : 'Save'
                                        }
                                    </button>
                                    {
                                        workflowData.status === 'active'
                                            ?
                                            <button
                                                onClick={deactiveWorkflow}
                                                className={`${styles.workflowCreation__header__actions__activate}`}
                                            >
                                                Deactivate

                                            </button>
                                            :
                                            <button
                                                onClick={activateWorkflow}
                                                disabled={activateBtnDisabled()}
                                                className={`${styles.workflowCreation__header__actions__activate} ${activateBtnDisabled() ? styles.workflowCreation__header__actions__disabled : ''}`}
                                            >
                                                Activate
                                            </button>
                                    }
                                </div>
                            </div>
                            <div className={styles.workflowCreation__body}>

                                <EventCard
                                    workflowEvent={workflowEvent}
                                    setWorkflowEvent={setWorkflowEvent}
                                    setCloseSideBarOnMobile={setCloseSideBarOnMobile}
                                    setActionList={setActionList}
                                    actionList={actionList}
                                />

                                <div className={styles.line} />

                                <AddAction postion={'top'} addAction={addAction} />

                                {
                                    (actionList.length > 0) && <div className={styles.line} />
                                }

                                <div className={styles.workflowCreation__actionsList}>
                                    {
                                        actionList.map((action: any, index: number) => (
                                            <ActionsContainer
                                                key={action.randomID}
                                                addActionFn={addAction}
                                                position={index}
                                                actionList={actionList}
                                                setActionList={setActionList}
                                                actionToBeEdited={action}
                                                group={group}
                                                actionTypeString={actionTypeString}
                                                setActionTypeString={setActionTypeString}
                                            />
                                        ))
                                    }
                                </div>

                                <EventTriggerContainer
                                    workflowEvent={workflowEvent}
                                    hideDropdownRef={hideDropdownRef}
                                    setWorkflowEvent={setWorkflowEvent}
                                    workflowData={workflowData}
                                    group={group}
                                    eventString={eventString}
                                    setEventString={setEventString}
                                    eventResourceString={eventResourceString}
                                    setEventResourceString={setEventResourceString}
                                    hideDropdownResourceRef={hideDropdownResourceRef}
                                    externalData={externalData}
                                    landingPageEventData={landingPageEventData}
                                    workflowEventType={workflowEventType}
                                    setExternalData={setExternalData}
                                    lessonData={lessonData}
                                    setLessonData={setLessonData}
                                    lessonString={lessonString}
                                    setLessonString={setLessonString}
                                    landingPageString={landingPageString}
                                    setLandingPageString={setLandingPageString}
                                />
                            </div>

                            <DeleteConfirmation
                                isOpen={isDeleteConfirmationOpen}
                                onClose={() => setIsDeleteConfirmationOpen(false)}
                                onConfirm={closeAndSave}
                                message="You are about to exit this workflow."
                                hideNoUndoWaring
                                deleteBtnLabel="Exit"
                                minHeight={200}
                            />
                            <RenamePopup
                                IsOpen={isRenameModalOpen}
                                setIsOpen={setIsRenameModalOpen}
                                workflowTitle={workflowTitle}
                                editWorkflow={editWorkflow}
                                isEditingWorkflow={isEditingWorkflow}
                                setWorkflowTitle={setWorkflowTitle}
                                payload={contentpayload}
                            />

                            <TemplateNamePopup
                                IsOpen={isRenameTemplateOpen}
                                closeDialog={closeRenamePopup}
                                templateTitle={workflowData && workflowData.title}
                                editTemplateName={() => editWorkflow(false, contentpayload)}
                                isEditingTemplate={isEditingWorkflow}
                                setTemplateData={setWorkflowData}
                                templateType='workflow'
                            />

                        </div>
                    </div>
                }
            </WorkflowCreationContext.Provider>,
            //@ts-ignore
            document.getElementById('workflow-creation-portal-root')
        )
    )
}

const AddAction = ({ postion, addAction }: { postion: any, addAction: any }) => {
    const { setNewPostion } = React.useContext(WorkflowCreationContext);
    return (
        <div className={styles.add_action}>
            <span onClick={() => {
                addAction(postion)
                setNewPostion(postion)
            }}
            >
                <AddIcon />
            </span>
        </div>
    )
}

const ActionsContainer = (
    {
        addActionFn,
        position,
        actionList,
        setActionList,
        actionToBeEdited,
        group,
        actionTypeString,
        setActionTypeString
    }
        :
        {
            addActionFn: any
            position: number
            actionList: any
            setActionList: any
            actionToBeEdited: any
            group: any
            actionTypeString: any
            setActionTypeString: any
        }
) => {
    const {
        workflowActionType,
        setCloseSideBarOnMobile,
        workflowData,
        setWorkflowEvent,
        clearWorkflowEventQueries,
        workflowEventID,
        deletedMergeTags,
    } = React.useContext(WorkflowCreationContext);


    const hideDropdownRef = React.useRef<any>(null);
    const integrationHideDropdownResourceRef = React.useRef<any>(null);

    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = React.useState<boolean>(false)
    const [topActionsDetails, setTopActionsDetails] = React.useState<any>(actionToBeEdited);
    const [searchString, setSearchString] = React.useState<string>("");
    const [contentDataString, setContentDataString] = React.useState<string>("");

    const isIntegration = topActionsDetails && topActionsDetails.integrations_data
    const [integrationData, setIntegrationData] = React.useState<any>(() => {
        if (isIntegration && topActionsDetails.integrations_data.options) {
            return topActionsDetails.integrations_data.options;
        }
        return [];
    });
    const [integrationDataQuery, setIntegrationDataQuery] = React.useState<string>('');
    const [filteredintegrationData, setFilteredintegrationData] = React.useState<any[]>([]);

    useEffect(() => {
        if (integrationData.length > 0) {
            setTopActionsDetails((prevState: any) => {
                const updatedState = {
                    ...prevState,
                    integrations_data: {
                        ...prevState.integrations_data,
                        options: integrationData
                    }
                };
                return updatedState;
            });
        }

    }, [integrationData.length]);

    useEffect(() => {
        if (integrationDataQuery.trim() === '') {
            setFilteredintegrationData(integrationData);
        } else {
            const lowerQuery = integrationDataQuery.toLowerCase();

            const filtered = integrationData.filter((item: any) => JSON.stringify(item).toLowerCase().includes(lowerQuery));

            setFilteredintegrationData(filtered);
        }
    }, [integrationData, integrationDataQuery]);

    useEffect(() => {
        // add remove_segment_access to the top actions
        if (actionToBeEdited && actionToBeEdited.slug === 'segment/remove') {
            setTopActionsDetails({
                ...actionToBeEdited,
                remove_resource_access: (actionToBeEdited.remove_resource_access === undefined) ? false : actionToBeEdited.remove_resource_access
            })
        } else {
            setTopActionsDetails(actionToBeEdited)
        }
    }, [actionToBeEdited && actionToBeEdited.randomID])

    const deletedTags = deletedMergeTags
        ? Object.values(deletedMergeTags)
            .flatMap(function (entry: any) {
                return entry.filter(function (item: any) {
                    return (
                        item &&
                        item.deleted === true &&
                        item.randomID === actionToBeEdited.randomID
                    );
                });
            })
            .map(function (item: any) {
                return {
                    resource_name: item.resource_name,
                    tag: item.tag,
                };
            })
        : [];

    const mergeTagsTooltip = deletedTags.length > 0
        ? "Merge tags " +
        deletedTags
            .map((item) =>
                item.resource_name
                    ? `${item.tag} for (${item.resource_name})`
                    : item.tag
            )
            .join(", ") +
        " used in the workflow were deleted."
        : null;


    const deleteAction = () => {

        if (actionList.length === 1) {
            setWorkflowEvent((prev: any) => ({
                ...prev,
                active: true,
            }));
            setActionList([]);

        } else {

            // Filter out the action to be deleted
            const filteredActionList = actionList.filter((action: any) => action.randomID !== actionToBeEdited.randomID);

            // Determine if there are any active actions left
            const hasActiveActions = filteredActionList.some((action: any) => action.active === true);

            // If no active actions are left, set the first action to active
            if (!hasActiveActions && filteredActionList.length > 0) {
                filteredActionList[0].active = true;
            }

            // Update action list
            setActionList(filteredActionList);

            // Close the delete confirmation
            setIsDeleteConfirmationOpen(false);
        }
    }

    const clearWorkflowActionResoureQueries = () => {
        setSearchString(" ");
        setContentDataString(" ");
        clearWorkflowEventQueries()
    }

    const closeAction = () => {
        const updatedActionList = actionList.map((action: any) => {
            if (action.randomID === actionToBeEdited.randomID) {
                return { ...action, active: true };
            } else {
                return { ...action, active: false };
            }
        });
        clearWorkflowActionResoureQueries()
        setWorkflowEvent((prev: any) => ({
            ...prev,
            active: false,
        }));
        setActionList(updatedActionList);
    };

    const getActions = (acData: any) => {
        const actions = [
            {
                label: 'Delete',
                callback: () => {
                    setIsDeleteConfirmationOpen(true);
                }
            },
        ]
        return actions
    }

    const shouldShowDangerIcon = () => {
        if (topActionsDetails) {
            if (topActionsDetails.slug === null) {
                return true
            }
            if (!topActionsDetails.slug) {
                return true
            }
            if (topActionsDetails.slug === 'email' && (topActionsDetails.subject === null || !topActionsDetails.subject)) {
                return true
            }
            if (topActionsDetails.slug === 'email' &&
                (
                    topActionsDetails.message === null ||
                    !topActionsDetails.message ||
                    (miscUtils.stripHTML(topActionsDetails.message) as string).trim() === ''

                )
            ) {
                return true
            }
            if (
                topActionsDetails.slug === 'filter' &&
                topActionsDetails.condition_groups &&
                topActionsDetails.condition_groups.length > 0

            ) {
                if (
                    !topActionsDetails.condition_groups.every((group: any) =>
                        group.rules.every((rule: any) => rule.condition !== null && rule.field !== null)
                    )
                ) {
                    return true;
                }
                return false
            }
            return (
                false
            )
        }

    };

    const shouldShowDangerIconOnLabel = () => {
        if (topActionsDetails) {
            if (topActionsDetails.slug === null) {
                return true
            }
            if (!topActionsDetails.slug) {
                return true
            }
            if (topActionsDetails.slug === 'email' && (topActionsDetails.subject === null || !topActionsDetails.subject)) {
                return true
            }
            if (topActionsDetails.slug === 'email' &&
                (
                    topActionsDetails.message === null ||
                    !topActionsDetails.message ||
                    (miscUtils.stripHTML(topActionsDetails.message) as string).trim() === ''

                )
            ) {
                return true
            }
            if (topActionsDetails.slug !== 'email' && topActionsDetails.slug !== 'delay') {
                if (!topActionsDetails.action_details) {
                    return true
                }
            }
            if (topActionsDetails.slug === 'delay') {
                if (topActionsDetails.delay_in_minutes === 0) {
                    return true
                }
            }
            if (topActionsDetails.category === 'email' || topActionsDetails.category === 'direct-message') {
                if (deletedTags.length > 0) {
                    return true
                } else {
                    return false
                }
            }
            if (topActionsDetails.slug === 'webhook/send' && (topActionsDetails.endpoint === null || !topActionsDetails.endpoint || (topActionsDetails.endpoint && topActionsDetails.endpoint.trim() === ''))) {
                return true
            }
            return (
                false
            )
        }

    };

    const closeMobileSideBar = () => {
        if (window.innerWidth <= 767) {
            setCloseSideBarOnMobile(true)
        }
    }

    const rulesHash = React.useMemo(() => {
        return JSON.stringify(
            topActionsDetails && topActionsDetails.condition_groups && topActionsDetails.condition_groups.flatMap((group: any) => group.rules) || []
        );
    }, [topActionsDetails && topActionsDetails.condition_groups]);



    useEffect(() => {
        if (actionList.length > 0) {

            setActionList((prevList: any) => {
                // Update the found item with new data while keeping other items unchanged
                if (topActionsDetails) {

                    const updatedList = prevList.map((item: any) => {
                        if ((item.randomID === actionToBeEdited.randomID) && topActionsDetails) {
                            return {
                                ...topActionsDetails, // Merge new data into the found item
                                'randomID': item.randomID,
                                'active': item.active,
                            };
                        }
                        // Return other items as they are
                        return item
                    });
                    return updatedList;
                }
            });
            return

        }
    }, [
        topActionsDetails && topActionsDetails.slug,
        topActionsDetails && topActionsDetails.subject,
        topActionsDetails && topActionsDetails.executed_resource_name,
        topActionsDetails && topActionsDetails.message,
        topActionsDetails && topActionsDetails.message_json,
        topActionsDetails && topActionsDetails.recipient_emails,
        topActionsDetails && topActionsDetails.send_as,
        topActionsDetails && topActionsDetails.plan_option,
        topActionsDetails && topActionsDetails.remove_resource_access,
        topActionsDetails && topActionsDetails.condition_groups && topActionsDetails.condition_groups.length,
        rulesHash,
        topActionsDetails && topActionsDetails.mapping_fields,
        topActionsDetails && topActionsDetails.community_fields,
        topActionsDetails && topActionsDetails.integrations_data
    ])


    return (
        <>
            {position === 0 ? <></> : <div className={styles.line} />}
            <div
                className={`
                        ${styles.workflowCreation__body__Event} 
                        ${styles.workflowCreation__body__Action}
                        ${actionToBeEdited.active ? styles.Active : ''}
                 `}
                onClick={closeAction}
            >
                <div className={styles.ActionCard}>
                    <div
                        className={styles.workflowCreation__body__Action__Header}
                        onClick={closeMobileSideBar}
                    >
                        <div className={styles.top_action}>
                            {
                                shouldShowDangerIcon() && !topActionsDetails.label &&
                                <>
                                    {position + 1}. {' '}
                                    <span className={styles.top_action__actionText}>{topActionsDetails.slug === 'filter' ? 'Filter conditions' : 'Action'} </span>
                                    <span className={styles.top_action__Icon}> <DangerIcon /></span>
                                </>
                            }
                            <span>
                                {
                                    (topActionsDetails && topActionsDetails.slug) === 'filter' &&
                                    !shouldShowDangerIcon() &&
                                    <>
                                        <span className={`${styles.top_action__actionText} ${styles.top_action__actionText__filter}`}> {position + 1}. {' '} </span>
                                        <span className={`${styles.top_action__actionText} ${styles.top_action__actionText__filter}`}> Filter condition </span>
                                    </>
                                }
                            </span>
                        </div>
                        {workflowData.status === 'inactive' &&
                            <div className={styles.top_action__actions}>
                                <Dropdown
                                    useTippy
                                    showMenuDots
                                    tippyCompatibleActions
                                    actions={getActions(actionToBeEdited)}
                                />

                            </div>
                        }
                    </div>

                    <div
                        onClick={closeMobileSideBar}
                        className={styles.workflowCreation__body__Action__Header__h1}>
                        <h1>
                            {
                                topActionsDetails && topActionsDetails.label &&
                                <>
                                    {position + 1}. {' '}
                                </>
                            }
                            {topActionsDetails && topActionsDetails.label && topActionsDetails.label.includes('direct message')
                                ?
                                <>
                                    Send direct message from
                                </>
                                :
                                topActionsDetails && topActionsDetails.label
                            }

                        </h1>

                        <span>
                            {
                                shouldShowDangerIconOnLabel() &&
                                topActionsDetails.label &&
                                topActionsDetails.slug !== 'community/remove' &&
                                topActionsDetails.slug !== 'member/cancel-subscription' &&
                                topActionsDetails.category !== 'email' &&
                                topActionsDetails.category !== 'direct-message' &&
                                topActionsDetails.slug !== 'kit/remove_subscriber' &&
                                <DangerIcon />
                            }
                        </span>
                        <span>
                            {
                                shouldShowDangerIconOnLabel() &&
                                topActionsDetails.label &&
                                topActionsDetails.slug === 'member/cancel-subscription' &&
                                (
                                    !topActionsDetails.plan_option ||
                                    topActionsDetails.plan_option === null
                                ) &&
                                <DangerIcon />
                            }
                        </span>
                        <span>
                            {
                                shouldShowDangerIconOnLabel() &&
                                topActionsDetails.label &&
                                topActionsDetails.slug === 'member/cancel-subscription' &&
                                topActionsDetails.plan_option &&
                                topActionsDetails.plan_option === 'specific subscription' &&
                                <DangerIcon />
                            }
                        </span>
                        {topActionsDetails &&
                            topActionsDetails.action_details &&
                            topActionsDetails.action_details.resource_deleted !== undefined &&
                            topActionsDetails.action_details.resource_deleted &&

                            <div className={styles.tooltipText2Container}>
                                <span><DangerIcon /></span>
                                <span
                                    className={styles.tooltipText2}
                                    data-tooltip={`${topActionsDetails && topActionsDetails.executed_resource_name} was deleted.`}
                                >
                                </span>
                            </div>
                        }

                        {
                            shouldShowDangerIconOnLabel() &&
                            (
                                topActionsDetails.category === 'email' ||
                                topActionsDetails.category === 'direct-message'
                            ) &&
                            // topActionsDetails.action_details &&

                            <div className={styles.tooltipText2Container}>
                                <span><DangerIcon /></span>
                                {
                                    topActionsDetails.action_details &&
                                    <span
                                        className={styles.tooltipText2}
                                        data-tooltip={mergeTagsTooltip}
                                    >
                                    </span>
                                }
                            </div>
                        }

                    </div>

                    {topActionsDetails && topActionsDetails.executed_resource_name &&
                        <div className={styles.divider}></div>
                    }

                    <div
                        className={styles.workflowCreation__body__Action__Header__h2}>
                        <span onClick={closeMobileSideBar}>
                            {
                                topActionsDetails &&
                                    topActionsDetails.slug &&
                                    topActionsDetails.slug === "direct-message/send-message" &&
                                    topActionsDetails.executed_resource_name
                                    ?
                                    <div className={styles.SelectedTeammateCard}>
                                        <div
                                            className={styles.SelectedTeammate__user}
                                            key={topActionsDetails.executed_resource_name.id}
                                        >
                                            <CustomUserComponent
                                                user={{ user: topActionsDetails.executed_resource_name }}
                                                group={group}
                                                rightPlacement={false}
                                                isHost={true}
                                                profileImageStyles={styles.SelectedTeammate__user__profileImage}
                                            />
                                        </div>
                                    </div>
                                    :
                                    <>
                                        {
                                            topActionsDetails.slug === "filter"
                                                ?
                                                <span className={styles.FilterName}>{topActionsDetails && topActionsDetails.executed_resource_name}</span>
                                                :
                                                <>
                                                    {
                                                        topActionsDetails.slug === "webhook/send"
                                                            ?
                                                            <span className={styles.webhookName}>{topActionsDetails && topActionsDetails.executed_resource_name}</span>
                                                            :
                                                            <>
                                                                {topActionsDetails && topActionsDetails.executed_resource_name}
                                                            </>
                                                    }
                                                </>
                                        }
                                    </>
                            }
                        </span>
                    </div>

                </div>

                <div className={styles.workflowCreation__body__Action__body}>
                    <div
                        style={{ display: actionToBeEdited.active ? 'block' : 'none' }}
                        className={styles.actionTypeSelection}
                    >
                        {
                            topActionsDetails.slug === 'filter'
                                ?
                                <WorkflowEditSideBar
                                    editElement={
                                        <RuleEditor
                                            workflowData={workflowData}
                                            topActionsDetails={topActionsDetails}
                                            setTopActionsDetails={setTopActionsDetails}
                                            groupData={group}
                                            workflowEventID={workflowEventID}
                                        />
                                    }
                                    actionType={topActionsDetails && topActionsDetails.slug}
                                />
                                :
                                <WorkflowEditSideBar
                                    editElement={
                                        <div key={position}>

                                            <h6>Select Action
                                                <small>{" "}*</small>
                                            </h6>

                                            <AppSelect
                                                popupStyles={{
                                                    minHeight: '100px'
                                                }}
                                                inputClassName={styles.inputActionTrigger}
                                                disabled={(workflowData.status === 'active') || (topActionsDetails && topActionsDetails.workflow_action_title) || isIntegration}
                                                XIconstyles={` ${(topActionsDetails && topActionsDetails.workflow_action_title) || isIntegration ? styles.XIconstyles : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                                placeholder="Search or select option"
                                                hideDropdownRef={hideDropdownRef}
                                                value={
                                                    actionTypeString &&
                                                        actionTypeString.trim() !== ''
                                                        ?
                                                        actionTypeString
                                                        :
                                                        isIntegration
                                                            ?
                                                            topActionsDetails.integrations_data.label
                                                            :
                                                            (topActionsDetails && topActionsDetails.workflow_action_title) ?
                                                                (topActionsDetails.workflow_action_title.charAt(0).toUpperCase() + topActionsDetails.workflow_action_title.slice(1))
                                                                :
                                                                ''
                                                }
                                                markRequired
                                                cursorPointer
                                                inputIconClassName={`${styles.inputIconNameAction} 
                                                ${(topActionsDetails && topActionsDetails.workflow_action_title) || isIntegration ? styles.inputIconNameActionNone : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                                onChangeValue={(e: any) => setActionTypeString(e.target.value)}
                                                onRemoveSelectedValue={() => {
                                                    setActionTypeString(' ')
                                                    setTopActionsDetails({
                                                        randomID: topActionsDetails.randomID,
                                                        active: true
                                                    })
                                                    setIntegrationData([])
                                                }}
                                            >
                                                <div className={styles.ActiontypesDropdown}>
                                                    <WorkflowDataSelector
                                                        data={workflowActionType && workflowActionType}
                                                        onDataSelected={(value: any, data: any) => {
                                                            setActionTypeString(' ')
                                                            setTopActionsDetails((prev: any) => ({
                                                                randomID: prev.randomID,
                                                            }));
                                                            hideDropdownRef.current();
                                                            const matchingItem = data
                                                            if (matchingItem.external) {
                                                                setTopActionsDetails((prevState: any) => ({
                                                                    ...prevState,
                                                                    'integrations_data': {
                                                                        label: matchingItem.key === 'kit' ? 'Kit (Convertkit)' : matchingItem.key.charAt(0).toUpperCase() + matchingItem.key.slice(1),
                                                                        value: matchingItem.key,
                                                                    }
                                                                }))
                                                                return
                                                            }
                                                            setTopActionsDetails((prev: any) => ({
                                                                randomID: prev.randomID,
                                                                ...matchingItem,
                                                                active: true,
                                                                'workflow_action_title': matchingItem.title,
                                                                'external': matchingItem.external,
                                                                'options': matchingItem.options,
                                                                'resource_name': matchingItem.options && matchingItem.options.resource_name,
                                                                'workflow_action_id': matchingItem.id,
                                                            }));
                                                            if (matchingItem.slug === 'community/remove') {
                                                                setTopActionsDetails((prev: any) => ({
                                                                    randomID: prev.randomID,
                                                                    ...matchingItem,
                                                                    active: true,
                                                                    'workflow_action_title': matchingItem.title,
                                                                    'external': matchingItem.external,
                                                                    'options': matchingItem.options,
                                                                    'resource_name': matchingItem.options.resource_name,
                                                                    'workflow_action_id': matchingItem.id,
                                                                    'executed_resource_name': group.name
                                                                }))
                                                            }
                                                            if (matchingItem.slug === 'delay') {
                                                                setTopActionsDetails((prev: any) => ({
                                                                    randomID: prev.randomID,
                                                                    ...matchingItem,
                                                                    active: true,
                                                                    'workflow_action_title': matchingItem.title,
                                                                    'external': matchingItem.external,
                                                                    'options': matchingItem.options,
                                                                    'resource_name': matchingItem.options.resource_name,
                                                                    'workflow_action_id': matchingItem.id,
                                                                    'executed_resource_name': '5 minutes',
                                                                    'delay_in_minutes': 5,
                                                                    'delay_period_name': 'minutes',
                                                                    'display_delay_in_minutes': 5,
                                                                }))
                                                            }
                                                            if (matchingItem.slug === 'segment/remove') {
                                                                setTopActionsDetails((prev: any) => ({
                                                                    randomID: prev.randomID,
                                                                    ...matchingItem,
                                                                    active: true,
                                                                    'workflow_action_title': matchingItem.title,
                                                                    'external': matchingItem.external,
                                                                    'options': matchingItem.options,
                                                                    'resource_name': matchingItem.options.resource_name,
                                                                    'workflow_action_id': matchingItem.id,
                                                                    'remove_resource_access': true,

                                                                }))
                                                            }

                                                        }}
                                                        searchString={actionTypeString}
                                                        labelStyle={styles.workflowActionlabelStyle}
                                                        containerClassName={styles.ActiontypesDropdown__Dropdown}
                                                        elementContainerClass={styles.workflowActionEl}
                                                        saveIntegrationData={setIntegrationData}

                                                    />
                                                </div>
                                            </AppSelect>


                                            {
                                                ((filteredintegrationData.length > 0) || (topActionsDetails && topActionsDetails.integrations_data)) &&
                                                <>
                                                    <h6 style={{ marginTop: '16px' }}>Select Trigger Action
                                                        <small>{" "}*</small>
                                                    </h6>

                                                    <AppSelect
                                                        popupStyles={{
                                                            minHeight: '100px'
                                                        }}
                                                        inputClassName={styles.inputActionTrigger}
                                                        disabled={(workflowData.status === 'active') || (topActionsDetails && topActionsDetails.workflow_action_title)}
                                                        XIconstyles={` ${topActionsDetails && topActionsDetails.workflow_action_title ? styles.XIconstyles : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                                        placeholder="Search or select option"
                                                        hideDropdownRef={integrationHideDropdownResourceRef}
                                                        value={
                                                            integrationDataQuery &&
                                                                integrationDataQuery.trim() !== ''
                                                                ?
                                                                integrationDataQuery
                                                                :
                                                                (topActionsDetails && topActionsDetails.workflow_action_title) ?
                                                                    (topActionsDetails.workflow_action_title.charAt(0).toUpperCase() + topActionsDetails.workflow_action_title.slice(1))
                                                                    :
                                                                    ''
                                                        }
                                                        markRequired
                                                        cursorPointer
                                                        inputIconClassName={`${styles.inputIconNameAction} ${topActionsDetails &&
                                                            topActionsDetails.workflow_action_title ? styles.inputIconNameActionNone : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                                        onChangeValue={(e: any) => setIntegrationDataQuery(e.target.value)}
                                                        onRemoveSelectedValue={() => {
                                                            setIntegrationDataQuery(' ')
                                                            setTopActionsDetails((prevState: any) => {
                                                                // Create a copy of the integrations_data object
                                                                const newEventResourceDetails = { ...prevState.integrations_data };

                                                                // Return the updated state with the modified integrations_data
                                                                return {
                                                                    active: true,
                                                                    randomId: prevState.randomID,
                                                                    integrations_data: newEventResourceDetails,
                                                                };
                                                            });
                                                        }}
                                                    >
                                                        <div className={styles.ActiontypesDropdown}>
                                                            <ContentDataSelector
                                                                data={filteredintegrationData}
                                                                onDataSelected={(value: any, data: any) => {
                                                                    setIntegrationDataQuery(' ')
                                                                    integrationHideDropdownResourceRef.current();
                                                                    const matchingItem = data
                                                                    setTopActionsDetails((prevState: any) => ({
                                                                        ...prevState,
                                                                        ...matchingItem,
                                                                        'workflow_action_title': matchingItem.title,
                                                                        'external': matchingItem.external,
                                                                        'options': matchingItem.options,
                                                                        'resource_name': matchingItem.options && matchingItem.options.resource_name,
                                                                        'workflow_action_id': matchingItem.id,
                                                                    }))
                                                                }}
                                                                labelStyle={styles.eventResourceTypelabelStyle}
                                                                elementContainerClass={styles.eventResourceTypelabelStyle__Dropdown}
                                                                noResultsStringStyle={styles.noResultsStringStyle__integration}
                                                            />
                                                        </div>
                                                    </AppSelect>

                                                </>
                                            }


                                            {
                                                topActionsDetails && topActionsDetails.slug === 'delay' &&
                                                <TimeDelay
                                                    topActionsDetails={topActionsDetails}
                                                    setTopActionsDetails={setTopActionsDetails}
                                                    actionToBeEdited={actionToBeEdited}
                                                />
                                            }

                                            {
                                                topActionsDetails && topActionsDetails.slug && topActionsDetails.slug !== 'delay' &&
                                                <CurrentSelectedActionType
                                                    key={actionToBeEdited.randomID}
                                                    group={group}
                                                    topActionsDetails={topActionsDetails && topActionsDetails}
                                                    setTopActionsDetails={setTopActionsDetails}
                                                    actionToBeEdited={actionToBeEdited}
                                                    searchString={searchString}
                                                    setSearchString={setSearchString}
                                                    contentDataString={contentDataString}
                                                    setContentDataString={setContentDataString}
                                                />
                                            }
                                        </div>
                                    }
                                    actionType={topActionsDetails && topActionsDetails.slug}
                                />
                        }

                    </div>

                </div>
            </div>
            <div className={styles.line} />

            <AddAction postion={position} addAction={addActionFn} />

            <DeleteConfirmation
                isOpen={isDeleteConfirmationOpen}
                onClose={() => setIsDeleteConfirmationOpen(false)}
                onConfirm={deleteAction}
                deleteBtnLabel="Delete"
                minHeight={200}
                deletable={topActionsDetails}
                deletableNameKey='label'
                deletableResource="action"
            />
        </>
    )
}

const CurrentSelectedActionType = (
    {
        group,
        topActionsDetails,
        setTopActionsDetails,
        actionToBeEdited,
        searchString,
        setSearchString,
        contentDataString,
        setContentDataString,
    }:
        {
            group: any
            topActionsDetails: any
            setTopActionsDetails: any
            actionToBeEdited: any
            searchString: any
            setSearchString: any
            contentDataString: any
            setContentDataString: any
        }
) => {

    const hideDropdownRef = React.useRef<any>(null);
    const { workflowData, subscriptionOptions, changeDeletedStatus, inputValuefieldKeys, workflowEvent, setInputValuefieldKeys } = React.useContext(WorkflowCreationContext);
    // @ts-ignore
    // const { workflowData, subscriptionOptions, inputValuefieldKeys, workflowEvent, setInputValuefieldKeys } = React.useContext(WorkflowCreationContext);
    const [contentData, setContentData] = React.useState<any>(null);
    const [externalData, setExternalData] = React.useState<any>(null);


    function determineActionType() {
        if ((topActionsDetails.slug === 'member/cancel-subscription') || (topActionsDetails.slug === 'community/add')) {
            return 'subscription plan'
        }
        return topActionsDetails.category;
    }

    useEffect(() => {
        if (topActionsDetails && topActionsDetails.slug) {
            if (topActionsDetails.slug === 'channel/add') {
                let query: string = ``;
                if (searchString.length > 3) {
                    query = `?search=${searchString}`;
                }
                ChannelService.getInstance()
                    .getChannels(group.id, query)
                    .then((response: any) => {
                        const newList = response.data.data.filter((channel: any) => channel.deleted_at === null).map((item: any) => {
                            return {
                                label: item.name,
                                value: item.name,
                                ...item
                            }
                        });
                        setContentData(newList)
                    })
                    .catch((error: any) => {
                        console.error(error)
                        new Error(error)
                    })
                    .finally(() => { })
                return
            }
            if (topActionsDetails.slug === 'channel/remove') {
                let query: string = ``;
                if (searchString.length > 0) {
                    query = `?search=${searchString}`;
                }
                ChannelService.getInstance()
                    .getChannels(group.id, query)
                    .then((response: any) => {
                        const newList = response.data.data.filter((channel: any) => channel.deleted_at === null).map((item: any) => {
                            return {
                                label: item.name,
                                value: item.name,
                                ...item
                            }
                        });
                        setContentData(newList)
                    })
                    .catch((error: any) => {
                        console.error(error)
                        new Error(error)
                    })
                    .finally(() => { })
                return
            }

            if (topActionsDetails.slug === 'course/add') {
                LibraryService.getInstance()
                    .getSpecificContent(group.id, 'course', searchString)
                    .then((response: any) => {
                        const newList = response.data.data.map((item: any) => {
                            return {
                                label: item.contentable.title,
                                value: item.contentable.title,
                                ...item.contentable
                            }
                        });
                        setContentData(newList)
                    })
                    .catch((error: any) => {
                        console.error(error)
                        new Error(error)
                    })
                    .finally(() => { })
                return
            }

            if (topActionsDetails.slug === 'course/remove') {
                LibraryService.getInstance()
                    .getSpecificContent(group.id, 'course', searchString)
                    .then((response: any) => {
                        const newList = response.data.data.map((item: any) => {
                            return {
                                label: item.contentable.title,
                                value: item.contentable.title,
                                ...item.contentable
                            }
                        });
                        setContentData(newList)
                    })
                    .catch((error: any) => {
                        console.error(error)
                        new Error(error)
                    })
                    .finally(() => { })
                return
            }

            if (topActionsDetails.slug === 'library-content/accessed') {
                let query: string = ``;
                if (searchString.length > 0) {
                    query = `?search=${searchString}`;
                }
                LibraryService.getInstance()
                    .getLibraryContents(group.id, query)
                    .then((response: any) => {
                        const newList = response.data.data.map((item: any) => {
                            return {
                                label: item.contentable.title,
                                value: item.contentable.title,
                                ...item.contentable
                            }
                        });
                        setContentData(newList)
                    })
                    .catch((error: any) => {
                        console.error(error)
                        new Error(error)
                    })
                    .finally(() => { })
                return
            }

            if (topActionsDetails.slug === 'segment/add') {
                let query: string = ``;
                if (searchString.length > 0) {
                    query = `?search=${searchString}`;
                }
                SegmentService.getInstance()
                    .getCommunitySegments(group.id, query)
                    .then((response: any) => {
                        const newList = response.data.data.map((item: any) => {
                            return {
                                label: item.name,
                                value: item.name,
                                ...item
                            }
                        });
                        setContentData(newList)
                    })
                    .catch((error: any) => {
                        console.error(error)
                        new Error(error)
                    })
                    .finally(() => { })
                return
            }

            if (topActionsDetails.slug === 'segment/remove') {
                let query: string = ``;
                if (searchString.length > 0) {
                    query = `?search=${searchString}`;
                }
                SegmentService.getInstance()
                    .getCommunitySegments(group.id, query)
                    .then((response: any) => {
                        const newList = response.data.data.map((item: any) => {
                            return {
                                label: item.name,
                                value: item.name,
                                ...item
                            }
                        });
                        setContentData(newList)
                    })
                    .catch((error: any) => {
                        console.error(error)
                        new Error(error)
                    })
                    .finally(() => { })
                return
            }

            if (topActionsDetails.slug === 'community/add') {
                GroupService.getInstance()
                    .getAdminCommunityPlans(group.id, searchString)
                    .then((response: any) => {
                        const newList = response.data.data.filter((item: any) => (item.archived_at === null) && (item.price === 0)).map((item: any) => {
                            return {
                                label: item.name,
                                value: item.name,
                                ...item
                            }
                        });
                        setContentData(newList)
                    })
                    .catch((error: any) => {
                        console.error(error)
                        new Error(error)
                    })
                    .finally(() => { })
                return
            }

            if (topActionsDetails.slug === 'member/cancel-subscription') {
                GroupService.getInstance()
                    .getAdminCommunityPlans(group.id, searchString)
                    .then((response: any) => {
                        const newList = response.data.data.map((item: any) => {
                            return {
                                label: item.name,
                                value: item.name,
                                ...item
                            }
                        });
                        setContentData(newList)
                    })
                    .catch((error: any) => {
                        console.error(error)
                        new Error(error)
                    })
                    .finally(() => { })
                return
            }

            if (topActionsDetails.options && topActionsDetails.options.search && topActionsDetails.options.search.length) {
                topActionsDetails.options.search.map((searchItem: any) => {
                    if (searchItem.depends_on && searchItem.depends_on.length > 0) {
                        if (topActionsDetails.resource_id) {
                            searchItem.depends_on.map((dependItem: any) => {
                                if (dependItem.action) {

                                    const action = searchItem
                                    const data = {
                                        ...dependItem,
                                        "search_query": searchString,
                                    }

                                    AdminMessagingService.getInstance()
                                        .fetchEventsResource(group.id, topActionsDetails.third_party_application_id, data)
                                        .then((response: any) => {

                                            const newList = response.map((item: any) => {
                                                return {
                                                    label: item.name,
                                                    value: item.name,
                                                    ...item
                                                }
                                            });
                                            // if (topActionsDetails.options.search.length > 1) {
                                            setExternalData((prev: any) => {
                                                const safePrev = Array.isArray(prev) ? prev : [];
                                                return [
                                                    ...safePrev.filter(item => item.action !== action.action),
                                                    {
                                                        action: action.action,
                                                        data: newList
                                                    }
                                                ];
                                            });


                                        }).catch((error: any) => {
                                            console.error(error);
                                        }).finally(() => {

                                        })
                                    return
                                }
                            })
                            return
                        }

                    } else {
                        const action = searchItem
                        const data = {
                            "action": action && action.action,
                            "search_query": searchString
                        }

                        AdminMessagingService.getInstance()
                            .fetchEventsResource(group.id, topActionsDetails.third_party_application_id, data)
                            .then((response: any) => {

                                const newList = response.map((item: any) => {
                                    return {
                                        label: item.name,
                                        value: item.name,
                                        ...item
                                    }
                                });
                                setExternalData((prev: any) => {
                                    const safePrev = Array.isArray(prev) ? prev : [];
                                    return [
                                        ...safePrev.filter(item => item.action !== action.action),
                                        {
                                            action: action.action,
                                            data: newList
                                        }
                                    ];
                                });
                            }).catch((error: any) => {
                                console.error(error);
                            }).finally(() => {

                            })

                    }
                })
                return
            }


        }
    }, [
        topActionsDetails && topActionsDetails.slug,
        searchString,
        topActionsDetails.options && topActionsDetails.options.search && topActionsDetails.options.search.length,
        topActionsDetails && topActionsDetails.resource_id,
    ])



    React.useEffect(() => {
        if (
            topActionsDetails &&
            topActionsDetails.external &&
            topActionsDetails.options &&
            topActionsDetails.options.search &&
            topActionsDetails.options.search.length &&
            // topActionsDetails.options.search.some((item: any) => item.action === "getCustomFields") &&
            workflowEvent &&
            workflowEvent.event_resource_details &&
            workflowEvent.event_resource_details.parent_event_resource_id &&
            workflowEvent.event_resource_details.event_resource_id
        ) {
            if (
                workflowEvent.slug === 'page_form/new_submission'
            ) {
                AdminMessagingService.getInstance()
                    .fetchLeadableFields(group.id, workflowEvent.event_resource_details.parent_event_resource_id, workflowEvent.event_resource_details.event_resource_id)
                    .then((response: any) => {
                        const newList = response.data.map((item: any) => {
                            return {
                                label: item.label,
                                value: item.label,
                                ...item
                            }
                        });

                        const newGroup = {
                            key: `${workflowEvent.resource_name}: ${workflowEvent.event_resource_details.event_resource_title}`,
                            data: newList
                        };

                        setInputValuefieldKeys(newGroup);

                    }).catch((error: any) => {
                        console.error(error);
                    }).finally(() => {

                    })

            }

            if (
                workflowEvent.slug === 'course-form/submitted'
            ) {
                AdminMessagingService.getInstance()
                    .fetchCoursesFormFields(group.id, workflowEvent.event_resource_details.event_resource_id)
                    .then((response: any) => {
                        const newList = response.data.map((item: any) => {
                            return {
                                label: item.label,
                                value: item.label,
                                ...item
                            }
                        });
                        const newGroup = {
                            key: `${workflowEvent.resource_name}: ${workflowEvent.event_resource_details.event_resource_title}`,
                            data: newList
                        };

                        setInputValuefieldKeys(newGroup);

                    }).catch((error: any) => {
                        console.error(error);
                    }).finally(() => {

                    })
            }
        }

    }, [
        topActionsDetails && topActionsDetails.external,
        topActionsDetails && topActionsDetails.options && topActionsDetails.options.search && topActionsDetails.options.search,
        workflowEvent && workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_id,
        workflowEvent && workflowEvent.event_resource_details && workflowEvent.event_resource_details.parent_event_resource_id,
    ])

    function alignDropdownIcon() {
        const container: any = document.querySelector('.groupapp-select-input-wrapper');
        const icon: any = document.querySelector('.groupapp-select-input-icon');

        if (!container || !icon) return;

        const containerHeight = container.offsetHeight;
        const iconHeight = icon.offsetHeight;

        const centeredTop = (containerHeight - iconHeight) / 2;

        const finalCenteredTop = centeredTop - 8;

        if (finalCenteredTop < 0) {
            return 14
        }

        return finalCenteredTop

    }

    const observer = new MutationObserver(() => {
        alignDropdownIcon();
    });

    const target = document.querySelector('.groupapp-select-input-wrapper');
    if (target) {
        observer.observe(target, { childList: true, subtree: true });
    }


    function alignDropdown() {
        const container: any = document.querySelector('.groupapp-select-input-wrapper');
        const icon: any = document.querySelector('.groupapp-select-input-icon');

        if (!container || !icon) return;

        const containerHeight = container.offsetHeight;
        const iconHeight = icon.offsetHeight;

        const centeredTop = (containerHeight - iconHeight);

        return centeredTop + 10

    }

    const observerDropdown = new MutationObserver(() => {
        alignDropdown();
    });

    const targetDropdown = document.querySelector('.groupapp-select-input-wrapper');
    if (targetDropdown) {
        observerDropdown.observe(targetDropdown, { childList: true, subtree: true });
    }

    return (
        <>
            {
                topActionsDetails.slug === 'delay' ?
                    <h1 className={styles.workflowCreation__sidebarTitle}>
                        {`Add time ${determineActionType()}`}
                        <small>{" "}*</small>
                    </h1>
                    :
                    <>
                        {
                            topActionsDetails &&
                                topActionsDetails.options &&
                                topActionsDetails.options.search &&
                                topActionsDetails.options.search.length
                                ?
                                <>
                                    {
                                        externalData && topActionsDetails.options.search.map((searchOption: any, index: number) => {
                                            return (
                                                <div key={index}>
                                                    {Object.entries(externalData).map(([actionKey, actionData]: any, index: number) => {
                                                        if ((searchOption.action === actionData.action)) {

                                                            if (searchOption.type === 'mapping') {
                                                                return <>
                                                                    {
                                                                        searchOption.input_label && actionData.data && actionData.data.length > 0 &&
                                                                        <h1 className={styles.workflowCreation__sidebarTitle}>
                                                                            {searchOption.input_label}
                                                                            {
                                                                                searchOption.type === 'mapping' && inputValuefieldKeys.data.length === 0 &&
                                                                                <small
                                                                                    style={{
                                                                                        color: '#666',
                                                                                        fontSize: '13px',
                                                                                        fontStyle: 'normal',
                                                                                        lineHeight: 'normal',
                                                                                        marginLeft: '4px',
                                                                                        textTransform: 'none',
                                                                                        fontWeight: 400
                                                                                    }}
                                                                                >(Select a trigger to add mapping fields)
                                                                                </small>
                                                                            }
                                                                        </h1>
                                                                    }
                                                                    {
                                                                        actionData.data.map((data: any, dataIndex: number) => (
                                                                            <KitInputTypes
                                                                                topActionsDetails={topActionsDetails}
                                                                                setTopActionsDetails={setTopActionsDetails}
                                                                                key={`${actionKey}-${dataIndex}`} // unique key
                                                                                kitInputsType={data}
                                                                                KitInputTypesKey={`${actionKey}-${dataIndex}`}
                                                                            />
                                                                        ))
                                                                    }
                                                                </>

                                                            } else {
                                                                return <>
                                                                    {
                                                                        searchOption.input_label &&
                                                                        <h1 className={styles.workflowCreation__sidebarTitle}>
                                                                            {searchOption.input_label}
                                                                        </h1>
                                                                    }

                                                                    {
                                                                        searchOption.input_placeholder &&
                                                                        <>
                                                                            {
                                                                                searchOption.type === 'multi-select' ?
                                                                                    <AppSelect
                                                                                        popupStyles={{
                                                                                            minHeight: '120px',
                                                                                            top: alignDropdown(),

                                                                                        }}
                                                                                        containerClassName={`${styles.appSelectContainer} 
                                                                                            ${(topActionsDetails.resources && topActionsDetails.resources.length > 0) ? styles.appSelectContainerWhite2 : ''}`}
                                                                                        disabled={workflowData.status === 'active'}
                                                                                        placeholder={searchOption.input_placeholder}
                                                                                        hideDropdownRef={hideDropdownRef}
                                                                                        valueElement={
                                                                                            topActionsDetails.resources && topActionsDetails.resources.length > 0 &&
                                                                                            <ResourceTagList
                                                                                                resources={topActionsDetails.resources || []}
                                                                                                setTopActionsDetails={setTopActionsDetails}
                                                                                                isDisabled={workflowData.status === 'active'}
                                                                                            />
                                                                                        }
                                                                                        markRequired
                                                                                        cursorPointer
                                                                                        inputClassName={styles.inputAction3}
                                                                                        onRemoveSelectedValue={() => {
                                                                                            setSearchString('')
                                                                                            setTopActionsDetails((prevDetails: any) => {
                                                                                                // Delete the specific properties
                                                                                                delete prevDetails.action_details;
                                                                                                delete prevDetails.resource_id
                                                                                                delete prevDetails.executed_resource_name
                                                                                                delete prevDetails.resources
                                                                                                return {
                                                                                                    ...prevDetails,
                                                                                                    active: true,
                                                                                                };
                                                                                            });
                                                                                        }}
                                                                                        inputIconClassName={`${styles.inputIconNameActionResource2} ${workflowData && workflowData.status === 'active' ? styles.inputIconNameActionResourceDisabled : ''}`}
                                                                                        inputIconStyles={{
                                                                                            top: alignDropdownIcon()
                                                                                        }}
                                                                                    >
                                                                                        {
                                                                                            externalData &&

                                                                                            <div className={styles.ActiontypesDropdown}>
                                                                                                <ContentDataSelector
                                                                                                    data={actionData.data}
                                                                                                    onDataSelected={(value: any, data: any) => {
                                                                                                        const matchingItem: any = actionData.data.find((innerItem: any) => innerItem.id === data.id);
                                                                                                        if (hideDropdownRef.current) {
                                                                                                            hideDropdownRef.current();
                                                                                                        }
                                                                                                        setSearchString('')
                                                                                                        setTopActionsDetails((prevDetails: any) => {
                                                                                                            const existingResources = prevDetails.resources || [];

                                                                                                            // Remove duplicates
                                                                                                            const filteredResources = existingResources.filter(
                                                                                                                (res: any) => res.resource_id !== matchingItem.id
                                                                                                            );

                                                                                                            const updatedResources = [
                                                                                                                ...filteredResources,
                                                                                                                searchOption.workflow_resource_value
                                                                                                                    ? {
                                                                                                                        workflow_resource_value: matchingItem.name,
                                                                                                                        resource_name: matchingItem.name,
                                                                                                                    }
                                                                                                                    : {
                                                                                                                        resource_id: matchingItem.id,
                                                                                                                        resource_name: matchingItem.name,
                                                                                                                    }
                                                                                                            ];

                                                                                                            // Join all resource names
                                                                                                            const executedResourceName = updatedResources
                                                                                                                .map(res => res.resource_name)
                                                                                                                .join(', ');

                                                                                                            // Combine existing IDs (excluding duplicate) + new one
                                                                                                            const existingResourceIds = Array.isArray(prevDetails.resource_ids)
                                                                                                                ? prevDetails.resource_ids.filter((id: any) => id !== matchingItem.id)
                                                                                                                : [];

                                                                                                            const updatedResourceIds = [...existingResourceIds, matchingItem.id];

                                                                                                            return {
                                                                                                                ...prevDetails,
                                                                                                                active: true,
                                                                                                                resource_ids: updatedResourceIds,
                                                                                                                executed_resource_name: executedResourceName,
                                                                                                                resources: updatedResources
                                                                                                            };
                                                                                                        });



                                                                                                    }}
                                                                                                    searchString={searchString}
                                                                                                    labelStyle={styles.eventResourceTypelabelStyle}
                                                                                                    elementContainerClass={styles.eventResourceTypelabelStyle__Dropdown}
                                                                                                />
                                                                                            </div>

                                                                                        }
                                                                                    </AppSelect>
                                                                                    :
                                                                                    <AppSelect
                                                                                        popupStyles={{ minHeight: '120px' }}
                                                                                        containerClassName={`${styles.appSelectContainer} ${((topActionsDetails.action_details && topActionsDetails.action_details.action_resource_id) === null) ||
                                                                                            (topActionsDetails.action_details && topActionsDetails.action_details.action_resource_id === undefined)
                                                                                            ||
                                                                                            (!topActionsDetails.action_details)
                                                                                            ? styles.appSelectContainerWhite : ''}`}
                                                                                        disabled={
                                                                                            (workflowData.status === 'active') ||
                                                                                            (
                                                                                                topActionsDetails &&
                                                                                                topActionsDetails.action_details &&
                                                                                                topActionsDetails.action_details.action_resource_id
                                                                                            )}
                                                                                        placeholder={searchOption.input_placeholder}
                                                                                        hideDropdownRef={hideDropdownRef}
                                                                                        value={
                                                                                            searchString
                                                                                                &&
                                                                                                searchString.trim() !== ''
                                                                                                ?
                                                                                                searchString
                                                                                                :
                                                                                                // searchString.length === 0
                                                                                                //     ?
                                                                                                //     ''
                                                                                                //     :
                                                                                                topActionsDetails.action_details
                                                                                                    ?
                                                                                                    (topActionsDetails.action_details.action_resource_title)
                                                                                                    :
                                                                                                    ''
                                                                                        }
                                                                                        markRequired
                                                                                        cursorPointer
                                                                                        inputClassName={styles.inputAction3}
                                                                                        onRemoveSelectedValue={() => {
                                                                                            setSearchString('')
                                                                                            setTopActionsDetails((prevDetails: any) => {

                                                                                                // Delete the specific properties
                                                                                                delete prevDetails.action_details;
                                                                                                delete prevDetails.resource_id
                                                                                                delete prevDetails.executed_resource_name
                                                                                                delete prevDetails.resources
                                                                                                return {
                                                                                                    ...prevDetails,
                                                                                                    active: true,
                                                                                                };
                                                                                            });
                                                                                        }}
                                                                                        XIconstyles={`${topActionsDetails && topActionsDetails.action_details && topActionsDetails.action_details.action_resource_id ? styles.XIconstyles : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                                                                        inputIconClassName={`${styles.inputIconNameActionResource2} ${topActionsDetails && topActionsDetails.action_details && topActionsDetails.action_details.action_resource_id ? styles.inputIconNameActionNone : ""}`}
                                                                                    >
                                                                                        {
                                                                                            externalData &&

                                                                                            <div className={styles.ActiontypesDropdown}>
                                                                                                <ContentDataSelector
                                                                                                    data={actionData.data}
                                                                                                    onDataSelected={(value: any, data: any) => {
                                                                                                        const matchingItem: any = actionData.data.find((innerItem: any) => innerItem.id === data.id);
                                                                                                        if (hideDropdownRef.current) {
                                                                                                            hideDropdownRef.current();
                                                                                                        }
                                                                                                        setSearchString('')
                                                                                                        setTopActionsDetails((prevDetails: any) => {
                                                                                                            // Step 1: Build base updatedDetails (without resources yet)

                                                                                                            let updatedDetails: any = {
                                                                                                                ...prevDetails,
                                                                                                                active: true,
                                                                                                                resource_id: matchingItem.id,
                                                                                                                'executed_resource_name': matchingItem.name,
                                                                                                                "action_details": {
                                                                                                                    "action_resource_title": matchingItem.name,
                                                                                                                    'action_resource_id': matchingItem.id,
                                                                                                                },
                                                                                                                options: {
                                                                                                                    ...(prevDetails.options || {}),
                                                                                                                    ...(prevDetails.options && prevDetails.options.search
                                                                                                                        ? {
                                                                                                                            search: prevDetails.options.search.map((item: any) =>
                                                                                                                                Array.isArray(item.depends_on) && item.depends_on.length > 0
                                                                                                                                    ? {
                                                                                                                                        ...item,
                                                                                                                                        depends_on: item.depends_on.map((opt: any) => {
                                                                                                                                            if (opt.payload) {
                                                                                                                                                // Early return: don't spread opt
                                                                                                                                                const obj: any = {
                                                                                                                                                    action: item.action,
                                                                                                                                                    [opt.payload]: matchingItem.id,
                                                                                                                                                };

                                                                                                                                                return Object.fromEntries(
                                                                                                                                                    Object.entries(obj).filter(
                                                                                                                                                        ([key, value]) => key !== 'undefined' && value !== undefined
                                                                                                                                                    )
                                                                                                                                                );
                                                                                                                                            } else {
                                                                                                                                                // Default case: include spread opt
                                                                                                                                                const obj: any = {
                                                                                                                                                    action: item.action,
                                                                                                                                                    [opt.payload]: matchingItem.id,
                                                                                                                                                    ...opt,
                                                                                                                                                };

                                                                                                                                                return Object.fromEntries(
                                                                                                                                                    Object.entries(obj).filter(
                                                                                                                                                        ([key, value]) => key !== 'undefined' && value !== undefined
                                                                                                                                                    )
                                                                                                                                                );

                                                                                                                                            }

                                                                                                                                        }),

                                                                                                                                    }
                                                                                                                                    : item
                                                                                                                            ),
                                                                                                                        }
                                                                                                                        : {}),
                                                                                                                }
                                                                                                            };

                                                                                                            //    ...(searchOption.resource_name && {
                                                                                                            //     resources: [
                                                                                                            //         {
                                                                                                            //             ...(prevDetails.resources || {}),
                                                                                                            //             resource_id: matchingItem.id,
                                                                                                            //             resource_name: searchOption.resource_name,
                                                                                                            //         }
                                                                                                            //     ]
                                                                                                            // })

                                                                                                            // Step 2: Conditionally add resources based on updatedDetails
                                                                                                            if (topActionsDetails.slug !== "mailchimp/add_tag_to_subscriber") {
                                                                                                                if (searchOption.resource_name) {
                                                                                                                    updatedDetails = {
                                                                                                                        ...updatedDetails,
                                                                                                                        resources: [
                                                                                                                            {
                                                                                                                                ...(prevDetails.resources || {}),
                                                                                                                                resource_id: matchingItem.id,
                                                                                                                                resource_name: searchOption.resource_name,
                                                                                                                            },
                                                                                                                        ],
                                                                                                                    };
                                                                                                                }
                                                                                                                else if (!searchOption.resource_name) {
                                                                                                                    updatedDetails = {
                                                                                                                        ...updatedDetails,
                                                                                                                        resources: [
                                                                                                                            {
                                                                                                                                ...(prevDetails.resources || {}),
                                                                                                                                resource_id: matchingItem.id,
                                                                                                                                resource_name: matchingItem.name,
                                                                                                                            },
                                                                                                                        ],
                                                                                                                    };
                                                                                                                }

                                                                                                            }

                                                                                                            return updatedDetails;
                                                                                                        });
                                                                                                    }}
                                                                                                    searchString={searchString}
                                                                                                    labelStyle={styles.eventResourceTypelabelStyle}
                                                                                                    elementContainerClass={styles.eventResourceTypelabelStyle__Dropdown}
                                                                                                />
                                                                                            </div>

                                                                                        }
                                                                                    </AppSelect>
                                                                            }
                                                                        </>
                                                                    }
                                                                </>
                                                            }
                                                        }
                                                        return null; // explicitly return null if condition not met
                                                    })}
                                                </div>
                                            )
                                        })
                                    }


                                </>
                                :
                                <>
                                    {
                                        topActionsDetails.slug !== 'email' &&
                                        topActionsDetails.slug !== 'community/remove' &&
                                        topActionsDetails.slug !== 'channel/add' &&
                                        topActionsDetails.slug !== 'channel/remove' &&
                                        topActionsDetails.slug !== 'member/cancel-subscription' &&
                                        contentData &&

                                        <h1 className={styles.workflowCreation__sidebarTitle}>
                                            {`Select ${determineActionType()}`}
                                            <small>{" "}*</small>
                                        </h1>
                                    }

                                    {
                                        (
                                            topActionsDetails.slug === 'channel/add' ||
                                            topActionsDetails.slug === 'channel/remove'
                                        )
                                        &&

                                        <h1 className={styles.workflowCreation__sidebarTitle}>
                                            {`Select Channel`}
                                            <small>{" "}*</small>
                                        </h1>
                                    }
                                </>
                        }
                    </>
            }

            <>
                {
                    topActionsDetails.slug === 'email' ?
                        <EmailEditor
                            group={group}
                            topActionsDetails={topActionsDetails}
                            setTopActionsDetails={setTopActionsDetails}
                        />
                        :
                        <>
                            {
                                topActionsDetails.slug === 'webhook/send' ?
                                    <>
                                        <WebHookURLAndBtn
                                            topActionsDetails={topActionsDetails}
                                            setTopActionsDetails={setTopActionsDetails}
                                        />
                                        <WebHookStatus />
                                    </>
                                    :
                                    <>
                                        {
                                            topActionsDetails.slug === 'email/notification' ?
                                                <EmailNotificationEditor
                                                    group={group}
                                                    topActionsDetails={topActionsDetails}
                                                    setTopActionsDetails={setTopActionsDetails}
                                                />
                                                :
                                                <>
                                                    {
                                                        topActionsDetails.slug === 'direct-message/send-message' ?
                                                            <DirectMessageEditor
                                                                group={group}
                                                                topActionsDetails={topActionsDetails}
                                                                setTopActionsDetails={setTopActionsDetails}
                                                            />
                                                            :
                                                            <>
                                                                {topActionsDetails.slug === 'community/remove'
                                                                    ?
                                                                    <></>
                                                                    :
                                                                    <>
                                                                        {
                                                                            (
                                                                                topActionsDetails.slug === 'channel/add' ||
                                                                                topActionsDetails.slug === 'channel/remove'
                                                                            )
                                                                                ?
                                                                                <AppSelect
                                                                                    popupStyles={{ minHeight: '100px' }}
                                                                                    disabled={
                                                                                        (workflowData.status === 'active') ||
                                                                                        (
                                                                                            topActionsDetails &&
                                                                                            topActionsDetails.action_details &&
                                                                                            topActionsDetails.action_details.action_resource_id
                                                                                        )
                                                                                    }
                                                                                    value={
                                                                                        searchString
                                                                                            &&
                                                                                            searchString.trim() !== ''
                                                                                            ?
                                                                                            searchString
                                                                                            :
                                                                                            // searchString.length === 0
                                                                                            //     ?
                                                                                            //     ''
                                                                                            //     :
                                                                                            topActionsDetails.action_details
                                                                                                ?
                                                                                                (topActionsDetails.action_details.action_resource_title)
                                                                                                :
                                                                                                ''
                                                                                    }
                                                                                    onChangeValue={(e: any) => setSearchString(e.target.value)}
                                                                                    placeholder={`Select or search ${determineActionType()}`}
                                                                                    hideDropdownRef={hideDropdownRef}
                                                                                    containerClassName={`${styles.appSelectContainer} 
                                    ${((
                                                                                            topActionsDetails.action_details &&
                                                                                            topActionsDetails.action_details.action_resource_id
                                                                                        ) === null) ||
                                                                                            (
                                                                                                topActionsDetails.action_details &&
                                                                                                topActionsDetails.action_details.action_resource_id === undefined
                                                                                            )
                                                                                            ||
                                                                                            (
                                                                                                !topActionsDetails.action_details

                                                                                            )
                                                                                            ? styles.appSelectContainerWhite : ''}`}
                                                                                    inputClassName={styles.inputAction3}
                                                                                    onRemoveSelectedValue={() => {
                                                                                        setSearchString('')
                                                                                        setTopActionsDetails((prevDetails: any) => {
                                                                                            // Delete the specific properties
                                                                                            delete prevDetails.action_details;
                                                                                            delete prevDetails.resource_id
                                                                                            delete prevDetails.executed_resource_name
                                                                                            return {
                                                                                                ...prevDetails,
                                                                                                active: true,
                                                                                            };

                                                                                        });

                                                                                    }}
                                                                                    XIconstyles={`${topActionsDetails && topActionsDetails.action_details && topActionsDetails.action_details.action_resource_id ? styles.XIconstyles : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                                                                    inputIconClassName={`${styles.inputIconNameActionResource2} ${topActionsDetails && topActionsDetails.action_details && topActionsDetails.action_details.action_resource_id ? styles.inputIconNameActionNone : ""}`}

                                                                                >
                                                                                    {contentData && contentData.length > 0 &&
                                                                                        <ChannelSelector
                                                                                            group={group}
                                                                                            onChannelSelected={(channel: any) => {
                                                                                                if (hideDropdownRef.current) {
                                                                                                    //@ts-ignore
                                                                                                    hideDropdownRef.current();
                                                                                                }
                                                                                                setSearchString(' ')
                                                                                                setContentDataString('');
                                                                                                setTopActionsDetails((prevDetails: any) => ({
                                                                                                    ...prevDetails, // Spread previous details to preserve existing data
                                                                                                    active: true,
                                                                                                    resource_id: channel.id,
                                                                                                    'executed_resource_name': channel.name,
                                                                                                    "action_details": {
                                                                                                        "action_resource_title": channel.name,
                                                                                                        'action_resource_id': channel.id,
                                                                                                    },
                                                                                                }));
                                                                                            }}
                                                                                            searchString={searchString}
                                                                                            excludeArchived
                                                                                        />
                                                                                    }

                                                                                </AppSelect>
                                                                                :
                                                                                <>
                                                                                    {
                                                                                        topActionsDetails.slug === 'member/cancel-subscription'
                                                                                            ?
                                                                                            <>
                                                                                                {
                                                                                                    contentData &&
                                                                                                    <div className={styles.resourseSearch}>
                                                                                                        <h1 className={styles.workflowCreation__sidebarTitle}>
                                                                                                            {`Select subscription plan option`}
                                                                                                            <small>{" "}*</small>
                                                                                                        </h1>

                                                                                                        <AppSelect
                                                                                                            popupStyles={{ minHeight: '100px' }}
                                                                                                            inputClassName={styles.inputAction3}
                                                                                                            containerClassName={`${styles.appSelectContainer} 
                                                                                                        ${((
                                                                                                                    topActionsDetails &&
                                                                                                                    topActionsDetails.plan_option
                                                                                                                ) === null) ||
                                                                                                                    (
                                                                                                                        topActionsDetails &&
                                                                                                                        topActionsDetails.plan_option === undefined
                                                                                                                    )
                                                                                                                    ? styles.appSelectContainerWhite : ''}`}
                                                                                                            disabled={(workflowData.status === 'active') ||
                                                                                                                (topActionsDetails &&
                                                                                                                    topActionsDetails &&
                                                                                                                    topActionsDetails.plan_option
                                                                                                                )}
                                                                                                            placeholder={`Select option`}
                                                                                                            hideDropdownRef={hideDropdownRef}
                                                                                                            noCaret
                                                                                                            markRequired
                                                                                                            cursorPointer
                                                                                                            onRemoveSelectedValue={() => {
                                                                                                                setSearchString('')
                                                                                                                setTopActionsDetails((prevDetails: any) => {
                                                                                                                    // Delete the specific properties
                                                                                                                    delete prevDetails.plan_option;
                                                                                                                    delete prevDetails.action_details;
                                                                                                                    delete prevDetails.resource_id
                                                                                                                    delete prevDetails.executed_resource_name

                                                                                                                    return {
                                                                                                                        ...prevDetails,
                                                                                                                        active: true,
                                                                                                                    };

                                                                                                                });
                                                                                                            }}
                                                                                                            value={
                                                                                                                topActionsDetails && topActionsDetails.plan_option
                                                                                                                    ?
                                                                                                                    (topActionsDetails.plan_option.charAt(0).toUpperCase() + topActionsDetails.plan_option.slice(1))
                                                                                                                    :
                                                                                                                    ''
                                                                                                            }
                                                                                                            XIconstyles={`${topActionsDetails && topActionsDetails.plan_option ? styles.XIconstyles : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                                                                                            inputIconClassName={`${styles.inputIconNameActionResource2} ${topActionsDetails && topActionsDetails.plan_option ? styles.inputIconNameActionNone : ""}`}
                                                                                                        >
                                                                                                            <div className={styles.ActiontypesDropdown}>
                                                                                                                <ContentDataSelector
                                                                                                                    data={subscriptionOptions()}
                                                                                                                    onDataSelected={(value: any, data: any) => {
                                                                                                                        if (hideDropdownRef.current) {
                                                                                                                            //@ts-ignore
                                                                                                                            hideDropdownRef.current();
                                                                                                                        }
                                                                                                                        setSearchString(' ')
                                                                                                                        setContentDataString('');
                                                                                                                        setTopActionsDetails((prevDetails: any) => ({
                                                                                                                            ...prevDetails,
                                                                                                                            active: true,
                                                                                                                            plan_option: value,
                                                                                                                        }));

                                                                                                                    }}
                                                                                                                    labelStyle={styles.workflowActionlabelStyle}
                                                                                                                    containerClassName={styles.ActiontypesDropdown}
                                                                                                                    elementContainerClass={styles.workflowActionEl}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </AppSelect>

                                                                                                        {/* subscription plan selection */}
                                                                                                        {
                                                                                                            topActionsDetails &&
                                                                                                            topActionsDetails.plan_option === 'specific subscription' &&
                                                                                                            <SubscriptionPlanSelectionForAction
                                                                                                                topActionsDetails={topActionsDetails}
                                                                                                                contentData={contentData}
                                                                                                                searchString={searchString}
                                                                                                                setSearchString={setSearchString}
                                                                                                                setTopActionsDetails={setTopActionsDetails}
                                                                                                                setContentDataString={setContentDataString} />
                                                                                                        }
                                                                                                    </div>
                                                                                                }
                                                                                            </>
                                                                                            :
                                                                                            <>
                                                                                                {
                                                                                                    contentData &&
                                                                                                    <AppSelect
                                                                                                        popupStyles={{
                                                                                                            minHeight: '100px'
                                                                                                        }}
                                                                                                        disabled={(workflowData.status === 'active') || (topActionsDetails && topActionsDetails.action_details && topActionsDetails.action_details.action_resource_id)}
                                                                                                        value={
                                                                                                            searchString
                                                                                                                &&
                                                                                                                searchString.trim() !== ''
                                                                                                                ?
                                                                                                                searchString
                                                                                                                :
                                                                                                                // searchString.length === 0
                                                                                                                //     ?
                                                                                                                //     ''
                                                                                                                //     :
                                                                                                                topActionsDetails.action_details
                                                                                                                    ?
                                                                                                                    (topActionsDetails.action_details.action_resource_title)
                                                                                                                    :
                                                                                                                    ''
                                                                                                        }
                                                                                                        onChangeValue={(e: any) => setSearchString(e.target.value)}
                                                                                                        placeholder={`Select or search ${determineActionType()}`}
                                                                                                        hideDropdownRef={hideDropdownRef}
                                                                                                        containerClassName={`${styles.appSelectContainer} 
                                ${((
                                                                                                                topActionsDetails.action_details &&
                                                                                                                topActionsDetails.action_details.action_resource_id
                                                                                                            ) === null) ||
                                                                                                                (
                                                                                                                    topActionsDetails.action_details &&
                                                                                                                    topActionsDetails.action_details.action_resource_id === undefined
                                                                                                                )
                                                                                                                ||
                                                                                                                (
                                                                                                                    !topActionsDetails.action_details

                                                                                                                )
                                                                                                                ? styles.appSelectContainerWhite : ''}`}
                                                                                                        inputClassName={styles.inputAction3}
                                                                                                        onRemoveSelectedValue={() => {
                                                                                                            setSearchString('')
                                                                                                            setTopActionsDetails((prevDetails: any) => {
                                                                                                                // Delete the specific properties
                                                                                                                delete prevDetails.action_details;
                                                                                                                delete prevDetails.resource_id
                                                                                                                delete prevDetails.executed_resource_name
                                                                                                                return {
                                                                                                                    ...prevDetails,
                                                                                                                    active: true,
                                                                                                                };

                                                                                                            });

                                                                                                        }}
                                                                                                        XIconstyles={`${topActionsDetails && topActionsDetails.action_details && topActionsDetails.action_details.action_resource_id ? styles.XIconstyles : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                                                                                        inputIconClassName={`${styles.inputIconNameActionResource2} ${topActionsDetails && topActionsDetails.action_details && topActionsDetails.action_details.action_resource_id ? styles.inputIconNameActionNone : ""}`}

                                                                                                    >
                                                                                                        {contentData && contentData.length ?
                                                                                                            <ContentDataSelector
                                                                                                                data={contentData}
                                                                                                                onDataSelected={(value: any, data: any) => {
                                                                                                                    if (hideDropdownRef.current) {
                                                                                                                        //@ts-ignore
                                                                                                                        hideDropdownRef.current();
                                                                                                                    }
                                                                                                                    const matchingItem = contentData.find((innerItem: any) => innerItem.id === data.id);
                                                                                                                    setSearchString(' ')
                                                                                                                    setContentDataString('');
                                                                                                                    setTopActionsDetails((prevDetails: any) => ({
                                                                                                                        ...prevDetails, // Spread previous details to preserve existing data
                                                                                                                        active: true,
                                                                                                                        resource_id: matchingItem.id,
                                                                                                                        'executed_resource_name': matchingItem.label,
                                                                                                                        "action_details": {
                                                                                                                            "action_resource_title": matchingItem.label,
                                                                                                                            'action_resource_id': matchingItem.id,
                                                                                                                        },
                                                                                                                    }));
                                                                                                                    changeDeletedStatus({
                                                                                                                        resource_name: topActionsDetails.options.resource_name,
                                                                                                                        resource_id: matchingItem.id,
                                                                                                                        executed_resource_name: matchingItem.label,
                                                                                                                    })
                                                                                                                }}
                                                                                                                labelStyle={styles.workflowActionlabelStyle}
                                                                                                                containerClassName={styles.ActiontypesDropdown}
                                                                                                                elementContainerClass={styles.workflowActionEl}
                                                                                                            />
                                                                                                            :
                                                                                                            <h1 className={styles.NoResultsFound}>No results found</h1>
                                                                                                        }

                                                                                                    </AppSelect>
                                                                                                }

                                                                                            </>
                                                                                    }
                                                                                </>
                                                                        }
                                                                    </>
                                                                }
                                                            </>
                                                    }
                                                </>
                                        }
                                    </>
                            }
                        </>

                }
                {
                    contentData &&
                        contentData.length &&
                        topActionsDetails &&
                        topActionsDetails.slug === 'segment/remove'
                        ?
                        <div className={styles.KeepSegmentAcess}>

                            <div className={styles.KeepSegmentAcess__div1}>
                                <h1 className={styles.workflowCreation__sidebarTitle}>
                                    Member resource access
                                </h1>

                                <div className={styles.tooltipText2Container}>
                                    <div className={styles.TippyIcon}><TippyIcon /></div>
                                    <span
                                        className={styles.tooltipText2}
                                        data-tooltip={`Any member removed from this segment
                                                     won't be able to access any course,
                                                     event, channel or library content with
                                                      access level set to the segment.
                                                    `}
                                    >
                                    </span>
                                </div>
                            </div>
                            <SelectionDropDown
                                options={['Remove Access', 'Keep Access']}
                                defaultOption={topActionsDetails.remove_resource_access ? 'Remove Access' : 'Keep Access'}
                                toggleOption={(option: any) => {
                                    const _option = option === 'Keep Access' ? false : true
                                    setTopActionsDetails((prev: any) => (
                                        {
                                            ...prev,
                                            remove_resource_access: _option
                                        }
                                    ))
                                }}
                                optionsType={'remove_resource_access'}
                                isDisabled={(workflowData.status === 'active')}
                            />
                        </div>
                        :
                        <></>
                }
            </>
        </>
    );
}

const SubscriptionPlanSelectionForAction = ({
    searchString,
    setSearchString,
    topActionsDetails,
    setTopActionsDetails,
    contentData,
    setContentDataString,
}: {
    searchString: any
    setSearchString: any
    topActionsDetails: any
    setTopActionsDetails: any
    contentData: any
    setContentDataString: any
}
) => {
    const { workflowData, } = React.useContext(WorkflowCreationContext);
    const hideDropdownRef = React.useRef<any>(null);


    return (
        <div className={styles.resourseSearch}>
            <h1 className={styles.workflowCreation__sidebarTitle}>
                {`Select subscription plan`}
                <small>{" "}*</small>
            </h1>

            <AppSelect
                popupStyles={{ minHeight: '100px' }}
                disabled={(workflowData.status === 'active') ||
                    (
                        topActionsDetails &&
                        topActionsDetails.action_details &&
                        topActionsDetails.action_details.action_resource_id
                    )
                }
                value={
                    searchString
                        &&
                        searchString.trim() !== ''
                        ?
                        searchString
                        :
                        // searchString.length === 0
                        //     ?
                        //     ''
                        //     :
                        topActionsDetails.action_details
                            ?
                            (topActionsDetails.action_details.action_resource_title)
                            :
                            ''
                }
                onChangeValue={(e: any) => setSearchString(e.target.value)}
                placeholder={`Select or search subscription plan`}
                hideDropdownRef={hideDropdownRef}
                containerClassName={`${styles.appSelectContainer} 
                                ${((
                        topActionsDetails.action_details &&
                        topActionsDetails.action_details.action_resource_id
                    ) === null) ||
                        (
                            topActionsDetails.action_details &&
                            topActionsDetails.action_details.action_resource_id === undefined
                        )
                        ||
                        (
                            !topActionsDetails.action_details

                        )
                        ? styles.appSelectContainerWhite : ''}`}
                inputClassName={styles.inputAction3}
                onRemoveSelectedValue={() => {
                    setSearchString('')
                    setTopActionsDetails((prevDetails: any) => {
                        // Delete the specific properties
                        delete prevDetails.action_details;
                        delete prevDetails.resource_id
                        delete prevDetails.executed_resource_name
                        return {
                            ...prevDetails,
                            active: true,
                        };

                    });

                }}
                XIconstyles={`${topActionsDetails && topActionsDetails.action_details && topActionsDetails.action_details.action_resource_id ? styles.XIconstyles : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                inputIconClassName={`${styles.inputIconNameActionResource2} ${topActionsDetails && topActionsDetails.action_details && topActionsDetails.action_details.action_resource_id ? styles.inputIconNameActionNone : ""}`}

            >
                {contentData && contentData.length ?
                    <ContentDataSelector
                        data={contentData}
                        onDataSelected={(value: any, data: any) => {
                            if (hideDropdownRef.current) {
                                //@ts-ignore
                                hideDropdownRef.current();
                            }
                            const matchingItem = contentData.find((innerItem: any) => innerItem.id === data.id);
                            setSearchString(' ')
                            setContentDataString('');
                            setTopActionsDetails((prevDetails: any) => ({
                                ...prevDetails,
                                active: true,
                                resource_id: matchingItem.id,
                                'executed_resource_name': matchingItem.label,
                                "action_details": {
                                    ...prevDetails.action_details,
                                    "action_resource_title": matchingItem.label,
                                    'action_resource_id': matchingItem.id,
                                },
                            }));

                        }}
                        // searchString={contentDataString}
                        labelStyle={styles.workflowActionlabelStyle}
                        containerClassName={styles.ActiontypesDropdown}
                        elementContainerClass={styles.workflowActionEl}
                    />
                    :
                    <h1 className={styles.NoResultsFound}>No results found</h1>
                }

            </AppSelect>

        </div>

    )
}

const EventCard = ({
    workflowEvent,
    setWorkflowEvent,
    setCloseSideBarOnMobile,
    setActionList,
    actionList
}: {
    workflowEvent: any
    setWorkflowEvent: any
    setCloseSideBarOnMobile: any
    setActionList: any
    actionList: any
}
) => {

    const shouldShowDangerIcon = () => {
        if (workflowEvent && workflowEvent.event_resource_details) {
            if (
                [
                    "member/plan-subscription",
                    "member/cancelled-subscription",
                    "member/subscription-due",
                    "course-content/complete",
                    "course-form/submitted",
                    "page_form/new_submission",
                    "event_rsvp/create",
                    "library-content/accessed",
                    "segment/member_add",
                    "segment/member_remove",
                    "channel/new_member",
                    "channel/member_removed",
                    "course/enroll",
                    "course/completed",
                    "onboarding/field-submitted",
                ].includes(workflowEvent.slug) || (workflowEvent.event_resource_details && workflowEvent.event_resource_details.external)
            ) {
                // Specific logic for "member/cancelled-subscription" and "member/subscription-due"
                if (
                    (
                        workflowEvent.slug === "member/cancelled-subscription" ||
                        workflowEvent.slug === "member/subscription-due"
                    )
                ) {
                    if (!workflowEvent.plan_option || workflowEvent.plan_option === null) {
                        return true;
                    }
                    if (
                        workflowEvent.plan_option === 'specific subscription' &&
                        (
                            !workflowEvent.event_resource_details.event_resource_id ||
                            workflowEvent.event_resource_details.event_resource_id === null
                        )
                    ) {
                        return true;
                    }
                }
                // General logic for other slugs
                else if (
                    !workflowEvent.event_resource_details.event_resource_id ||
                    workflowEvent.event_resource_details.event_resource_id === null
                ) {
                    return true;
                }
            }
        }
        return false;

    };

    const [showContent, setShowContent] = React.useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowContent(true);
        }, 100);

        return () => clearTimeout(timer); // Cleanup the timer if the component unmounts
    }, []);

    return (
        <div
            onClick={() => {
                if (window.innerWidth <= 767) {
                    setCloseSideBarOnMobile(true)
                }
                setWorkflowEvent({ ...workflowEvent, active: true })
                setActionList([...actionList.map((item: any) => ({ ...item, active: false }))]);
            }}
            className={
                `
        ${styles.workflowCreation__body__Event}
        ${workflowEvent.active ? styles.Active : ''}
        `
            }
        >

            {
                workflowEvent && workflowEvent.event_resource_details
                    ?
                    <div className={styles.eventTypeTitleContainer}>
                        <div className={styles.eventTypeTitle}>
                            {
                                workflowEvent.label
                                    ?
                                    <h3>
                                        {workflowEvent.label.charAt(0).toUpperCase() + workflowEvent.label.slice(1)}{" "}
                                    </h3>
                                    :
                                    <></>
                            }
                            {
                                shouldShowDangerIcon() &&
                                <span><DangerIcon /></span>
                            }
                            {
                                (
                                    workflowEvent &&
                                    workflowEvent.event_resource_details &&
                                    workflowEvent.event_resource_details.event_resource_id &&
                                    workflowEvent.event_resource_details.resource_deleted !== undefined &&
                                    workflowEvent.event_resource_details.resource_deleted
                                )
                                &&
                                <div className={styles.tooltipText2Container}>
                                    <span><DangerIcon /></span>
                                    <span className={styles.tooltipText2} data-tooltip={
                                        `${workflowEvent &&
                                        workflowEvent.event_resource_details.event_resource_title &&
                                        workflowEvent.event_resource_details.event_resource_title} was deleted.`}
                                    >
                                    </span>
                                </div>

                            }
                        </div>

                        {
                            workflowEvent.event_resource_details &&
                            workflowEvent.event_resource_details.event_resource_title &&
                            <div className={styles.divider}></div>
                        }
                        <div className={styles.eventResourceTypeTitle}>
                            <span >
                                {
                                    workflowEvent.event_resource_details &&
                                    workflowEvent.event_resource_details.event_resource_title &&
                                    (workflowEvent.event_resource_details.event_resource_title.charAt(0).toUpperCase() + workflowEvent.event_resource_details.event_resource_title.slice(1))
                                }
                            </span>

                        </div>


                    </div>
                    :
                    <>
                        {
                            showContent &&
                            <div className={styles.eventTypeTriggerTitle}>
                                <h3>{
                                    workflowEvent.integrations_data && workflowEvent.integrations_data.label ?
                                        'Select Trigger Action'
                                        :
                                        'Set workflow trigger'
                                }</h3>
                                <span><DangerIcon /></span>
                            </div>

                        }
                    </>
            }
        </div>
    )
}

const EventTriggerContainer = (
    {
        workflowEvent,
        hideDropdownRef,
        setWorkflowEvent,
        workflowData,
        group,
        eventString,
        setEventString,
        eventResourceString,
        setEventResourceString,
        hideDropdownResourceRef,
        externalData,
        landingPageEventData,
        workflowEventType,
        setExternalData,
        lessonData,
        setLessonData,
        lessonString,
        setLessonString,
        landingPageString,
        setLandingPageString,

    }:
        {
            workflowEvent: any
            hideDropdownRef: any
            setWorkflowEvent: any
            workflowData: any
            group: any
            eventString: any
            setEventString: any
            eventResourceString: any
            setEventResourceString: any
            hideDropdownResourceRef: any
            externalData: any
            landingPageEventData: any
            workflowEventType: any
            setExternalData: any
            lessonData: any
            setLessonData: any
            lessonString: any
            setLessonString: any
            landingPageString: any
            setLandingPageString: any
        }
) => {

    const coursehideDropdownResourceRef = React.useRef<any>(null);
    const ladingPageHideDropdownResourceRef = React.useRef<any>(null);
    const SubhideDropdownResourceRef = React.useRef<any>(null);
    const integrationHideDropdownResourceRef = React.useRef<any>(null);

    const { subscriptionOptions, setIntegrations } = React.useContext(WorkflowCreationContext);

    const isIntegrations = workflowEvent.integrations_data && workflowEvent.integrations_data.label

    const [integrationDataQuery, setIntegrationDataQuery] = React.useState<string>('');
    const [filteredintegrationData, setFilteredintegrationData] = React.useState<any[]>(() => {
        if (isIntegrations && workflowEvent.integrations_data && workflowEvent.integrations_data.options) {
            return workflowEvent.integrations_data.options
        }
        return []
    });


    useEffect(() => {
        if (
            workflowEvent &&
            workflowEvent.integrations_data &&
            Array.isArray(workflowEvent.integrations_data.options)
        ) {
            const options = workflowEvent.integrations_data.options;
            const query = integrationDataQuery.trim().toLowerCase();

            const filtered = query === ''
                ? options
                : options.filter((item: any) =>
                    JSON.stringify(item).toLowerCase().includes(query)
                );

            setFilteredintegrationData(filtered);
        }
    }, [workflowEvent && workflowEvent.integrations_data, integrationDataQuery]);

    return (
        <div style={{ display: workflowEvent.active ? 'block' : 'none' }}>
            <WorkflowEditSideBar
                isAction
                editElement={
                    <>
                        <h6>Select Workflow Trigger
                            <small>{" "}*</small>
                        </h6>
                        <AppSelect
                            popupStyles={{
                                minHeight: '100px'
                            }}
                            inputClassName={styles.inputActionTrigger}
                            disabled={
                                ((workflowData.status === 'active') || (workflowEvent.event_resource_details) || isIntegrations)
                            }
                            XIconstyles={`${workflowEvent.event_resource_details || isIntegrations ? styles.XIconstyles : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                            placeholder="Select or search option"
                            hideDropdownRef={hideDropdownRef}
                            value={eventString && eventString.trim() !== '' ?
                                eventString
                                :
                                isIntegrations
                                    ?
                                    workflowEvent.integrations_data.label
                                    :
                                    workflowEvent.label && workflowEvent.label ?
                                        (workflowEvent.label.charAt(0).toUpperCase() + workflowEvent.label.slice(1))
                                        :
                                        ""
                            }
                            markRequired
                            cursorPointer
                            inputIconClassName={`${styles.inputIconNameActionResource} 
                        ${(workflowEvent.event_resource_details && workflowEvent.event_resource_details) || isIntegrations ? styles.inputIconNameActionNone : ""}`}
                            onChangeValue={(e: any) => setEventString(e.target.value)}
                            onRemoveSelectedValue={() => {
                                setEventString('')
                                setWorkflowEvent((prev: any) => ({
                                    randomID: prev.randomID,
                                    active: true,
                                }));
                                setExternalData(null)
                                setEventResourceString('');
                                setIntegrations([])
                            }}
                        >
                            <div className={styles.ActiontypesDropdown}>
                                <WorkflowDataSelector
                                    data={workflowEventType}
                                    onDataSelected={(value: any, data: any) => {
                                        setEventString('');
                                        hideDropdownRef.current();
                                        const matchingItem = data
                                        if (matchingItem.external) {
                                            setWorkflowEvent({
                                                ...workflowEvent,
                                                'integrations_data': {
                                                    label: matchingItem.key.charAt(0).toUpperCase() + matchingItem.key.slice(1),
                                                    value: matchingItem.key,
                                                    options: matchingItem.data,
                                                }
                                            });
                                        } else {
                                            setWorkflowEvent({
                                                ...workflowEvent,
                                                ...matchingItem,
                                                'workflow_event_id': matchingItem.id,
                                                'third_party_application_id': matchingItem.third_party_application_id,
                                                'resource_name': (
                                                    matchingItem.options &&
                                                    matchingItem.options.resource_name
                                                ) || matchingItem.category,
                                                "event_resource_details": {
                                                    'external': matchingItem.external,
                                                    'options': matchingItem.options,
                                                    'third_party_application_id': matchingItem.third_party_application_id,
                                                    'category': matchingItem.category,
                                                }
                                            });
                                        }
                                    }}
                                    searchString={eventString}
                                    labelStyle={styles.labelStyle}
                                    containerClassName={styles.ActiontypesDropdown__Dropdown}
                                    elementContainerClass={styles.workflowActionEl}
                                    saveIntegrationData={setIntegrations}
                                />
                            </div>
                        </AppSelect>


                        {
                            ((workflowEvent && workflowEvent.integrations_data)) &&
                            <>
                                <h6 style={{ marginTop: '16px' }}>Select Trigger Action
                                    <small>{" "}*</small>
                                </h6>
                                <AppSelect
                                    popupStyles={{
                                        minHeight: '100px'
                                    }}
                                    inputClassName={styles.inputActionTrigger}
                                    disabled={
                                        ((workflowData.status === 'active') || (workflowEvent.event_resource_details))
                                    }
                                    XIconstyles={`${workflowEvent.event_resource_details ? styles.XIconstyles : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                    placeholder="Select or search option"
                                    hideDropdownRef={integrationHideDropdownResourceRef}
                                    value={integrationDataQuery && integrationDataQuery.trim() !== '' ?
                                        integrationDataQuery
                                        :
                                        workflowEvent.label && workflowEvent.label ?
                                            (workflowEvent.label.charAt(0).toUpperCase() + workflowEvent.label.slice(1))
                                            :
                                            ""
                                    }
                                    markRequired
                                    cursorPointer
                                    inputIconClassName={`${styles.inputIconNameActionResource} 
                                                ${(workflowEvent.event_resource_details && workflowEvent.event_resource_details) ? styles.inputIconNameActionNone : ""}`}
                                    onChangeValue={(e: any) => setIntegrationDataQuery(e.target.value)}
                                    onRemoveSelectedValue={() => {
                                        setIntegrationDataQuery('')
                                        setWorkflowEvent((prevState: any) => {
                                            // Create a copy of the integrations_data object
                                            const newEventResourceDetails = { ...prevState.integrations_data };

                                            // Delete the specific properties
                                            delete newEventResourceDetails.event_resource_id;
                                            delete newEventResourceDetails.event_resource_title;
                                            delete newEventResourceDetails.resource_deleted

                                            // Return the updated state with the modified integrations_data
                                            return {
                                                active: true,
                                                integrations_data: newEventResourceDetails,
                                            };
                                        });
                                        setEventResourceString('');
                                    }}
                                >
                                    <div className={styles.ActiontypesDropdown}>
                                        <ContentDataSelector
                                            data={filteredintegrationData}
                                            onDataSelected={(value: any, data: any) => {
                                                setIntegrationDataQuery('');
                                                integrationHideDropdownResourceRef.current();
                                                const matchingItem = data
                                                setWorkflowEvent({
                                                    ...workflowEvent,
                                                    ...matchingItem,
                                                    'workflow_event_id': matchingItem.id,
                                                    'third_party_application_id': matchingItem.third_party_application_id,
                                                    'resource_name': (
                                                        matchingItem.options &&
                                                        matchingItem.options.resource_name
                                                    ) || matchingItem.category,
                                                    "event_resource_details": {
                                                        'external': matchingItem.external,
                                                        'options': matchingItem.options,
                                                        'third_party_application_id': matchingItem.third_party_application_id,
                                                        'category': matchingItem.category,
                                                    }
                                                });
                                            }}
                                            labelStyle={styles.eventResourceTypelabelStyle}
                                            elementContainerClass={styles.eventResourceTypelabelStyle__Dropdown}
                                            noResultsStringStyle={styles.noResultsStringStyle__integration}
                                        />
                                    </div>
                                </AppSelect>
                            </>
                        }

                        {/* Resource select other than lesson, forms and events, channel, subscription */}
                        {workflowEvent.event_resource_details &&
                            externalData &&
                            workflowEvent.slug !== 'course-content/complete' &&
                            workflowEvent.slug !== 'course-form/submitted' &&
                            workflowEvent.slug !== 'page_form/new_submission' &&
                            workflowEvent.slug !== 'event_rsvp/create' &&
                            workflowEvent.slug !== 'channel/new_member' &&
                            workflowEvent.slug !== 'channel/member_removed' &&
                            workflowEvent.slug !== "member/cancelled-subscription" &&
                            workflowEvent.slug !== "member/subscription-due" &&

                            <div className={styles.resourseSearch}>
                                <>
                                    {
                                        workflowEvent.event_resource_details.external ?
                                            <h1 className={styles.workflowCreation__sidebarTitle}>
                                                {
                                                    workflowEvent.event_resource_details.options &&
                                                        workflowEvent.event_resource_details.options.search &&
                                                        workflowEvent.event_resource_details.options.search.input_label
                                                        ?
                                                        workflowEvent.event_resource_details.options.search.input_label
                                                        :
                                                        ''
                                                }
                                                <small>{" "}*</small>
                                            </h1>
                                            :

                                            <h1 className={styles.workflowCreation__sidebarTitle}>
                                                {`Select ${workflowEvent.event_resource_details.category === 'landing-page'
                                                    ?
                                                    'landing page'
                                                    :
                                                    workflowEvent.event_resource_details.category === 'library-content'
                                                        ? 'content library' :
                                                        workflowEvent.event_resource_details.category === 'shopify'
                                                            ? 'shopify product'
                                                            : workflowEvent.event_resource_details.category === 'subscription'
                                                                ? 'subscription plan'
                                                                : workflowEvent.event_resource_details.category === 'onboarding'
                                                                    ? 'onboarding field'
                                                                    : workflowEvent.event_resource_details.category
                                                    }`}
                                                <small>{" "}*</small>
                                            </h1>
                                    }

                                </>

                                {/* Other resources other than lesson */}

                                <AppSelect
                                    popupStyles={{
                                        minHeight: '120px'
                                    }}
                                    inputClassName={`${styles.inputAction3} ${workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_title ? styles.inputAction3__withTitle : ''}`}
                                    containerClassName={`${styles.appSelectContainer} 
                                        ${((
                                            workflowEvent.event_resource_details &&
                                            workflowEvent.event_resource_details.event_resource_id
                                        ) === null) ||
                                            (
                                                workflowEvent.event_resource_details &&
                                                workflowEvent.event_resource_details.event_resource_id === undefined
                                            )
                                            ? styles.appSelectContainerWhite : ''}`}
                                    disabled={(workflowData.status === 'active') || (workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_id)}
                                    placeholder={
                                        workflowEvent.event_resource_details && workflowEvent.event_resource_details.external ?
                                            workflowEvent.event_resource_details.options &&
                                                workflowEvent.event_resource_details.options.search &&
                                                workflowEvent.event_resource_details.options.search.input_placeholder
                                                ?
                                                workflowEvent.event_resource_details.options.search.input_placeholder
                                                :
                                                ''
                                            :
                                            `Select or search ${workflowEvent.event_resource_details &&
                                                workflowEvent.event_resource_details.category === 'landing-page'
                                                ?
                                                'landing page'
                                                :
                                                workflowEvent.event_resource_details.category === 'library-content'
                                                    ?
                                                    'content library'
                                                    :
                                                    workflowEvent.event_resource_details.category === 'shopify'
                                                        ?
                                                        'shopify product'
                                                        :
                                                        workflowEvent.event_resource_details.category === 'subscription'
                                                            ?
                                                            'subscription plan'
                                                            : workflowEvent.event_resource_details.category === 'onboarding'
                                                                ? 'onboarding field'
                                                                :
                                                                workflowEvent.event_resource_details.category
                                            }
                                    `}
                                    hideDropdownRef={hideDropdownResourceRef}
                                    value={
                                        eventResourceString &&
                                            eventResourceString.trim() !== ''
                                            ?
                                            eventResourceString
                                            :
                                            // eventResourceString.length === 0
                                            //     ?
                                            //     ''
                                            //     :
                                            (workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_title) ?
                                                (workflowEvent.event_resource_details.event_resource_title.charAt(0).toUpperCase() + workflowEvent.event_resource_details.event_resource_title.slice(1))
                                                :
                                                ''
                                    }
                                    markRequired
                                    cursorPointer
                                    onChangeValue={(e: any) => setEventResourceString(e.target.value)}
                                    onRemoveSelectedValue={() => {
                                        setEventResourceString('');
                                        setWorkflowEvent((prevState: any) => {
                                            // Create a copy of the event_resource_details object
                                            const newEventResourceDetails = { ...prevState.event_resource_details };

                                            // Delete the specific properties
                                            delete newEventResourceDetails.event_resource_id;
                                            delete newEventResourceDetails.event_resource_title;
                                            delete newEventResourceDetails.resource_deleted

                                            // Return the updated state with the modified event_resource_details
                                            return {
                                                ...prevState,
                                                event_resource_details: newEventResourceDetails,
                                            };
                                        });

                                    }}
                                    XIconstyles={`${workflowEvent.event_resource_details.event_resource_id ? styles.XIconstylesEventResource : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                    inputIconClassName={`${styles.inputIconNameActionResource}
                                        ${workflowEvent.event_resource_details.event_resource_id && workflowEvent.event_resource_details.event_resource_id ? styles.inputIconNameActionNone : ""}`}
                                >
                                    {
                                        externalData &&
                                        workflowEvent.slug !== 'event_rsvp/create' &&
                                        workflowEvent.slug !== 'page_form/new_submission' &&
                                        workflowEvent.slug !== 'course-content/complete' &&
                                        workflowEvent.slug !== 'course-form/submitted'
                                        &&
                                        <div className={styles.ActiontypesDropdown}>
                                            <ContentDataSelector
                                                data={externalData && externalData}
                                                onDataSelected={(value: any, data: any) => {
                                                    setEventResourceString('');
                                                    hideDropdownResourceRef.current();
                                                    if (workflowEvent.slug === 'onboarding/field-submitted') {
                                                        setWorkflowEvent({
                                                            ...workflowEvent,
                                                            "event_resource_details": {
                                                                ...workflowEvent.event_resource_details,
                                                                'event_resource_title': data.label,
                                                                'event_resource_id': data.key,
                                                            }
                                                        });
                                                        return
                                                    }
                                                    const matchingItem = externalData.find((innerItem: any) => innerItem.id === data.id);
                                                    setWorkflowEvent({
                                                        ...workflowEvent,
                                                        "event_resource_details": {
                                                            ...workflowEvent.event_resource_details,
                                                            'event_resource_title': matchingItem.label,
                                                            'event_resource_id': matchingItem.id,
                                                        }
                                                    });
                                                }}
                                                labelStyle={styles.eventResourceTypelabelStyle}
                                                elementContainerClass={styles.eventResourceTypelabelStyle__Dropdown}
                                            />
                                        </div>
                                    }
                                </AppSelect>

                            </div>
                        }

                        {/* Resource select subscription */}
                        {
                            workflowEvent.event_resource_details &&
                            externalData &&
                            (
                                workflowEvent.slug === "member/cancelled-subscription" ||
                                workflowEvent.slug == "member/subscription-due"
                            ) &&

                            <div className={styles.resourseSearch}>
                                <h1 className={styles.workflowCreation__sidebarTitle}>
                                    {`Select subscription plan option`}
                                    <small>{" "}*</small>
                                </h1>

                                <AppSelect
                                    popupStyles={{
                                        minHeight: '100px'
                                    }}
                                    inputClassName={styles.inputAction3}
                                    containerClassName={`${styles.appSelectContainer} 
                                        ${((
                                            workflowEvent &&
                                            workflowEvent.plan_option
                                        ) === null) ||
                                            (
                                                workflowEvent &&
                                                workflowEvent.plan_option === undefined
                                            )
                                            ? styles.appSelectContainerWhite : ''}`}
                                    disabled={(workflowData.status === 'active') || (workflowEvent && workflowEvent.plan_option)}
                                    placeholder={`Select option`}
                                    hideDropdownRef={SubhideDropdownResourceRef}
                                    value={
                                        (workflowEvent.plan_option && workflowEvent.plan_option) ?
                                            (workflowEvent.plan_option.charAt(0).toUpperCase() + workflowEvent.plan_option.slice(1))
                                            :
                                            ''
                                    }
                                    noCaret
                                    markRequired
                                    cursorPointer
                                    onRemoveSelectedValue={() => {
                                        setEventResourceString('');
                                        setWorkflowEvent((prevState: any) => {
                                            // Create a copy of the event_resource_details object
                                            const newEventResourceDetails = { ...prevState.event_resource_details };

                                            // Delete the specific properties
                                            delete prevState.plan_option;
                                            delete newEventResourceDetails.event_resource_id;
                                            delete newEventResourceDetails.event_resource_title;
                                            delete newEventResourceDetails.resource_deleted

                                            // Return the updated state with the modified event_resource_details
                                            return {
                                                ...prevState,
                                                event_resource_details: newEventResourceDetails,
                                            };
                                        });

                                    }}
                                    XIconstyles={`${workflowEvent.plan_option ? styles.XIconstylesEventResource : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                    inputIconClassName={`${styles.inputIconNameActionResource}
                                        ${workflowEvent && workflowEvent.plan_option ? styles.inputIconNameActionNone : ""}`}
                                >
                                    {
                                        externalData &&
                                        <div className={styles.ActiontypesDropdown}>
                                            <ContentDataSelector
                                                data={subscriptionOptions()}
                                                onDataSelected={(value: any, data: any) => {
                                                    SubhideDropdownResourceRef.current();
                                                    setWorkflowEvent({
                                                        ...workflowEvent,
                                                        'plan_option': value,
                                                    });
                                                }}
                                                labelStyle={styles.eventResourceTypelabelStyle}
                                                elementContainerClass={styles.eventResourceTypelabelStyle__Dropdown}
                                            />
                                        </div>
                                    }
                                </AppSelect>

                            </div>
                        }

                        {/* subscription plan selection */}
                        {
                            workflowEvent.event_resource_details &&
                            externalData &&
                            workflowEvent.plan_option === 'specific subscription' &&
                            <SubscriptionPlanSelection
                                workflowEvent={workflowEvent}
                                externalData={externalData}
                                eventResourceString={eventResourceString}
                                setEventResourceString={setEventResourceString}
                                setWorkflowEvent={setWorkflowEvent} />
                        }

                        {/* course for lessson section */}
                        {
                            workflowEvent.event_resource_details &&
                            externalData &&
                            (
                                workflowEvent.slug === 'course-content/complete' ||
                                workflowEvent.slug === 'course-form/submitted'
                            ) &&

                            <div className={styles.resourseSearch}>
                                <h1 className={styles.workflowCreation__sidebarTitle}>
                                    {`Select course`}
                                    <small>{" "}*</small>
                                </h1>

                                <AppSelect
                                    popupStyles={{
                                        minHeight: '120px'
                                    }}
                                    containerClassName={`${styles.appSelectContainer} 
                                                            ${((
                                            workflowEvent.event_resource_details &&
                                            workflowEvent.event_resource_details.parent_event_resource_id
                                        ) === null) ||
                                            (
                                                workflowEvent.event_resource_details &&
                                                workflowEvent.event_resource_details.parent_event_resource_id === undefined
                                            )
                                            ? styles.appSelectContainerWhite : ''}`}
                                    inputClassName={styles.inputAction3}
                                    disabled={(workflowData.status === 'active') || (workflowEvent.event_resource_details && workflowEvent.event_resource_details.parent_event_resource_id)}
                                    placeholder={`Select or search course`}
                                    hideDropdownRef={coursehideDropdownResourceRef}
                                    value={
                                        eventResourceString &&
                                            eventResourceString.trim() !== ''
                                            ?
                                            eventResourceString
                                            :
                                            // eventResourceString.length === 0
                                            //     ?
                                            //     ''
                                            //     :
                                            (workflowEvent.event_resource_details && workflowEvent.event_resource_details.parent_event_resource_name) ?
                                                (workflowEvent.event_resource_details.parent_event_resource_name.charAt(0).toUpperCase() + workflowEvent.event_resource_details.parent_event_resource_name.slice(1))
                                                :
                                                ''
                                    }
                                    markRequired
                                    cursorPointer
                                    onChangeValue={(e: any) => setEventResourceString(e.target.value)}
                                    onRemoveSelectedValue={() => {
                                        setEventResourceString('');
                                        setWorkflowEvent((prevState: any) => {
                                            // Create a copy of the event_resource_details object
                                            const newEventResourceDetails = { ...prevState.event_resource_details };

                                            // Delete the specific properties
                                            delete newEventResourceDetails.event_resource_id;
                                            delete newEventResourceDetails.event_resource_title;
                                            delete newEventResourceDetails.parent_event_resource_id;
                                            delete newEventResourceDetails.parent_event_resource_name;

                                            // Return the updated state with the modified event_resource_details
                                            return {
                                                ...prevState,
                                                event_resource_details: newEventResourceDetails,
                                            };
                                        });

                                    }}
                                    XIconstyles={`${workflowEvent.event_resource_details.parent_event_resource_id ? styles.XIconstylesEventResource : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                    inputIconClassName={`${styles.inputIconNameActionResource}
                                            ${workflowEvent.event_resource_details.parent_event_resource_id && workflowEvent.event_resource_details.parent_event_resource_id ? styles.inputIconNameActionNone : ""}`}
                                >

                                    {
                                        externalData &&
                                        // externalData.length > 0 &&
                                        (workflowEvent.slug === 'course-content/complete' ||
                                            workflowEvent.slug === 'course-form/submitted')
                                        &&
                                        <div className={styles.ActiontypesDropdown}>
                                            <ContentDataSelector
                                                data={externalData && externalData}
                                                onDataSelected={(value: any, data: any) => {
                                                    setEventResourceString('');
                                                    coursehideDropdownResourceRef.current();
                                                    const matchingItem = externalData.find((innerItem: any) => innerItem.id === data.id);

                                                    setWorkflowEvent({
                                                        ...workflowEvent,
                                                        "event_resource_details": {
                                                            ...workflowEvent.event_resource_details,
                                                            'parent_event_resource_name': matchingItem.label,
                                                            'parent_event_resource_id': matchingItem.id,
                                                        }
                                                    });
                                                }}
                                                // searchString={eventResourceString}
                                                labelStyle={styles.eventResourceTypelabelStyle}
                                                elementContainerClass={styles.eventResourceTypelabelStyle__Dropdown}
                                            />
                                        </div>
                                    }

                                </AppSelect>

                            </div>
                        }

                        {/* lesson section */}
                        {
                            lessonData &&
                            (workflowEvent.slug === 'course-content/complete' ||
                                workflowEvent.slug === 'course-form/submitted')
                            &&
                            workflowEvent.event_resource_details.parent_event_resource_id &&
                            <div className={styles.resourseSearch}>
                                {
                                    <h1 className={styles.workflowCreation__sidebarTitle}>
                                        {
                                            workflowEvent.slug === 'course-content/complete'
                                                ?
                                                `Select lesson`
                                                :
                                                `Select form`
                                        }
                                        <small>{" "}*</small>
                                    </h1>
                                }
                                <AppSelect
                                    popupStyles={{
                                        minHeight: '100px'
                                    }}
                                    containerClassName={`${styles.appSelectContainer} 
                                        ${((
                                            workflowEvent.event_resource_details &&
                                            workflowEvent.event_resource_details.event_resource_id
                                        ) === null) ||
                                            (
                                                workflowEvent.event_resource_details &&
                                                workflowEvent.event_resource_details.event_resource_id === undefined
                                            )
                                            ? styles.appSelectContainerWhite : ''}`}
                                    disabled={(workflowData.status === 'active') || (workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_id)}
                                    placeholder={
                                        workflowEvent.slug === 'course-content/complete'
                                            ?
                                            `Select or search lesson`
                                            :
                                            `Select or search form`
                                    }
                                    hideDropdownRef={hideDropdownResourceRef}
                                    value={
                                        lessonString &&
                                            lessonString.trim() !== ''
                                            ?
                                            lessonString
                                            :
                                            // lessonString.length === 0
                                            //     ?
                                            //     ''
                                            //     :
                                            (workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_title) ?
                                                (workflowEvent.event_resource_details.event_resource_title.charAt(0).toUpperCase() + workflowEvent.event_resource_details.event_resource_title.slice(1))
                                                :
                                                ''
                                    }
                                    markRequired
                                    cursorPointer
                                    onChangeValue={(e: any) => setLessonString(e.target.value)}
                                    inputClassName={styles.inputAction3}
                                    onRemoveSelectedValue={() => {
                                        setLessonString('');
                                        setWorkflowEvent((prevState: any) => {
                                            // Create a copy of the event_resource_details object
                                            const newEventResourceDetails = { ...prevState.event_resource_details };

                                            // Delete the specific properties
                                            delete newEventResourceDetails.event_resource_id;
                                            delete newEventResourceDetails.event_resource_title;
                                            delete newEventResourceDetails.resource_deleted
                                            // Return the updated state with the modified event_resource_details
                                            return {
                                                ...prevState,
                                                event_resource_details: newEventResourceDetails,
                                            };
                                        });

                                    }}
                                    XIconstyles={`${workflowEvent.event_resource_details.event_resource_id ? styles.XIconstylesEventResource : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                    inputIconClassName={`${styles.inputIconNameActionResource}
                                    ${workflowEvent.event_resource_details.event_resource_id && workflowEvent.event_resource_details.event_resource_id ? styles.inputIconNameActionNone : ""}`}
                                >
                                    <div className={styles.LessonsDropdown}>
                                        <WorkflowDataSelector
                                            data={lessonData && lessonData}
                                            onDataSelected={(value: any, data: any) => {
                                                // const matchingItem = item.contents.find((innerItem: any) => innerItem.id === data.id);
                                                const matchingItem = data

                                                setLessonString(' ');
                                                hideDropdownResourceRef.current();
                                                setWorkflowEvent({
                                                    ...workflowEvent,
                                                    "event_resource_details": {
                                                        ...workflowEvent.event_resource_details,
                                                        'event_resource_title': matchingItem.title,
                                                        'event_resource_id': matchingItem.id,
                                                        'third_party_application_id': null,
                                                    }
                                                });
                                            }}
                                            searchString={lessonString}
                                            labelStyle={styles.labelStyle}
                                            elementContainerClass={styles.workflowActionEl}
                                            containerClassName={styles.DropdownSpacing}
                                        />

                                    </div>
                                </AppSelect>
                            </div>
                        }

                        {/* landing page section */}
                        {workflowEvent.event_resource_details &&
                            externalData &&
                            workflowEvent.slug === 'page_form/new_submission' &&

                            <div className={styles.resourseSearch}>
                                <h1 className={styles.workflowCreation__sidebarTitle}>
                                    {`Select Landing Page`}
                                    <small>{" "}*</small>
                                </h1>
                                <AppSelect
                                    popupStyles={{
                                        minHeight: '120px'
                                    }}
                                    inputClassName={styles.inputAction3}
                                    containerClassName={`${styles.appSelectContainer} 
                                    ${((
                                            workflowEvent.event_resource_details &&
                                            workflowEvent.event_resource_details.parent_event_resource_id
                                        ) === null) ||
                                            (
                                                workflowEvent.event_resource_details &&
                                                workflowEvent.event_resource_details.parent_event_resource_id === undefined
                                            )
                                            ? styles.appSelectContainerWhite : ''}`}
                                    disabled={(workflowData.status === 'active') || (workflowEvent.event_resource_details && workflowEvent.event_resource_details.parent_event_resource_id)}
                                    placeholder={`Select or search landing page`}
                                    hideDropdownRef={ladingPageHideDropdownResourceRef}
                                    value={
                                        eventResourceString &&
                                            eventResourceString.trim() !== ''
                                            ?
                                            eventResourceString
                                            :
                                            // eventResourceString.length === 0
                                            //     ?
                                            //     ''
                                            //     :
                                            (workflowEvent.event_resource_details && workflowEvent.event_resource_details.parent_event_resource_name) ?
                                                (workflowEvent.event_resource_details.parent_event_resource_name.charAt(0).toUpperCase() + workflowEvent.event_resource_details.parent_event_resource_name.slice(1))
                                                :
                                                ''
                                    }
                                    markRequired
                                    cursorPointer
                                    onChangeValue={(e: any) => setEventResourceString(e.target.value)}
                                    onRemoveSelectedValue={() => {
                                        setEventResourceString('');
                                        setWorkflowEvent((prevState: any) => {
                                            // Create a copy of the event_resource_details object
                                            const newEventResourceDetails = { ...prevState.event_resource_details };

                                            // Delete the specific properties
                                            delete newEventResourceDetails.event_resource_id;
                                            delete newEventResourceDetails.event_resource_title;
                                            delete newEventResourceDetails.parent_event_resource_id;
                                            delete newEventResourceDetails.parent_event_resource_name;
                                            delete newEventResourceDetails.resource_deleted

                                            // Return the updated state with the modified event_resource_details
                                            return {
                                                ...prevState,
                                                event_resource_details: newEventResourceDetails,
                                            };
                                        });

                                    }}
                                    XIconstyles={`${workflowEvent.event_resource_details.parent_event_resource_id ? styles.XIconstylesEventResource : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                    inputIconClassName={`${styles.inputIconNameActionResource}
                                        ${workflowEvent.event_resource_details.parent_event_resource_id && workflowEvent.event_resource_details.parent_event_resource_id ? styles.inputIconNameActionNone : ""}`}
                                >

                                    {
                                        externalData &&
                                        workflowEvent.slug === 'page_form/new_submission' &&
                                        <div className={styles.ActiontypesDropdown}>
                                            <ContentDataSelector
                                                data={externalData && externalData}
                                                onDataSelected={(value: any, data: any) => {
                                                    setEventResourceString('');
                                                    ladingPageHideDropdownResourceRef.current();
                                                    const matchingItem = externalData.find((innerItem: any) => innerItem.id === data.id);

                                                    setWorkflowEvent({
                                                        ...workflowEvent,
                                                        "event_resource_details": {
                                                            ...workflowEvent.event_resource_details,
                                                            'parent_event_resource_name': matchingItem.label,
                                                            'parent_event_resource_id': matchingItem.id,
                                                        }
                                                    });
                                                }}
                                                // searchString={eventResourceString}
                                                labelStyle={styles.eventResourceTypelabelStyle}
                                                elementContainerClass={styles.eventResourceTypelabelStyle__Dropdown}
                                            />
                                        </div>
                                    }

                                </AppSelect>
                            </div>
                        }

                        {/* form selection */}
                        {
                            landingPageEventData &&
                            workflowEvent.slug === 'page_form/new_submission' &&
                            workflowEvent.event_resource_details.parent_event_resource_id &&
                            <div className={styles.resourseSearch}>
                                {
                                    <h1 className={styles.workflowCreation__sidebarTitle}>
                                        {`Select form`}
                                        <small>{" "}*</small>
                                    </h1>
                                }

                                <AppSelect
                                    popupStyles={{
                                        minHeight: '100px'
                                    }}
                                    containerClassName={`${styles.appSelectContainer} 
                                        ${((
                                            workflowEvent.event_resource_details &&
                                            workflowEvent.event_resource_details.event_resource_id
                                        ) === null) ||
                                            (
                                                workflowEvent.event_resource_details &&
                                                workflowEvent.event_resource_details.event_resource_id === undefined
                                            )

                                            ? styles.appSelectContainerWhite : ''}`}

                                    disabled={(workflowData.status === 'active') || (workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_title)}
                                    placeholder={`Select or search form `}
                                    hideDropdownRef={hideDropdownResourceRef}
                                    value={

                                        landingPageString &&
                                            landingPageString.trim() !== ''
                                            ?
                                            landingPageString
                                            :
                                            (workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_title) ?
                                                (workflowEvent.event_resource_details.event_resource_title.charAt(0).toUpperCase() + workflowEvent.event_resource_details.event_resource_title.slice(1))
                                                :
                                                ''
                                    }
                                    markRequired
                                    cursorPointer
                                    onChangeValue={(e: any) => setLandingPageString(e.target.value)}
                                    inputClassName={styles.inputAction3}
                                    onRemoveSelectedValue={() => {
                                        setLandingPageString('');
                                        setWorkflowEvent((prevState: any) => {
                                            // Create a copy of the event_resource_details object
                                            const newEventResourceDetails = { ...prevState.event_resource_details };

                                            // Delete the specific properties
                                            delete newEventResourceDetails.event_resource_id;
                                            delete newEventResourceDetails.event_resource_title;
                                            delete newEventResourceDetails.resource_deleted

                                            return {
                                                ...prevState,
                                                event_resource_details: newEventResourceDetails,
                                            };
                                        });

                                    }}
                                    XIconstyles={`${workflowEvent.event_resource_details.event_resource_title &&
                                        workflowEvent.event_resource_details.event_resource_title ? styles.XIconstylesEventResource : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                    inputIconClassName={`${styles.inputIconNameActionResource}
                                    ${workflowEvent.event_resource_details.event_resource_title && workflowEvent.event_resource_details.event_resource_title ? styles.inputIconNameActionNone : ""}`}
                                >
                                    <div className={styles.LessonsDropdown}>

                                        <ContentDataSelector
                                            data={landingPageEventData && landingPageEventData}
                                            onDataSelected={(value: any, data: any) => {
                                                setLandingPageString(' ');
                                                hideDropdownResourceRef.current();
                                                const matchingItem = landingPageEventData.find((innerItem: any) => innerItem.id === data.id);
                                                setWorkflowEvent({
                                                    ...workflowEvent,
                                                    "event_resource_details": {
                                                        ...workflowEvent.event_resource_details,
                                                        'event_resource_title': matchingItem.label,
                                                        'event_resource_id': matchingItem.id,
                                                        'third_party_application_id': matchingItem.third_party_application_id,
                                                        'leadable_type': matchingItem.leadable_type,
                                                    }
                                                });
                                            }}
                                            searchString={landingPageString}
                                            labelStyle={styles.labelStyle}
                                            elementContainerClass={styles.workflowActionEl}
                                            containerClassName={styles.DropdownSpacing}
                                        />


                                    </div>
                                </AppSelect>

                                {
                                    workflowEvent &&
                                    workflowEvent.event_resource_details &&
                                    workflowEvent.event_resource_details.event_resource_title &&
                                    !workflowEvent.event_resource_details.event_resource_id &&
                                    <div className={styles.emailIsRequired}>
                                        <DangerIcon />
                                        <span>
                                            Mark form email field as required.
                                        </span>

                                    </div>
                                }
                            </div>
                        }

                        {/* Event selection */}
                        {workflowEvent.event_resource_details && workflowEvent.slug === 'event_rsvp/create' &&
                            <div className={styles.resourseSearch}>

                                {
                                    <h1 className={styles.workflowCreation__sidebarTitle}>
                                        {`Select Event`}
                                        <small>{" "}*</small>
                                    </h1>
                                }

                                <AppSelect
                                    popupStyles={{
                                        minHeight: '100px'
                                    }}
                                    disabled={(workflowData.status === 'active') || (workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_id)}
                                    containerClassName={`
                                    ${((
                                            workflowEvent.event_resource_details &&
                                            workflowEvent.event_resource_details.event_resource_id
                                        ) === null) ||
                                            (
                                                workflowEvent.event_resource_details &&
                                                workflowEvent.event_resource_details.event_resource_id === undefined
                                            )

                                            ? styles.appSelectContainerWhite : ''}`}
                                    placeholder={`Select or search event`}
                                    hideDropdownRef={hideDropdownResourceRef}
                                    value={
                                        eventResourceString &&
                                            eventResourceString.trim() !== ''
                                            ?
                                            eventResourceString
                                            :
                                            // eventResourceString.length === 0
                                            //     ?
                                            //     ''
                                            //     :
                                            (workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_title) ?
                                                (workflowEvent.event_resource_details.event_resource_title.charAt(0).toUpperCase() + workflowEvent.event_resource_details.event_resource_title.slice(1))
                                                :
                                                ''
                                    }
                                    markRequired
                                    cursorPointer
                                    onChangeValue={(e: any) => setEventResourceString(e.target.value)}
                                    inputClassName={styles.inputActionTrigger}
                                    onRemoveSelectedValue={() => {
                                        setLandingPageString('');
                                        setWorkflowEvent((prevState: any) => {
                                            // Create a copy of the event_resource_details object
                                            const newEventResourceDetails = { ...prevState.event_resource_details };

                                            // Delete the specific properties
                                            delete newEventResourceDetails.event_resource_id;
                                            delete newEventResourceDetails.event_resource_title;
                                            delete newEventResourceDetails.resource_deleted

                                            // Return the updated state with the modified event_resource_details
                                            return {
                                                ...prevState,
                                                event_resource_details: newEventResourceDetails,
                                            };
                                        });

                                    }}
                                    XIconstyles={`${workflowEvent.event_resource_details.event_resource_id ? styles.XIconstylesEventResource : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                    inputIconClassName={`${styles.inputIconNameActionResource}
                                    ${workflowEvent.event_resource_details.event_resource_id && workflowEvent.event_resource_details.event_resource_id ? styles.inputIconNameActionNone : ""}`}
                                >
                                    {workflowEvent.slug === 'event_rsvp/create' &&
                                        <EventsSelector
                                            group={group}
                                            onEventSelected={(event: any) => {
                                                setEventResourceString('');
                                                hideDropdownResourceRef.current();
                                                setWorkflowEvent({
                                                    ...workflowEvent,
                                                    "event_resource_details": {
                                                        ...workflowEvent.event_resource_details,
                                                        'event_resource_title': event.title,
                                                        'event_resource_id': event.id,
                                                        'third_party_application_id': null,
                                                    }
                                                });
                                            }}
                                            searchString={eventResourceString}
                                        />
                                    }
                                </AppSelect>

                            </div>
                        }


                        {/* Channel selections */}
                        {
                            workflowEvent.event_resource_details &&
                            (
                                (workflowEvent.slug === 'channel/new_member') ||
                                (workflowEvent.slug === 'channel/member_removed')
                            )
                            &&
                            <div className={styles.resourseSearch}>

                                {
                                    <h1 className={styles.workflowCreation__sidebarTitle}>
                                        {`Select Channel`}
                                        <small>{" "}*</small>
                                    </h1>
                                }

                                <AppSelect
                                    popupStyles={{
                                        minHeight: '100px'
                                    }}
                                    disabled={(workflowData.status === 'active') || (workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_id)}
                                    containerClassName={`
                                        ${((
                                            workflowEvent.event_resource_details &&
                                            workflowEvent.event_resource_details.event_resource_id
                                        ) === null) ||
                                            (
                                                workflowEvent.event_resource_details &&
                                                workflowEvent.event_resource_details.event_resource_id === undefined
                                            )

                                            ? styles.appSelectContainerWhite : ''}`}
                                    placeholder={`Select or search channel`}
                                    hideDropdownRef={hideDropdownResourceRef}
                                    value={
                                        eventResourceString &&
                                            eventResourceString.trim() !== ''
                                            ?
                                            eventResourceString
                                            :
                                            // eventResourceString.length === 0
                                            //     ?
                                            //     ''
                                            //     :
                                            (workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_title) ?
                                                (workflowEvent.event_resource_details.event_resource_title.charAt(0).toUpperCase() + workflowEvent.event_resource_details.event_resource_title.slice(1))
                                                :
                                                ''
                                    }
                                    markRequired
                                    cursorPointer
                                    onChangeValue={(e: any) => setEventResourceString(e.target.value)}
                                    inputClassName={styles.inputActionTrigger}
                                    onRemoveSelectedValue={() => {
                                        setLandingPageString('');
                                        setWorkflowEvent((prevState: any) => {
                                            // Create a copy of the event_resource_details object
                                            const newEventResourceDetails = { ...prevState.event_resource_details };

                                            // Delete the specific properties
                                            delete newEventResourceDetails.event_resource_id;
                                            delete newEventResourceDetails.event_resource_title;
                                            delete newEventResourceDetails.resource_deleted

                                            // Return the updated state with the modified event_resource_details
                                            return {
                                                ...prevState,
                                                event_resource_details: newEventResourceDetails,
                                            };
                                        });

                                    }}
                                    XIconstyles={`${workflowEvent.event_resource_details.event_resource_id ? styles.XIconstylesEventResource : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                    inputIconClassName={`${styles.inputIconNameActionResource}
                                    ${workflowEvent.event_resource_details.event_resource_id && workflowEvent.event_resource_details.event_resource_id ? styles.inputIconNameActionNone : ""}`}
                                >
                                    {
                                        (
                                            workflowEvent.slug === 'channel/new_member' ||
                                            workflowEvent.slug === 'channel/member_removed'
                                        ) &&
                                        <ChannelSelector
                                            group={group}
                                            onChannelSelected={(channel: any) => {
                                                setEventResourceString('');
                                                hideDropdownResourceRef.current();
                                                setWorkflowEvent({
                                                    ...workflowEvent,
                                                    "event_resource_details": {
                                                        ...workflowEvent.event_resource_details,
                                                        'event_resource_title': channel.name,
                                                        'event_resource_id': channel.id,
                                                        'third_party_application_id': null,
                                                    }
                                                });
                                            }}
                                            searchString={eventResourceString}
                                            excludeArchived
                                        />
                                    }
                                </AppSelect>

                            </div>
                        }
                    </>
                }
                actionType={workflowEvent}
            />
        </div>
    )
}

const SubscriptionPlanSelection = ({
    workflowEvent,
    externalData,
    eventResourceString,
    setEventResourceString,
    setWorkflowEvent
}: {
    workflowEvent: any
    externalData: any
    eventResourceString: any
    setEventResourceString: any
    setWorkflowEvent: any
}
) => {
    const { workflowData, } = React.useContext(WorkflowCreationContext);
    const hideDropdownResourceRef = React.useRef<any>(null);


    return (
        <div>
            {
                workflowEvent.event_resource_details &&
                externalData &&
                (
                    workflowEvent.slug === "member/cancelled-subscription" ||
                    workflowEvent.slug == "member/subscription-due"
                ) &&

                <div className={styles.resourseSearch}>
                    <h1 className={styles.workflowCreation__sidebarTitle}>
                        {`Select subscription plan`}
                        <small>{" "}*</small>
                    </h1>

                    <AppSelect
                        popupStyles={{
                            minHeight: '120px'
                        }}
                        inputClassName={styles.inputAction3}
                        containerClassName={`${styles.appSelectContainer} 
                                        ${((
                                workflowEvent.event_resource_details &&
                                workflowEvent.event_resource_details.event_resource_id
                            ) === null) ||
                                (
                                    workflowEvent.event_resource_details &&
                                    workflowEvent.event_resource_details.event_resource_id === undefined
                                )
                                ? styles.appSelectContainerWhite : ''}`}
                        disabled={(workflowData.status === 'active') || (workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_id)}
                        placeholder={`Select or search subscription plan`}
                        hideDropdownRef={hideDropdownResourceRef}
                        value={
                            eventResourceString &&
                                eventResourceString.trim() !== ''
                                ?
                                eventResourceString
                                :
                                // eventResourceString.length === 0
                                //     ?
                                //     ''
                                //     :
                                (workflowEvent.event_resource_details && workflowEvent.event_resource_details.event_resource_title) ?
                                    (workflowEvent.event_resource_details.event_resource_title.charAt(0).toUpperCase() + workflowEvent.event_resource_details.event_resource_title.slice(1))
                                    :
                                    ''
                        }
                        markRequired
                        cursorPointer
                        onChangeValue={(e: any) => setEventResourceString(e.target.value)}
                        onRemoveSelectedValue={() => {
                            setEventResourceString('');
                            setWorkflowEvent((prevState: any) => {
                                // Create a copy of the event_resource_details object
                                const newEventResourceDetails = { ...prevState.event_resource_details };

                                // Delete the specific properties
                                delete newEventResourceDetails.event_resource_id;
                                delete newEventResourceDetails.event_resource_title;
                                delete newEventResourceDetails.resource_deleted
                                // Return the updated state with the modified event_resource_details
                                return {
                                    ...prevState,
                                    event_resource_details: newEventResourceDetails,
                                };
                            });

                        }}
                        XIconstyles={`${workflowEvent.event_resource_details.event_resource_id ? styles.XIconstylesEventResource : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                        inputIconClassName={`${styles.inputIconNameActionResource}
                                        ${workflowEvent.event_resource_details.event_resource_id && workflowEvent.event_resource_details.event_resource_id ? styles.inputIconNameActionNone : ""}`}
                    >

                        <div className={styles.ActiontypesDropdown}>
                            <ContentDataSelector
                                data={externalData && externalData}
                                onDataSelected={(value: any, data: any) => {
                                    setEventResourceString('');
                                    hideDropdownResourceRef.current();
                                    const matchingItem = externalData.find((innerItem: any) => innerItem.id === data.id);
                                    setWorkflowEvent({
                                        ...workflowEvent,
                                        "event_resource_details": {
                                            ...workflowEvent.event_resource_details,
                                            'event_resource_title': matchingItem.label,
                                            'event_resource_id': matchingItem.id,
                                        }
                                    });
                                }}
                                labelStyle={styles.eventResourceTypelabelStyle}
                                elementContainerClass={styles.eventResourceTypelabelStyle__Dropdown}
                            />
                        </div>
                    </AppSelect>

                </div>
            }
        </div>

    )
}

const TimeDelay = (
    {
        topActionsDetails,
        setTopActionsDetails,
        actionToBeEdited
    }: {
        topActionsDetails: any
        setTopActionsDetails: any
        actionToBeEdited: any
    }
) => {
    const hideAccessDurationDropdownRef = React.useRef();
    const {
        workflowData,
    } = React.useContext(WorkflowCreationContext);

    const getAccessDurationUnitData = () => {
        return [
            {
                label: `Minutes`,
                value: 'minutes',
            },
            {
                label: `Hours`,
                value: 'hours',
            },
            {
                label: `Days`,
                value: 'days',
            },
        ]
    }


    return (
        <div className={styles.delay}>


            <div className={styles.delay__number}>
                <h1 className={styles.timeDelayTitle}>
                    {`Add time delay`}
                    <small>{" "}*</small>
                </h1>

                <p> Wait for {" "}<small>*</small></p>
                <input
                    disabled={(workflowData.status === 'active')}
                    type="number"
                    form-datatype="number"
                    placeholder='Enter a number'
                    value={topActionsDetails && topActionsDetails.display_delay_in_minutes}
                    onChange={(e: any) => {
                        const value = e.target.value;
                        setTopActionsDetails((prevDetails: any) => ({
                            ...prevDetails, // Spread previous details to preserve existing data
                            'active': true,
                            'executed_resource_name': `${value} ${topActionsDetails.delay_period_name}`,
                            'delay_in_minutes': topActionsDetails.delay_period_name === 'hours' ? Number(value) * 60 : topActionsDetails.delay_period_name === 'days' ? Number(value) * 1440 : Number(value),
                            'delay_period_name': topActionsDetails.delay_period_name,
                            'display_delay_in_minutes': value,
                            "action_details": {
                                'delay_in_minutes': value,
                                'delay_period_name': topActionsDetails.delay_period_name,
                            },
                        }));
                    }}
                    onKeyDown={(e: any) => {
                        const isAllowedCharacter = /^[a-zA-Z0-9-_]$/.test(e.key) || e.keyCode === 8;
                        if (!isAllowedCharacter) {
                            e.preventDefault();
                        }

                        if (e.key === '.' || e.key === '-' || e.key === '+') {
                            e.preventDefault();
                        }

                        if (e.key === 'ArrowDown' && Number(e.target.value) < 0) {
                            e.preventDefault();
                        }
                    }}

                />
            </div>

            <div className={styles.delay__time}>
                <AppSelect
                    popupStyles={{
                        minHeight: '100px'
                    }}
                    inputClassName={styles.inputActionTrigger}

                    disabled={(workflowData.status === 'active')}
                    placeholder="Select time"
                    hideDropdownRef={hideAccessDurationDropdownRef}
                    value={topActionsDetails && `${topActionsDetails.delay_period_name && topActionsDetails.delay_period_name.charAt(0).toUpperCase()}${topActionsDetails.delay_period_name.slice(1)}`}
                    noCaret
                    cursorPointer
                    inputIconClassName={`${styles.inputIconNameActionResource2} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                >
                    <ContentDataSelector
                        data={getAccessDurationUnitData()}
                        onDataSelected={(selectedData: any) => {
                            //@ts-ignore
                            hideAccessDurationDropdownRef.current();

                            // Convert delay_in_minutes based on the selected unit
                            const currentDelayInMinutes = topActionsDetails.display_delay_in_minutes;
                            let convertedDelayInMinutes: any;

                            switch (selectedData) {
                                case 'hours':
                                    convertedDelayInMinutes = Number(currentDelayInMinutes) * 60;
                                    break;
                                case 'days':
                                    convertedDelayInMinutes = Number(currentDelayInMinutes) * 1440;
                                    break;
                                default: // 'minutes'
                                    convertedDelayInMinutes = Number(currentDelayInMinutes);
                                    break;
                            }

                            setTopActionsDetails((prevDetails: any) => ({
                                ...prevDetails,
                                'active': true,
                                'executed_resource_name': `${currentDelayInMinutes} ${selectedData}`,
                                'delay_period_name': selectedData,
                                'delay_in_minutes': convertedDelayInMinutes,
                                "action_details": {
                                    'delay_in_minutes': convertedDelayInMinutes,
                                    'delay_period_name': selectedData,
                                },
                            }));
                        }}
                    />
                </AppSelect>
            </div>
        </div>
    )
}

const DirectMessageEditor = (
    {
        group,
        topActionsDetails,
        setTopActionsDetails
    }
        :
        {
            group: any,
            topActionsDetails: any
            setTopActionsDetails: any,
        }
) => {
    const hideDropdownResourceRef = React.useRef<any>(null);
    const inputRef = React.useRef<any>(null);

    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [teamMembers, setTeamMembers] = React.useState<any>([]);
    const [searchString, setSearchString] = React.useState<string>("");

    const [emailData, setEmailData] = React.useState<any>({
        send_as: topActionsDetails && topActionsDetails.send_as,
        message: topActionsDetails && topActionsDetails.message,
        executed_resource_name: topActionsDetails && topActionsDetails.executed_resource_name,
    })

    const {
        workflowData, eventAndActionsMergeTags, saveMergetagsUsed,
        updateMergeTagsWhenDeleteOnString,
        updateMergeTagsByResourceKey
    } = React.useContext(WorkflowCreationContext);
    const [emailDataToBeEdited, setEmailDataToBeEdited] = React.useState<any>(emailData);

    useEffect(() => {
        setEmailData({
            message: topActionsDetails && topActionsDetails.message,
            send_as: topActionsDetails && topActionsDetails.send_as,
            executed_resource_name: topActionsDetails && topActionsDetails.executed_resource_name,
        })

    }, [
        topActionsDetails && topActionsDetails.message,
        topActionsDetails && topActionsDetails.send_as,
        topActionsDetails && topActionsDetails.executed_resource_name,
    ])

    const getTeamMembers = () => {
        let query: string = ``;
        if (searchString.length > 0) {
            query = `?search=${searchString}`;
        }
        TeamService.getInstance()
            .getTeamMembers(group.id, query)
            .then((response: any) => {
                const excludeModerators = response.data.data.filter((item: any) => item.role_id !== 3);
                setTeamMembers(excludeModerators);
            }).catch((error: any) => console.error(error))
            .finally(() => {

            })
    };

    useEffect(() => {
        getTeamMembers();
    }, [searchString])

    const discardChanges = () => {
        setIsOpen(false);
        setEmailDataToBeEdited(emailData);
    }


    const saveChanges = () => {
        if ((emailDataToBeEdited.send_as === undefined) || Boolean(emailDataToBeEdited && emailDataToBeEdited.send_as === null)) {
            toast("Sender is required.", {
                type: 'error',
                autoClose: 3000,
                position: "top-center",
                hideProgressBar: true,
                theme: "light"
            });
            return;
        }

        if ((emailDataToBeEdited.message === undefined) || Boolean((miscUtils.stripHTML(emailDataToBeEdited.message) as string).trim() === '')) {
            toast("Message content is required.", {
                type: 'error',
                autoClose: 3000,
                position: "top-center",
                hideProgressBar: true,
                theme: "light"
            });
            return;
        }

        setIsOpen(false);
        setTopActionsDetails((prevDetails: any) => ({
            ...prevDetails,
            active: true,
            'executed_resource_name': emailDataToBeEdited.executed_resource_name,
            'message': emailDataToBeEdited.message,
            send_as: emailDataToBeEdited.send_as,
            action_details: {
                'message': emailDataToBeEdited.message,
                'send_as': emailDataToBeEdited.send_as,
            }
        }));

        saveMergetagsUsed()
        setTimeout(() => {
            updateMergeTagsWhenDeleteOnString(emailDataToBeEdited && miscUtils.stripHTML(emailDataToBeEdited.message), topActionsDetails.randomID)
        }, 1000)

        setEmailData(emailDataToBeEdited);
        toast("Message edited successfully.", {
            type: 'success',
            autoClose: 2000,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
        });
    }

    const EmailSubjectIsNone = () => {
        return (
            (emailDataToBeEdited.message === undefined) || Boolean(emailDataToBeEdited && emailDataToBeEdited.message.trim() === "")
        )
    }

    const handleTagClick = (tag: any, mergeTagRes: any) => {
        if (inputRef.current) {
            const input = inputRef.current;
            const start = input.selectionStart;
            const end = input.selectionEnd;
            const textBefore = input.value.substring(0, start);
            const textAfter = input.value.substring(end, input.value.length);


            updateMergeTagsByResourceKey({
                ...mergeTagRes,
                randomID: topActionsDetails.randomID,
            })

            setEmailDataToBeEdited({
                ...emailDataToBeEdited,
                message: textBefore + tag + textAfter,
            })

            // Set the cursor position after the inserted tag
            setTimeout(() => {
                input.selectionStart = input.selectionEnd = start + tag.length;
                input.focus();
            }, 0);
        }
    };

    return (
        <div className={styles.emailEditor}>
            <div className={styles.emailEditor__message}>
                <div className={styles.emailEditor__message__header}>
                    {!EmailSubjectIsNone() &&
                        <div className={styles.emailEditor__message__header__subject}>
                            <label htmlFor="subject">Direct message </label>
                            <input
                                onChange={e => {
                                    setEmailData({
                                        ...emailData,
                                        message: e.target.value
                                    })
                                }}
                                value={emailData.message}
                                type="text"
                                aria-label="message"
                                placeholder='Add message here...'
                                className={`${styles.subject} ${styles.messageEllipsis}`}
                                disabled
                            />
                        </div>
                    }
                </div>
                <button
                    disabled={(workflowData.status === 'active')}
                    className={`${styles.emailEditor__message__btn} ${workflowData.status === 'active' ? `${styles.emailEditor__message__btn__disabled}` : ``}`}
                    onClick={() => setIsOpen(true)}
                >
                    {EmailSubjectIsNone() ? 'Write direct message' : 'Edit direct message'}
                </button>

                <InputEntryDialog
                    dialogID={'ReminderPopUp'}
                    closefn={() => discardChanges()}
                    saveText={'Save'}
                    cancelText={"Discard"}
                    titleText={`${EmailSubjectIsNone() ? 'Write direct message' : 'Edit direct message'}`}
                    saveFn={() => saveChanges()}
                    IsOpen={isOpen}
                    isSavingText={'Adding...'}
                    isSaving={false}
                    isdisabledState={false}
                    maxDialogHeight={window.innerWidth <= 1600 ? 'calc(100vh - 50px)' : 'calc(100vh - 100px)'}
                    inputHeaderStyling={styles.inputHeaderStyling}
                    childrenComponents={
                        <div className={styles.emailEditorNotificationbody}>
                            <div className={styles.resourseSearch}>
                                <div className={styles.recipientHeader}>
                                    <h1>
                                        {`Select sender`}
                                        <small>{" "}*</small>
                                    </h1>
                                </div>

                                <AppSelect
                                    popupStyles={{ minHeight: '100px' }}
                                    value={searchString}
                                    onChangeValue={(e: any) => setSearchString(e.target.value)}
                                    placeholder={`Select or search team member`}
                                    hideDropdownRef={hideDropdownResourceRef}
                                    valueElement={
                                        (emailDataToBeEdited &&
                                            emailDataToBeEdited.executed_resource_name) ?
                                            <div
                                                className={styles.SelectedTeammate__user}
                                                key={emailDataToBeEdited.executed_resource_name.id}
                                            >
                                                <CustomUserComponent
                                                    user={{ user: emailDataToBeEdited.executed_resource_name }}
                                                    group={group}
                                                    rightPlacement={false}
                                                    isHost={true}
                                                    profileImageStyles={styles.SelectedTeammate__user__profileImage}
                                                />
                                            </div>
                                            :
                                            undefined
                                    }
                                    disabled={
                                        (workflowData.status === 'active') ||
                                        (
                                            emailDataToBeEdited &&
                                            emailDataToBeEdited.send_as
                                        )
                                    }
                                    inputClassName={styles.inputAction3}
                                    onRemoveSelectedValue={() => {
                                        setSearchString('')
                                        setEmailDataToBeEdited((prevDetails: any) => ({
                                            ...prevDetails,
                                            executed_resource_name: undefined,
                                            send_as: undefined
                                        }))
                                    }}
                                    XIconstyles={`${emailDataToBeEdited && emailDataToBeEdited.send_as ? styles.XIconSendMessagestyles : ""} ${workflowData.status === 'active' ? styles.hideXIconstyles : ""}`}
                                    inputIconClassName={`${styles.inputIconNameActionResource2} ${emailDataToBeEdited && emailDataToBeEdited.send_as ? styles.inputIconNameActionNone : ""}`}
                                    selectInputWarpperStyles={styles.selectInputWarpperStyles}
                                >
                                    <TeammateSelector
                                        data={teamMembers && teamMembers}
                                        onDataSelected={(data: any) => {
                                            hideDropdownResourceRef.current()

                                            const matchingItem = teamMembers.find((innerItem: any) => innerItem.id === data.id);
                                            setSearchString('')
                                            setEmailDataToBeEdited((prevDetails: any) => ({
                                                ...prevDetails,
                                                send_as: matchingItem.id,
                                                executed_resource_name: matchingItem.user,
                                            }));
                                        }}
                                        searchString={searchString}
                                        containerClassName={styles.ActiontypesDropdown}
                                        elementContainerClass={styles.workflowActionEl}
                                        excludes={
                                            [
                                                emailDataToBeEdited.executed_resource_name &&
                                                emailDataToBeEdited.executed_resource_name.id
                                            ]
                                        }
                                    />
                                </AppSelect>
                            </div>

                            <div className={styles.DirectMessageContent}>
                                <div className={styles.recipientHeader}>
                                    <h1>
                                        {`Message`}
                                        <small>{" "}*</small>
                                    </h1>
                                    {
                                        eventAndActionsMergeTags &&
                                        eventAndActionsMergeTags.length > 0 &&
                                        <WorkflowMergeTags eventAndActionsMergeTags={eventAndActionsMergeTags} handleTagClick={handleTagClick} />
                                    }
                                </div>
                                <textarea
                                    onChange={e => {
                                        setEmailDataToBeEdited({
                                            ...emailDataToBeEdited,
                                            message: e.target.value
                                        })
                                    }}
                                    value={emailDataToBeEdited.message}
                                    aria-label="message"
                                    placeholder='Write direct message here...'
                                    ref={inputRef}
                                />

                            </div>

                        </div>
                    }
                />
            </div>
        </div>
    )
}

const EmailEditor = (
    {
        group,
        topActionsDetails,
        setTopActionsDetails
    }
        :
        {
            group: any,
            topActionsDetails: any
            setTopActionsDetails: any,
        }
) => {
    const resetDraftRef = React.useRef<any>(null);
    const inputRef = React.useRef<any>(null);
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [emailData, setEmailData] = React.useState<any>({
        subject: topActionsDetails && topActionsDetails.subject,
        message: topActionsDetails && topActionsDetails.message,
        message_json: topActionsDetails && topActionsDetails.message_json,
    })
    const [emailDataToBeEdited, setEmailDataToBeEdited] = React.useState<any>(emailData);

    useEffect(() => {
        setEmailData({
            subject: topActionsDetails && topActionsDetails.subject,
            message: topActionsDetails && topActionsDetails.message,
            message_json: topActionsDetails && topActionsDetails.message_json,
        })

    }, [
        topActionsDetails && topActionsDetails.subject,
        topActionsDetails && topActionsDetails.message,
        topActionsDetails && topActionsDetails.message_json,
    ])

    const {
        workflowData,
        eventAndActionsMergeTags,
        saveMergetagsUsed,
        updateMergeTagsWhenDeleteOnString,
        updateMergeTagsByResourceKey
    } = React.useContext(WorkflowCreationContext);
    const [fullScreen, setFullScreen] = React.useState<boolean>(false);

    const discardChanges = () => {
        setIsOpen(false);
        setEmailDataToBeEdited(emailData);
        setFullScreen(false)
    }

    const saveChanges = () => {
        if ((emailDataToBeEdited.subject === undefined) || Boolean(emailDataToBeEdited && emailDataToBeEdited.subject.trim() === "")) {
            toast("Email subject is required.", {
                type: 'error',
                autoClose: 3000,
                position: "top-center",
                hideProgressBar: true,
                theme: "light"
            });
            return;
        }

        if ((emailDataToBeEdited.message === undefined) || Boolean((miscUtils.stripHTML(emailDataToBeEdited.message) as string).trim() === '')) {
            toast("Email body content is required.", {
                type: 'error',
                autoClose: 3000,
                position: "top-center",
                hideProgressBar: true,
                theme: "light"
            });
            return;
        }

        setIsOpen(false);
        setTopActionsDetails((prevDetails: any) => ({
            ...prevDetails,
            active: true,
            'executed_resource_name': emailDataToBeEdited.subject,
            'subject': emailDataToBeEdited.subject,
            'message': emailDataToBeEdited.message,
            'message_json': emailDataToBeEdited.message_json,
            action_details: {
                'subject': emailDataToBeEdited.subject,
                'message': emailDataToBeEdited.message,
                'message_json': emailDataToBeEdited.message_json,
            }
        }));
        saveMergetagsUsed()
        if (emailDataToBeEdited) {
            setTimeout(() => {
                updateMergeTagsWhenDeleteOnString(`${emailDataToBeEdited.subject} ${miscUtils.stripHTML(emailDataToBeEdited.message)}`, topActionsDetails.randomID)
            }, 1000)
        }

        setEmailData(emailDataToBeEdited);
        toast("Email edited successfully.", {
            type: 'success',
            autoClose: 2000,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
        });
    }

    const EmailSubjectIsNone = () => {
        return (
            (emailDataToBeEdited.subject === undefined) || Boolean(emailDataToBeEdited && emailDataToBeEdited.subject.trim() === "")
        )
    }

    const previewEmail = () => {
        AdminMessagingService.getInstance()
            .previewWorkflowEmailTask(group.id,
                {
                    data: {
                        subject: emailDataToBeEdited.subject,
                        message: emailDataToBeEdited.message,
                    }
                }
            )
            .then((response: any) => {
                toast("Email test sent successfully.", {
                    type: 'success',
                    autoClose: 2000,
                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                });
            }).catch((error: any) => {
                console.error(error);
            }).finally(() => {

            })
    }

    const updateTempMergeTagResource = (tag: any, mergeTagRes: any) => {
        updateMergeTagsByResourceKey({
            ...mergeTagRes,
            randomID: topActionsDetails.randomID,
        })

    }

    const handleTagClick = (tag: any, mergeTagRes: any) => {
        if (inputRef.current) {
            const input = inputRef.current;
            const start = input.selectionStart;
            const end = input.selectionEnd;
            const textBefore = input.value.substring(0, start);
            const textAfter = input.value.substring(end, input.value.length);
            setEmailDataToBeEdited({
                ...emailDataToBeEdited,
                subject: textBefore + tag + textAfter
            })

            updateMergeTagsByResourceKey({
                ...mergeTagRes,
                randomID: topActionsDetails.randomID,
            })

            // Set the cursor position after the inserted tag
            setTimeout(() => {
                input.selectionStart = input.selectionEnd = start + tag.length;
                input.focus();
            }, 0);
        }
    };

    return (
        <div className={styles.emailEditor}>
            <div className={styles.emailEditor__message}>
                <div className={styles.emailEditor__message__header}>
                    {
                        !EmailSubjectIsNone() &&
                        <div className={styles.emailEditor__message__header__subject}>
                            <label htmlFor="subject">Email Subject</label>
                            <input
                                onChange={e => {
                                    setEmailData({
                                        ...emailData,
                                        subject: e.target.value
                                    })
                                }}
                                value={emailData.subject}
                                type="text"
                                aria-label="Subject"
                                placeholder='Add email subject here...'
                                className={styles.subject}
                                maxLength={100}
                                disabled
                            />

                        </div>
                    }
                </div>
                <button
                    disabled={(workflowData.status === 'active')}
                    // className={styles.emailEditor__message__btn}
                    className={`${styles.emailEditor__message__btn} ${workflowData.status === 'active' ? `${styles.emailEditor__message__btn__disabled}` : ``}`}

                    onClick={() => setIsOpen(true)}
                >
                    {EmailSubjectIsNone() ? 'Write email content' : 'Edit email content'}
                </button>

                <InputEntryDialog
                    dialogID={'ReminderPopUp'}
                    closefn={() => discardChanges()}
                    saveText={'Save'}
                    cancelText={"Discard"}
                    titleText={`${EmailSubjectIsNone() ? 'Write email content' : 'Edit email content'}`}
                    saveFn={() => saveChanges()}
                    IsOpen={isOpen}
                    isSavingText={'Adding...'}
                    isSaving={false}
                    isdisabledState={false}
                    inputHeaderStyling={styles.inputHeaderStyling}
                    DialogWidth={fullScreen && window.innerWidth > 767 ? '100vw' : undefined}
                    fullScreenContainer={fullScreen && window.innerWidth > 767 ? styles.fullScreenContainer : ''}
                    childrenComponents={
                        <div style={{ overflow: 'hidden' }}>
                            <div className={styles.recipientHeader}>
                                <h1>
                                    {`Subject`}
                                    <small>{" "}*</small>
                                </h1>
                                {
                                    (emailDataToBeEdited.subject === undefined) ||
                                        Boolean(emailDataToBeEdited && emailDataToBeEdited.subject.trim() === "") ||
                                        (emailDataToBeEdited.message === undefined) ||
                                        Boolean((miscUtils.stripHTML(emailDataToBeEdited.message) as string).trim() === '')
                                        ?
                                        <></>
                                        :
                                        <span className={styles.email_preview_email} onClick={() => previewEmail()}>
                                            Send test
                                        </span>
                                }
                            </div>

                            <div className={styles.EmailInputContainer}>
                                <input
                                    onChange={e => {
                                        setEmailDataToBeEdited({
                                            ...emailDataToBeEdited,
                                            subject: e.target.value
                                        })
                                    }}
                                    value={emailDataToBeEdited.subject}
                                    type="text"
                                    aria-label="Subject"
                                    placeholder='Add email subject here...'
                                    className={styles.subject}
                                    maxLength={100}
                                    ref={inputRef}
                                />

                                {
                                    eventAndActionsMergeTags && eventAndActionsMergeTags.length > 0 &&
                                    <WorkflowMergeTags
                                        eventAndActionsMergeTags={eventAndActionsMergeTags}
                                        handleTagClick={handleTagClick}
                                    />
                                }

                            </div>

                            <div className={styles.recipientHeader}>
                                <h1>
                                    {`Content`}
                                    <small>{" "}*</small>
                                </h1>
                            </div>
                            <div className={styles.message}>
                                {
                                    window.innerWidth > 767 &&
                                    <div
                                        onClick={() => setFullScreen(!fullScreen)}
                                        className={styles.MaximizeIcon}
                                    >
                                        {fullScreen ? <MinimizeIcon /> : <MaximizeIcon />}
                                    </div>
                                }
                                <PostableDraft
                                    group={group}
                                    resetDraftRef={resetDraftRef}
                                    onStateChange={(htmlValue: string, jsonValue: string) => {
                                        setEmailDataToBeEdited((prevState: any) => ({
                                            ...prevState,
                                            message: htmlValue,
                                            message_json: jsonValue
                                        }))
                                    }}
                                    editMode={true}
                                    draftJSON={emailDataToBeEdited.message_json}
                                    postDescription={emailDataToBeEdited.message}
                                    placeholder="Add email message here..."
                                    disableTaggingonAutomations={true}
                                    hideTitleInput={true}
                                    hideCoverImageInput={true}
                                    editorContainerClasses={styles.draftEditorContainer}
                                    gifContainerClass={styles.postGIFContainer}
                                    gifGridClass={styles.gifGridClass}
                                    workflowMergeTags={eventAndActionsMergeTags}
                                    updateworkflowMergeTags={updateTempMergeTagResource}
                                />

                            </div>
                        </div>
                    }
                />


            </div>
        </div>
    )
}

const EmailNotificationEditor = (
    {
        group,
        topActionsDetails,
        setTopActionsDetails
    }
        :
        {
            group: any,
            topActionsDetails: any
            setTopActionsDetails: any,
        }
) => {

    const MAX_EMAILS = 8;
    const resetDraftRef = React.useRef<any>(null);
    const inputRef = React.useRef<any>(null);
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [fullScreen, setFullScreen] = React.useState<boolean>(false);
    const [emailData, setEmailData] = React.useState<any>({
        recipient_emails: (topActionsDetails && topActionsDetails.recipient_emails) || [],
        subject: topActionsDetails && topActionsDetails.subject,
        message: topActionsDetails && topActionsDetails.message,
        message_json: topActionsDetails && topActionsDetails.message_json,
        executed_resource_name: topActionsDetails && topActionsDetails.executed_resource_name,
    })

    const {
        workflowData,
        eventAndActionsMergeTags,
        saveMergetagsUsed,
        updateMergeTagsWhenDeleteOnString,
        updateMergeTagsByResourceKey
    } = React.useContext(WorkflowCreationContext);

    const [emailDataToBeEdited, setEmailDataToBeEdited] = React.useState<any>(emailData);
    const [tags, setTags] = React.useState<any>(emailData && emailData.recipient_emails);

    useEffect(() => {
        setEmailData({
            subject: topActionsDetails && topActionsDetails.subject,
            message: topActionsDetails && topActionsDetails.message,
            message_json: topActionsDetails && topActionsDetails.message_json,
            recipient_emails: (topActionsDetails && topActionsDetails.recipient_emails) || [],
            executed_resource_name: topActionsDetails && topActionsDetails.executed_resource_name,
        })

    }, [
        topActionsDetails && topActionsDetails.subject,
        topActionsDetails && topActionsDetails.message,
        topActionsDetails && topActionsDetails.message_json,
        topActionsDetails && topActionsDetails.recipient_emails,
        topActionsDetails && topActionsDetails.executed_resource_name,
    ])

    const discardChanges = () => {
        setIsOpen(false);
        setEmailDataToBeEdited(emailData);
        setTags(emailData && emailData.recipient_emails);
        setFullScreen(false)
    }


    const saveChanges = () => {
        if (
            (emailDataToBeEdited.recipient_emails === undefined) ||
            Boolean(emailDataToBeEdited && emailDataToBeEdited.recipient_emails.length === 0)) {
            toast("Email recipient is required.", {
                type: 'error',
                autoClose: 3000,
                position: "top-center",
                hideProgressBar: true,
                theme: "light"
            });
            return;
        }

        if ((emailDataToBeEdited.subject === undefined) || Boolean(emailDataToBeEdited && emailDataToBeEdited.subject.trim() === "")) {
            toast("Email subject is required.", {
                type: 'error',
                autoClose: 3000,
                position: "top-center",
                hideProgressBar: true,
                theme: "light"
            });
            return;
        }

        if ((emailDataToBeEdited.message === undefined) || Boolean((miscUtils.stripHTML(emailDataToBeEdited.message) as string).trim() === '')) {
            toast("Email body content is required.", {
                type: 'error',
                autoClose: 3000,
                position: "top-center",
                hideProgressBar: true,
                theme: "light"
            });
            return;
        }

        setIsOpen(false);
        setTopActionsDetails((prevDetails: any) => ({
            ...prevDetails,
            active: true,
            'executed_resource_name': emailDataToBeEdited.subject,
            'subject': emailDataToBeEdited.subject,
            'message': emailDataToBeEdited.message,
            'message_json': emailDataToBeEdited.message_json,
            recipient_emails: [...emailDataToBeEdited.recipient_emails],
            action_details: {
                'subject': emailDataToBeEdited.subject,
                'message': emailDataToBeEdited.message,
                'message_json': emailDataToBeEdited.message_json,
                'recipient_emails': [...emailDataToBeEdited.recipient_emails],
            }
        }));

        setEmailData(emailDataToBeEdited);

        saveMergetagsUsed()

        setTimeout(() => {
            updateMergeTagsWhenDeleteOnString(
                `${emailDataToBeEdited.subject} ${miscUtils.stripHTML(emailDataToBeEdited.message)}`, topActionsDetails.randomID
            )
        }, 1000)

        toast("Email edited successfully.", {
            type: 'success',
            autoClose: 2000,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
        });
    }

    const EmailSubjectIsNone = () => {
        return (
            (emailDataToBeEdited.subject === undefined) || Boolean(emailDataToBeEdited && emailDataToBeEdited.subject.trim() === "")
        )
    }

    const previewEmail = () => {
        AdminMessagingService.getInstance()
            .previewWorkflowEmailTask(group.id,
                {
                    data: {
                        subject: emailDataToBeEdited.subject,
                        message: emailDataToBeEdited.message,
                    }
                }
            )
            .then((response: any) => {
                toast("Email test sent successfully.", {
                    type: 'success',
                    autoClose: 2000,
                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                });
            }).catch((error: any) => {
                console.error(error);
            }).finally(() => {

            })
    }

    const handleAddTag = (newTag: string) => {
        if (newTag && !tags.includes(newTag) && tags.length < MAX_EMAILS) {
            setTags([...tags, newTag]);
        }
    };

    // Function to remove tag from array
    const handleRemoveTag = (tag: string) => {
        setTags((prevTags: any) => prevTags.filter((t: any) => t !== tag));
        setEmailDataToBeEdited((prevDetails: any) => ({
            ...prevDetails,
            recipient_emails: prevDetails.recipient_emails.filter((ids: any) => ids !== tag),
        }));

    };

    const handleSubmit = (emailTag: any) => {
        setEmailDataToBeEdited((prevDetails: any) => ({
            ...prevDetails,
            recipient_emails: [...prevDetails.recipient_emails, emailTag],
        }));
    };

    const handleTagClick = (tag: any, mergeTagRes: any) => {
        if (inputRef.current) {
            const input = inputRef.current;
            const start = input.selectionStart;
            const end = input.selectionEnd;
            const textBefore = input.value.substring(0, start);
            const textAfter = input.value.substring(end, input.value.length);

            setEmailDataToBeEdited({
                ...emailDataToBeEdited,
                subject: textBefore + tag + textAfter,
            })

            updateMergeTagsByResourceKey({
                ...mergeTagRes,
                randomID: topActionsDetails.randomID,
            })

            // Set the cursor position after the inserted tag
            setTimeout(() => {
                input.selectionStart = input.selectionEnd = start + tag.length;
                input.focus();
            }, 0);

        }
    };

    const updateTempMergeTagResource = (tag: any, mergeTagRes: any) => {
        updateMergeTagsByResourceKey({
            ...mergeTagRes,
            randomID: topActionsDetails.randomID,
        })

    }

    return (
        <div className={styles.emailEditor}>

            <div className={styles.emailEditor__message}>
                <div className={styles.emailEditor__message__header}>
                    {
                        !EmailSubjectIsNone() &&
                        <div className={styles.emailEditor__message__header__subject}>
                            <label htmlFor="subject">Email Subject</label>
                            <input
                                onChange={e => {
                                    setEmailData({
                                        ...emailData,
                                        subject: e.target.value
                                    })
                                }}
                                value={emailData.subject}
                                type="text"
                                aria-label="Subject"
                                placeholder='Add email subject here...'
                                className={styles.subject}
                                maxLength={100}
                                disabled
                            />
                        </div>
                    }
                </div>
                <button
                    disabled={(workflowData.status === 'active')}
                    // className={styles.emailEditor__message__btn}
                    className={`${styles.emailEditor__message__btn} ${workflowData.status === 'active' ? `${styles.emailEditor__message__btn__disabled}` : ``}`}
                    onClick={() => setIsOpen(true)}
                >
                    {EmailSubjectIsNone() ? 'Write email notification' : 'Edit email notification'}
                </button>

                <InputEntryDialog
                    dialogID={'ReminderPopUp'}
                    closefn={() => discardChanges()}
                    saveText={'Save'}
                    cancelText={"Discard"}
                    titleText={`${EmailSubjectIsNone() ? 'Write email notification' : 'Edit email notification'}`}
                    saveFn={() => saveChanges()}
                    IsOpen={isOpen}
                    isSavingText={'Adding...'}
                    isSaving={false}
                    isdisabledState={false}
                    maxDialogHeight={window.innerWidth <= 1600 ? 'calc(100vh - 10px)' : 'calc(100vh - 135px)'}
                    inputHeaderStyling={styles.inputHeaderStyling}
                    DialogWidth={fullScreen && window.innerWidth > 767 ? '100vw' : undefined}
                    fullScreenContainer={fullScreen && window.innerWidth > 767 ? styles.fullScreenContainer : ''}
                    childrenComponents={
                        <div className={styles.emailEditorNotificationbody}>
                            <div className={styles.resourseSearch}>
                                <div className={styles.recipientHeader}>
                                    <h1>
                                        {`To`}
                                        <small>{" "}*</small>
                                    </h1>
                                    {
                                        (emailDataToBeEdited.subject === undefined) ||
                                            Boolean(emailDataToBeEdited && emailDataToBeEdited.subject.trim() === "") ||
                                            (emailDataToBeEdited.message === undefined) ||
                                            Boolean((miscUtils.stripHTML(emailDataToBeEdited.message) as string).trim() === '')
                                            ?
                                            <></>
                                            :
                                            <span className={styles.email_preview} onClick={() => previewEmail()}>
                                                Send test
                                            </span>
                                    }
                                </div>
                            </div>

                            <TagsFields
                                tags={tags}
                                addTag={handleAddTag}
                                removeTag={handleRemoveTag}
                                maxTags={MAX_EMAILS}
                                submitTags={handleSubmit}
                            />

                            <div className={styles.recipientHeader}>
                                <h1>
                                    {`Subject`}
                                    <small>{" "}*</small>
                                </h1>
                            </div>

                            <div className={styles.EmailInputContainer}>
                                <input
                                    onChange={e => {
                                        setEmailDataToBeEdited({
                                            ...emailDataToBeEdited,
                                            subject: e.target.value
                                        })
                                    }}
                                    value={emailDataToBeEdited.subject}
                                    type="text"
                                    aria-label="Subject"
                                    placeholder='Add email subject here...'
                                    className={styles.subjectEmailNotification}
                                    maxLength={100}
                                    ref={inputRef}
                                />

                                {
                                    eventAndActionsMergeTags && eventAndActionsMergeTags.length > 0 &&
                                    <WorkflowMergeTags
                                        eventAndActionsMergeTags={eventAndActionsMergeTags}
                                        handleTagClick={handleTagClick}
                                    />
                                }
                            </div>

                            <div className={styles.recipientHeader}>
                                <h1>
                                    {`Content`}
                                    <small>{" "}*</small>
                                </h1>
                            </div>
                            <div className={styles.SelectedTeammateScroll}>
                                {
                                    window.innerWidth > 767 &&
                                    <div
                                        onClick={() => setFullScreen(!fullScreen)}
                                        className={styles.MaximizeIcon}
                                    >
                                        {fullScreen ? <MinimizeIcon /> : <MaximizeIcon />}
                                    </div>
                                }
                                <PostableDraft
                                    group={group}
                                    resetDraftRef={resetDraftRef}
                                    onStateChange={(htmlValue: string, jsonValue: string) => {
                                        setEmailDataToBeEdited((prevState: any) => ({
                                            ...prevState,
                                            message: htmlValue,
                                            message_json: jsonValue
                                        }))
                                    }}
                                    editMode={true}
                                    draftJSON={emailDataToBeEdited.message_json}
                                    postDescription={emailDataToBeEdited.message}
                                    placeholder="Add email message here..."
                                    disableTaggingonAutomations={true}
                                    hideTitleInput={true}
                                    hideCoverImageInput={true}
                                    containerClasses={styles.draftContainer}
                                    editorContainerClasses={styles.draftEditorContainer}
                                    gifContainerClass={styles.postGIFContainer}
                                    gifGridClass={styles.gifGridClass}
                                    workflowMergeTags={eventAndActionsMergeTags}
                                    updateworkflowMergeTags={updateTempMergeTagResource}
                                />

                            </div>
                        </div>
                    }
                />
            </div>
        </div>
    )
}

const WebHookURLAndBtn = (
    {
        topActionsDetails,
        setTopActionsDetails
    }: {
        topActionsDetails: any
        setTopActionsDetails: any
    }
) => {
    const { group, workflowData, setiSWebHookStatus, webhookTestResults, setWebhookTestResults, workflowEvent } = React.useContext(WorkflowCreationContext);
    const webhookUrl = topActionsDetails && topActionsDetails.endpoint;
    const [url, setUrl] = React.useState<string>(webhookUrl);
    const webhookendpointPresent = workflowData && workflowData.actions_config && workflowData.actions_config.filter(
        (item: any) => item.resource_name === 'webhook').map((item: any) => item.endpoint)[0];

    useEffect(() => {
        setUrl(webhookUrl);
    }, [webhookUrl])

    const saveChanges = () => {
        setTopActionsDetails((prevDetails: any) => ({
            ...prevDetails,
            active: true,
            'executed_resource_name': url,
            'endpoint': url,
            'action_details': {
                'endpoint': url,
            }
        }));
        setWebhookTestResults(undefined)
    }

    useEffect(() => {
        saveChanges()
    }, [url])

    const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/;
    const payload = {
        endpoint: url
    }

    const testWebhook = () => {
        AdminMessagingService.getInstance()
            .testWebhookURL(group && group.id, workflowData && workflowData.id, payload)
            .then((response: any) => {
                toast(`${response.message}`, {
                    type: 'success',
                    autoClose: 2000,
                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                });
                testWebhookResults()
            }).catch((error: any) => {
                console.error(error);
            }).finally(() => {

            })
    }

    const testWebhookResults = () => {
        AdminMessagingService.getInstance()
            .testWebhookURLResults(group && group.id, workflowData && workflowData.id, payload)
            .then((response: any) => {
                setWebhookTestResults(response.data && response.data)
                //TODO

                // if (response.data && response.data.status_code === 200) {
                // saveChanges()
                // }
            }).catch((error: any) => {
                console.error(error);
            }).finally(() => {
            })
    }

    return (
        <div className={styles.webhookURLAndBtn}>
            <div className={styles.webhookURL}>
                <label>Webhook URL <small>{" "}*</small></label>
                <input
                    type="url"
                    placeholder="Enter webhook URL"
                    value={url}
                    onChange={e => setUrl(e.target.value)}
                    disabled={workflowData.status === 'active'}
                    // autoComplete='off'
                    name='webhook'
                />
            </div>
            {
                workflowData &&
                    webhookendpointPresent &&
                    workflowEvent &&
                    (
                        (
                            workflowEvent.event_resource_details &&
                            workflowEvent.event_resource_details.event_resource_id
                        )
                        ||
                        workflowEvent.slug === "member/create"
                    ) &&
                    (webhookendpointPresent === url)
                    ?
                    <div className={styles.webhookBtn}>
                        <button
                            onClick={testWebhook}
                            disabled={workflowData.status === 'active' || urlPattern.test(url) === false}
                            className={`${(workflowData.status === 'active' || (urlPattern.test(url) === false)) ? styles.webhookBtn__btn__disabled : ''}`}>
                            Test webhook
                        </button>
                    </div>
                    :
                    null
            }
            {
                webhookTestResults &&
                webhookTestResults.status_code === 200 &&
                <div className={styles.webhookBtn__status}>
                    <div className={styles.webhookBtn__status__header}>
                        <div className={styles.webhookBtn__status__icon} >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="4.5"
                                stroke="currentColor"
                                className="completed-button-img-white">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                            </svg>
                        </div>
                        <div className={styles.webhookBtn__status__header__body}>
                            <h1>Webhook connected successfully</h1>
                            <span onClick={() => setiSWebHookStatus(true)}>Show test data output</span>
                        </div>
                    </div>
                </div>
            }

            {(
                webhookTestResults === null ||
                (
                    webhookTestResults &&
                    (
                        webhookTestResults.status_code !== 200 ||
                        !webhookTestResults.status_code
                    )
                )) &&
                <div className={styles.webhookBtn__status}>
                    <div className={styles.webhookBtn__status__header}>
                        <div className={styles.webhookBtn__status__icon1} >
                            <DangerIcon />
                        </div>
                        <div className={styles.webhookBtn__status__header__body}>
                            <h1>Webhook test failed</h1>
                            <span onClick={() => setiSWebHookStatus(true)}>Show test data output</span>

                        </div>
                    </div>
                </div>
            }

        </div>
    )
}

const WebHookStatus = ({ }: {}) => {
    const { iSWebHookStatus, setiSWebHookStatus, webhookTestResults } = React.useContext(WorkflowCreationContext);

    const data = webhookTestResults && webhookTestResults.payload && webhookTestResults.payload.data

    return (
        <ReactModal
            id='webhookStatus'
            isOpen={iSWebHookStatus}
            className={`${styles.webhookStatus}`}
            style={{
                content: {
                    width: "546px",
                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 99999,
                }
            }}
        >
            <div className={styles.webhookStatus__header}>
                <h1>Webhook payload</h1>
                <span onClick={() => setiSWebHookStatus(false)}>
                    <CloseIcon />
                </span>
            </div>

            <div className={styles.webhookStatus__status}>
                <pre className={styles.webhookStatus__status__payload}>
                    {JSON.stringify(
                        data,
                        null,
                        2
                    )}
                </pre>
            </div>
        </ReactModal>

    )
}


export const WorkflowMergeTags = (
    {
        eventAndActionsMergeTags,
        handleTagClick,
        menuIconStyles,
    }:
        {
            eventAndActionsMergeTags: any,
            handleTagClick: any
            menuIconStyles?: any
        }
) => {

    const [visibleKey, setVisibleKey] = React.useState<string | null>(null);
    const closeFlexyPopOnMeRef = React.useRef<any>(null);

    const groupedTags = eventAndActionsMergeTags.reduce((acc: any, tag: any) => {
        // For each tag, check if the group already exists
        const existingGroup = acc.find((item: any) => item.key === tag.key);

        // If the group exists, add the dataItems with updated tags
        if (existingGroup) {
            existingGroup.dataItems.push({
                dataItemsName: tag.data.dataItemsName,
                dataItemsId: tag.data.dataItemsId,
                dataItems: tag.data.dataItems.map((item: any, index: number) => ({
                    ...item,
                    tag: item.tag,  // Append current index to tag
                }))
            });
        } else {
            // If the group doesn't exist, create a new group with the initial dataItems
            acc.push({
                key: tag.key,
                dataItems: [{
                    dataItemsName: tag.data.dataItemsName,
                    dataItemsId: tag.data.dataItemsId,
                    dataItems: tag.data.dataItems.map((item: any, index: number) => ({
                        ...item,
                        tag: item.tag,  // Append current index to tag
                    }))
                }]
            });
        }

        return acc;
    }, []);

    const [visibleSubKeys, setVisibleSubKeys] = React.useState<string[]>(() => {
        return groupedTags.flatMap((tag: any) =>
            tag.dataItems.map((data: any) => data.dataItemsName)
        );
    });

    const toggleDropdown = (key: string) => {
        setVisibleKey(prevKey => (prevKey === key ? null : key));
    };

    const tagRemove = (tag: string, tagIndex: number) => {
        const newTag = tag.replace(/[{}]/g, "")
        if (newTag === 'full_name' || newTag === 'email' || newTag === 'first_name' || newTag === 'last_name' || newTag === "phone_number") {
            return tag
        }
        return `{{${newTag}${'_'}${tagIndex}}}`
    }


    const toggleSubDropdown = (subKey: string) => {
        setVisibleSubKeys(prevSubKeys => {
            if (prevSubKeys.includes(subKey)) {
                // Close the subkey by removing it from the array
                return prevSubKeys.filter(key => key !== subKey);
            } else {
                // Open the subkey by adding it to the array
                return [...prevSubKeys, subKey];
            }
        });
    };


    return (
        <FlexyPopOnMe
            closePopupRef={closeFlexyPopOnMeRef}
            placement='bottom-end'
            hideTippyArrow
            component={
                <div className={styles.mergeTagsPopUp}>
                    {groupedTags && groupedTags.length > 0 ? (
                        groupedTags.filter((t: any) => t.dataItems && t.dataItems[0].dataItems.length > 0).map((tag: any, globalindex: number) => {
                            if (visibleKey === null || visibleKey === tag.key) {
                                return (
                                    <div key={globalindex}>
                                        <div
                                            onClick={() => toggleDropdown(tag.key)}
                                            className={`${styles.mergeTagContentKey} ${visibleKey === tag.key ? styles.mergeTagContentKey__selected : ""}`}
                                        >
                                            {
                                                tag.key === 'landing-page-leadable'
                                                    ?
                                                    <h1>Landing page forms</h1>
                                                    :
                                                    <h1>{tag.key && tag.key.replace(/[_-]/g, ' ')}</h1>
                                            }
                                            <div className={styles.mergeTagContentKey__icon}>
                                                <ArrowUpIcon />
                                            </div>
                                        </div>

                                        {visibleKey === tag.key && (
                                            <div className={styles.mergeTagContentKey__iconLeft}>
                                                <div
                                                    onClick={() => toggleDropdown(tag.key)}
                                                    className={styles.mergeTagContentKey__iconLeft__icon}
                                                >
                                                    <ArrowUpIcon />
                                                </div>
                                                <span>Merge tags</span>
                                            </div>
                                        )}

                                        {visibleKey === tag.key && (
                                            <>
                                                {tag.dataItems.length > 0 && tag.dataItems.map((data: any, subIndex: number) => (
                                                    <div key={subIndex}>
                                                        <div
                                                            onClick={() => toggleSubDropdown(data.dataItemsName)}
                                                            className={`${styles.dataItemsName} ${visibleSubKeys.includes(data.dataItemsName) ? styles.dataItemsName__selected : ''}`}
                                                        >
                                                            <span>{data.dataItemsName}</span>
                                                            <div className={styles.dataItemsName__icon}>
                                                                {visibleSubKeys.length > 0 && visibleSubKeys.includes(data.dataItemsName) ? (
                                                                    <ArrowUpIcon />
                                                                ) : (
                                                                    <ArrowDownIcon />
                                                                )}
                                                            </div>
                                                        </div>

                                                        {visibleSubKeys.includes(data.dataItemsName) && (
                                                            <>
                                                                {data.dataItems.length > 0 && data.dataItems.map((value: any, valueIndex: number) => {
                                                                    const _newtag = tagRemove(value.tag, subIndex + 1);
                                                                    return (
                                                                        <div
                                                                            key={valueIndex}
                                                                            className={styles.mergeTagContent}
                                                                            onClick={() => {
                                                                                const _key = tag.key === 'community' ? 'plan' : tag.key;
                                                                                handleTagClick(_newtag, { key: _key, data: data, tags: [_newtag] });

                                                                                if (closeFlexyPopOnMeRef.current) {
                                                                                    closeFlexyPopOnMeRef.current();
                                                                                    setVisibleKey(null);
                                                                                    // setVisibleSubKeys([]);
                                                                                }
                                                                            }}
                                                                        >

                                                                            <h1 className={styles.message_h1}>{value.description}</h1>
                                                                            <span className={styles.message_span}>{_newtag}</span>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </>
                                                        )}
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                    </div>
                                );
                            }
                        })
                    ) : (
                        <div>No tags available</div>
                    )}
                </div>
            }
        >
            <div className={`${styles.menuIcon} ${menuIconStyles ? menuIconStyles : ''}`}>
                <MenuIcon />
            </div>
        </FlexyPopOnMe>
    )
}


export default WorkflowCreation2